<template>
  <div class="animated fadeIn page-shell">
    <div class="page-main">
      <HeaderPadrao class="mb-2" icon="fa fa-shopping-cart" titulo="GESTÃO DE COMPRAS">
        <template #subtitulo>
          <i class="fa fa-tag mr-1 text-info"></i>
          Pedido: <strong class="text-white">{{ compra.ID || 'Novo Pedido' }}</strong>
          <span class="mx-2">•</span>
          <i class="fa fa-user mr-1 text-info"></i>
          Fornecedor: <strong class="text-white">{{ cliente.CODIGO }} - {{ cliente.NOME }}</strong>
        </template>

        <template #acoes>
          <b-button v-if="habilitarBotaoFinalizar" variant="link" class="btn-glass btn-glass-success" @click="finalizar()">
            <i class="fa fa-check mr-1"></i> FINALIZAR <small>F11</small>
          </b-button>

          <b-button v-if="habilitarBotaoReabrir" variant="link" class="btn-glass btn-glass-warning" @click="abrirModalReabrir()">
            <i class="fa fa-unlock mr-1"></i> REABRIR
          </b-button>

          <b-button v-if="habilitarBotaoReabrir" variant="link" class="btn-glass btn-glass-info" @click="imprimirEspelho()">
            <i class="fa fa-print mr-1"></i> ESPELHO
          </b-button>

          <b-button v-if="habilitaBotaoGravar" variant="link" class="btn-glass btn-glass-primary" @click="post()">
            <i class="fa fa-save mr-1"></i> GRAVAR <small>F10</small>
          </b-button>

          <b-button v-if="habilitaBotaoEditar" variant="link" class="btn-glass btn-glass-primary" @click="edit()">
            <i class="fa fa-save mr-1"></i> GRAVAR ALTERAÇÕES <small>F10</small>
          </b-button>

          <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm" @click.stop.prevent="voltar()">
            <i class="fa fa-arrow-left mr-1"></i> Voltar
          </b-button>
        </template>
      </HeaderPadrao>

      <!-- Main Summary Bar -->
      <b-row class="mb-4 px-1">
        <b-col md="2">
          <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top border-info" style="border-top-width: 3px !important;">
            <small class="modal-label-premium d-block text-muted">Volumes</small>
            <h4 class="mb-0 font-weight-bold text-dark">{{totalPecas ? totalPecas : 0}}</h4>
          </div>
        </b-col>
        <b-col md="2">
          <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top border-primary" style="border-top-width: 3px !important;">
            <small class="modal-label-premium d-block text-muted">Lançados</small>
            <h5 class="mb-0 font-weight-bold text-dark">{{Number(compra.VL_CIF || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</h5>
          </div>
        </b-col>
        <b-col md="2">
          <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top border-warning" style="border-top-width: 3px !important;">
            <small class="modal-label-premium d-block text-muted">Total FOB</small>
            <h4 class="mb-0 font-weight-bold text-dark">{{Number(compra.VL_FOB || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</h4>
          </div>
        </b-col>
        <b-col md="2">
          <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top border-secondary" style="border-top-width: 3px !important;">
            <small class="modal-label-premium d-block text-muted">Despesas</small>
            <h4 class="mb-0 font-weight-bold text-dark">{{Number(compra.VL_TOTAL_DESPESA || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</h4>
          </div>
        </b-col>
        <b-col md="4">
          <div class="stat-item bg-primary p-3 rounded shadow-sm text-center transition-hover h-100 text-white shadow-lg border-0" style="background: linear-gradient(135deg, #20a8d8 0%, #1985ac 100%) !important;">
            <small class="modal-label-premium d-block text-white opacity-75">VALOR TOTAL DA COMPRA</small>
            <h3 class="mb-0 font-weight-bold letter-spacing-1">{{Number(compra.VL_PEDIDO || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</h3>
          </div>
        </b-col>
      </b-row>

      <b-row class="p-0 align-items-stretch ml-2 mr-2">
        <b-col sm="7" class="p-0 d-flex pr-2">
          <b-card class="flex-fill border-0 shadow-sm" body-class="p-4">
            <template #header>
              <div class="d-flex align-items-center justify-content-between w-100">
                <div class="d-flex align-items-center">
                  <div class="bg-primary text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                    <i class="fa fa-user-circle"></i>
                  </div>
                  <div>
                    <h6 class="mb-0 font-weight-bold">Dados da Identificação</h6>
                    <small class="text-muted">Informações básicas do pedido e fornecedor</small>
                  </div>
                </div>
                <div class="d-flex flex-wrap gap-1 justify-content-end">
                  <b-badge :variant="colorirOP_FINANCEIRO(compra.OP_FINANCEIRO)" pill class="py-2 font-weight-bold">
                      {{traduzOP_FINANCEIRO(compra.OP_FINANCEIRO)}}
                  </b-badge>
                  <b-badge :variant="colorirOP_CARGA_XML(compra.OP_CARGA_XML)" pill class="py-2 ml-1 font-weight-bold">
                      {{traduzOP_CARGA_XML(compra.OP_CARGA_XML)}}
                  </b-badge>
                  <b-badge :variant="colorirOP_XML(compra.OP_XML)" pill class="py-2 ml-1 font-weight-bold">
                      {{traduzOP_XML(compra.OP_XML)}}
                  </b-badge>
                  <b-badge :variant="colorirOP_STATUS(compra.OP_STATUS)" pill class="py-2 ml-1 font-weight-bold">
                      {{traduzOP_STATUS(compra.OP_STATUS)}}
                  </b-badge>
                </div>
              </div>
            </template>

            <b-row class="mb-3">
              <b-col sm="2">
                <label class="modal-label-premium">Nº do Pedido</label>
                <b-form-input 
                  type="text" 
                  id="ID" 
                  class="rounded-pill shadow-xs bg-light"
                  :disabled="true" 
                  placeholder="Automático" 
                  v-model="compra.ID"
                />
              </b-col>
              <b-col sm="4">
                <label class="modal-label-premium">Data Cadastro</label>
                <cec-input-data
                  id="ob_dtDocumento" 
                  v-model="compra.DT_CADASTRO"
                  :disabled="true" 
                  class="shadow-xs"
                  input-class="rounded-pill"
                  :state="!!compra.DT_CADASTRO"
                />
              </b-col>
              <b-col sm="3">
                <label class="modal-label-premium">Núm. Externo</label>
                <b-form-input 
                  type="text" 
                  id="edNUMERO_EXTERNO" 
                  class="rounded-pill shadow-xs"
                  v-model="compra.NUMERO_EXTERNO"
                  :disabled="compraFechada"
                  :state="!!compra.NUMERO_EXTERNO"
                  placeholder="N. Identificador"
                />
              </b-col>
              <b-col sm="3">
                <label class="modal-label-premium">Interesse</label>
                <b-form-select 
                  :disabled="compraFechada || tabelaItens.items.length > 0" 
                  v-model="compra.OP_TIPO_PEDIDO"
                  :state="!!compra.OP_TIPO_PEDIDO"  
                  :options="optionsOP_TIPO_PEDIDO"
                  class="rounded-pill shadow-xs"
                />
              </b-col>
              
              
              
            </b-row>

            <b-row class="mb-3">
              <b-col sm="12">
                <cliente-pesquisa 
                  @retornaId="compra.FORNECEDOR_ID = $event"
                  :idInicial="compra.FORNECEDOR_ID"
                  @retornaCGC="cliente.CGC = $event"
                  @retornaNOME="cliente.NOME = $event"
                  @retornaRAZAO="cliente.RAZAOSOCIAL = $event"
                  :classe-required="true"
                  :desabilitarInput="compraFechada"
                  label="Fornecedor"
                  idModal="modalCliente"
                  id="edFORNECEDOR_ID"
                  ref="edFORNECEDOR_ID"
                  place="Informe o Fornecedor"
                  labelBotao=""
                  :arredondado="true"
                />
              </b-col>
            </b-row>

            <b-row class="mb-3">
              <b-col sm="6">
                
              </b-col>
              
            </b-row>

            <b-row class="mb-3">
              <b-col sm="6">
                <label class="modal-label-premium">Comprador</label>
                <funcionario-dropdown 
                  v-model="compra.COMPRADOR_ID"
                  :disabled="compraFechada"
                  :state="!!compra.COMPRADOR_ID"
                  placeholder="Informe o Comprador"
                  input-class="rounded-pill shadow-xs"
                />
              </b-col>
              <b-col sm="6">
                <label class="modal-label-premium">Transportadora</label>
                <transportadora-drop-down
                  v-model="compra.TRANSPORTADORA_ID"
                  :disabled="compraFechada"
                  :state="!!compra.TRANSPORTADORA_ID"
                  placeholder="Informe a Transportadora"
                  input-class="rounded-pill shadow-xs"
                />
              </b-col>
            </b-row>

            <b-row class="mb-3">
              <b-col sm="6">
                <label class="modal-label-premium">Incoterms</label>
                <b-form-select 
                  :disabled="compraFechada" 
                  v-model="compra.OP_INCOTERMS"
                  :state="!!compra.OP_INCOTERMS"  
                  :options="optionsOP_INCOTERMS"
                  class="rounded-pill shadow-xs"
                />
              </b-col>
              <b-col sm="6">
                <label class="modal-label-premium">Centro Estoque</label>
                <centro-estoque-drop-down 
                  v-if="mostrarDropdownIndustria"
                  v-model="compra.CENTRO_ESTOQUE_ID"
                  :disabled="compraFechada || compra.OP_GERA_ESTOQUE === 'N'"
                  input-class="rounded-pill shadow-xs"
                />
                <centro-estoque-almoxarifado-drop-down 
                  v-else-if="mostrarDropdownAlmoxarifado"
                  v-model="compra.CENTRO_ESTOQUE_ID"
                  :disabled="compraFechada || compra.OP_GERA_ESTOQUE === 'N'"
                  input-class="rounded-pill shadow-xs"
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="6">
                <label class="modal-label-premium">Empresa</label>
                <empresa-drop-down 
                  v-model="compra.EMPRESA_ID"
                  :disabled="compraFechada"
                  :state="!!compra.EMPRESA_ID"
                  input-class="rounded-pill shadow-xs"
                />
              </b-col>
              <b-col sm="3">
                <label class="modal-label-premium">Placa</label>
                <b-form-input 
                  type="text" 
                  id="edPLACA" 
                  v-model="compra.PLACA"
                  :disabled="compraFechada"
                  maxlength="7"
                  :state="!!compra.PLACA"
                  placeholder="PLACA"
                  class="rounded-pill shadow-xs"
                />
              </b-col>
              <b-col sm="3">
                
              </b-col>
            </b-row>
          </b-card>
        </b-col>

        <b-col sm="5" class="p-0 d-flex pl-2">
          <div class="flex-fill d-flex flex-column">
            

            <!-- Card Nota Fiscal -->
            <b-card class="flex-fill border-0 shadow-sm" body-class="p-4">
              <template #header>
                <div class="d-flex align-items-center justify-content-between w-100">
                  <div class="d-flex align-items-center">
                    <div class="bg-info text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                      <i class="fa fa-file-text-o"></i>
                    </div>
                    <div>
                      <h6 class="mb-0 font-weight-bold">Nota Fiscal</h6>
                      <small class="text-muted">Vínculo e conciliação de XML</small>
                    </div>
                  </div>
                  <b-form-checkbox 
                    id="cbOP_CONCLUIR_SEM_NOTA"
                    switch
                    :disabled="!habilitarConcluirSemNota" 
                    v-model="compra.OP_CONCLUIR_SEM_NOTA"
                    value="1"
                    unchecked-value="0"
                    class="m-0"
                  >
                    <small class="font-weight-bold">Sem NF</small>
                  </b-form-checkbox>
                </div>
              </template>

              <b-row class="mb-3">
                <b-col sm="12">
                  <label class="modal-label-premium">Chave NFE</label>
                  <b-form-input 
                    type="text" 
                    id="edOP_XML" 
                    v-model="compra.NOTA_FISCAL"
                    :disabled="compraFechada"
                    placeholder="Chave de acesso da nota"
                    class="rounded-pill shadow-xs"
                  />
                </b-col>
              </b-row>

              <b-row class="mb-3">
                <b-col sm="12">
                  <div class="d-flex flex-wrap gap-2">
                    <b-button variant="soft-info" pill class="flex-fill font-weight-bold shadow-sm mb-2" :disabled="!habilitarBotaoVincularXml" @click.stop.prevent="abrirModalVincularNotaFiscal">
                      <i class="fa fa-link mr-1"></i> Vincular XML
                    </b-button>
                    <b-button variant="soft-danger" pill class="flex-fill font-weight-bold shadow-sm mb-2" :disabled="!habilitarBotaoRemoverXml" @click.stop="desvincularXML">
                      <i class="fa fa-unlink mr-1"></i> Remover
                    </b-button>
                    <b-button variant="soft-primary" pill class="flex-fill font-weight-bold shadow-sm mb-2" :disabled="!habilitarBotaoConciliarXml" @click.stop="abrirModalConciliarNFE">
                      <i class="fa fa-balance-scale mr-1"></i> Conciliar
                    </b-button>
                    <b-button variant="soft-success" pill class="flex-fill font-weight-bold shadow-sm mb-2" :disabled="!habilitarBotaoVisualizarDanfe" @click.stop="downloadPDFNfe()">
                      <i class="fa fa-file-pdf-o mr-1"></i> DANFE
                    </b-button>
                    <b-button
                      v-if="compra.NOTA_FISCAL && compra.OP_XML !== '0' && compra.OP_XML !== '3'"
                      variant="soft-warning"
                      pill
                      class="flex-fill font-weight-bold shadow-sm mb-2"
                      @click.stop="manifestarSefaz">
                      <i class="fa fa-check-circle mr-1"></i> Confirmar SEFAZ
                    </b-button>
                  </div>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="12">
                </b-col>
              </b-row>
            </b-card>

            <!-- Card Impostos e Descontos -->
            <b-card class="mb-3 border-0 shadow-sm" body-class="p-4">
              <template #header>
                <div class="d-flex align-items-center">
                  <div class="bg-success text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                    <i class="fa fa-money"></i>
                  </div>
                  <div>
                    <h6 class="mb-0 font-weight-bold">Impostos e Descontos</h6>
                    <small class="text-muted">Resumo financeiro e tributário</small>
                  </div>
                </div>
              </template>

              <b-row class="mb-3">
                <b-col sm="4">
                  <label class="modal-label-premium">Valor do ICMS</label>
                  <vue-autonumeric  
                    v-model="compra.VL_ICMS" 
                    :disabled="compraFechada"  
                    :options="{ digitGroupSeparator: '.', decimalCharacter: ',', roundingMethod: 'U', minimumValue: '0' }"
                    class="form-control rounded-pill shadow-xs text-right"
                  />
                </b-col>
                <b-col sm="4">
                  <label class="modal-label-premium">Valor do PIS</label>
                  <vue-autonumeric  
                    v-model="compra.VL_PIS" 
                    :disabled="compraFechada"  
                    :options="{ digitGroupSeparator: '.', decimalCharacter: ',', roundingMethod: 'U', minimumValue: '0' }"
                    class="form-control rounded-pill shadow-xs text-right"
                  />
                </b-col>

                <b-col sm="4">
                  <label class="modal-label-premium">Valor do COFINS</label>
                  <vue-autonumeric  
                    v-model="compra.VL_COFINS" 
                    :disabled="compraFechada"  
                    :options="{ digitGroupSeparator: '.', decimalCharacter: ',', roundingMethod: 'U', minimumValue: '0' }"
                    class="form-control rounded-pill shadow-xs text-right"
                  />
                </b-col>
              </b-row>

              <b-row class="mb-3">
                <b-col sm="4">
                  <label class="modal-label-premium">Valor do IPI</label>
                  <vue-autonumeric  
                    v-model="compra.VL_IPI" 
                    :disabled="compraFechada"  
                    :options="{ digitGroupSeparator: '.', decimalCharacter: ',', roundingMethod: 'U', minimumValue: '0' }"
                    class="form-control rounded-pill shadow-xs text-right"
                  />
                </b-col>
                <b-col sm="4">
                  <label class="modal-label-premium">Total Frete</label>
                  <vue-autonumeric  
                    v-model="compra.VL_FRETE" 
                    :disabled="compraFechada"  
                    :options="{ digitGroupSeparator: '.', decimalCharacter: ',', roundingMethod: 'U', minimumValue: '0' }"
                    class="form-control rounded-pill shadow-xs text-right font-weight-bold text-danger"
                  />
                </b-col>
                <b-col sm="4">
                  <label class="modal-label-premium">Total Descontos</label>
                  <vue-autonumeric  
                    v-model="compra.VL_TOTAL_DESCONTO" 
                    :disabled="compraFechada"  
                    :options="{ digitGroupSeparator: '.', decimalCharacter: ',', roundingMethod: 'U', minimumValue: '0' }"
                    class="form-control rounded-pill shadow-xs text-right font-weight-bold text-danger"
                  />
                </b-col>
              </b-row>
            </b-card>
          </div>
        </b-col>
      </b-row>
       
        <!-- TABS PRINCIPAIS -->
        <b-card v-if="compra.ID" no-body class="shadow-sm border-0 mb-4">
          <b-tabs card pills nav-class="modern-tabs" content-class="p-4" @activate-tab="onTabActivated">
            
            <!-- ABA PRODUTOS -->
            <b-tab active>
              <template #title>
                <div class="d-flex align-items-center">
                  <i class="fa fa-cube mr-2"></i>
                  <span>Produtos</span>
                  <b-badge variant="soft-info" pill class="ml-2">{{ tabelaItens.items.length }}</b-badge>
                </div>
              </template>

              <div class="d-flex justify-content-between align-items-center mb-3">
                <div>
                  <h5 class="mb-0 font-weight-bold text-dark">Itens do Pedido</h5>
                  <small class="text-muted">{{ descricaoTabelaItens }}</small>
                </div>
                <div class="d-flex gap-2">
                 <b-badge :variant="compraAlmoxarifado ? 'success' : 'primary'" pill class="align-self-center px-3 py-2">
                   {{ rotuloTipoPedidoTabela }}
                 </b-badge>
                 
                <span class="mr-2 font-weight-bold d-flex align-items-center" style="font-size: 0.75rem;">GERA ESTOQUE</span>
                <b-form-checkbox
                  v-model="compra.OP_GERA_ESTOQUE"
                  switch
                  :disabled="!habilitarGeraEstoque"
                  value="S"
                  unchecked-value="N"
                  class="mr-2 mb-0 custom-switch-premium d-flex centered justify-content-center"
                  @change="onChangeOpGeraEstoque"
                >
                  
                </b-form-checkbox>
              
                  <b-button 
                    v-if="habilitarBotoesImportarXml"
                    variant="soft-info" 
                    class="rounded-pill px-3 mr-2"
                    @click="importarXML()"
                  >
                    <i class="fa fa-file-code-o mr-2"></i>Importar XML
                  </b-button>
                  <b-button 
                    v-if="habilitarBotoesItens"
                    variant="success" 
                    pill
                    class="px-4 font-weight-bold shadow-sm"
                    @click="abrirModalItemNovo()"
                  >
                    <i class="fa fa-plus-circle mr-1"></i> ADICIONAR PRODUTO
                  </b-button>
                </div>
              </div>

              <b-table 
                striped 
                hover 
                show-empty
                empty-text="Nenhum produto adicionado"
                stacked="md"
                small
                select-mode="single"
                head-variant="light"
                selectable
                bordered
                responsive
                
                @row-clicked="abrirModalItemEditar"
                :items="tabelaItens.items" 
                :fields="camposTabelaItens"
              >
                <template #cell(VL_UNITARIO_FOB)="item">
                  <span class="font-weight-bold text-primary">{{ formatarMoeda3Casas(item.item.VL_UNITARIO_FOB) }}</span>
                </template>
                <template #cell(VL_TOTAL_FOB)="item">
                  <span class="font-weight-bold text-dark">{{ formatarMoeda(item.item.VL_TOTAL_FOB) }}</span>
                </template>
                <template #cell(actions)="item">
                  <b-button 
                    v-if="itemExigeControleLote(item.item)"
                    :variant="itemLoteConsistente(item.item) ? 'soft-success' : 'soft-warning'"
                    size="sm" 
                    class="rounded-circle mr-1"
                    @click.stop.prevent="abrirModalLotes(item.item)"
                    v-b-tooltip.hover="itemLoteConsistente(item.item) ? 'Lotes consistentes' : 'Detalhar lotes'"
                  >
                    <i class="fa fa-clone"></i>
                  </b-button>
                  <b-button 
                    v-if="habilitarBotoesItens"
                    variant="soft-danger" 
                    size="sm" 
                    class="rounded-circle"
                    @click.stop.prevent="abrirModaldeleteItem(item.item)"
                    
                  >
                    <i class="fa fa-trash"></i>
                  </b-button>
                </template>
              </b-table>
            </b-tab>

            <!-- ABA FINANCEIRO -->
            <b-tab>
              <template #title>
                <div class="d-flex align-items-center">
                  <i class="fa fa-money mr-2"></i>
                  <span>Financeiro / Despesas</span>
                </div>
              </template>

              <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="mb-0 font-weight-bold text-dark">Despesas e Movimentações</h5>
                <b-button 
                  v-if="habilitaBotaoIncluirMovimentacao"
                  variant="success" 
                  pill
                  class="px-4 font-weight-bold shadow-sm"
                  @click="abrirModalDespesaNovo()"
                >
                  <i class="fa fa-plus-circle mr-1"></i> NOVA DESPESA
                </b-button>
              </div>

              <b-table 
                striped 
                hover 
                show-empty
                empty-text="Nenhum Lançamento"
                stacked="md"
                small
                select-mode="single"
                head-variant="light"
                selectable
                bordered
                responsive
                
                @row-clicked="abrirModalDespesaEditar"
                :items="despesas.items" 
                :fields="despesas.fields"
              >
                <template #cell(OP_GERA_TITULO)="item">
                  <b-badge :variant="item.item.OP_GERA_TITULO == '1' ? 'soft-success' : 'soft-warning'" pill>
                    <i :class="['fa fa-circle mr-1', colorirOP_GERA_TITULO(item.item.OP_GERA_TITULO)]"></i>
                    {{ item.item.OP_GERA_TITULO == '1' ? 'Gerado' : 'Pendente' }}
                  </b-badge>
                </template> 
                <template #cell(OP_DESPESA)="item">
                  <b-badge :variant="item.item.OP_DESPESA == '1' ? 'soft-danger' : 'soft-info'" pill>
                    <i :class="['fa fa-circle mr-1', colorirOP_DESPESA(item.item.OP_DESPESA)]"></i>
                    {{ item.item.OP_DESPESA == '1' ? 'Despesa' : 'Crédito' }}
                  </b-badge>
                </template> 
                <template #cell(actions)="item">
                  <div class="d-flex justify-content-center">
                    <b-button 
                      v-if="(( item.item.OP_GERA_TITULO != '1') && (!compraFechada))"
                      variant="soft-primary" 
                      size="sm" 
                      class="rounded-circle mr-1"
                      @click.stop.prevent="gerarFinanceiroDespesa(item.item)" 
                      v-b-tooltip.hover="'Gerar Financeiro'"
                    >
                      <i class="fa fa-money"></i>
                    </b-button>
                    <b-button 
                      v-if="(( item.item.OP_GERA_TITULO != '1') && (!compraFechada))"
                      variant="soft-danger" 
                      size="sm" 
                      class="rounded-circle"
                      @click.stop.prevent="deleteDespesa(item.item)" 
                      v-b-tooltip.hover="'Remover Despesa'"
                    >
                      <i class="fa fa-close"></i>
                    </b-button>
                  </div>
                </template>
              </b-table>
            </b-tab>

            <!-- ABA LOGÍSTICA -->
            <b-tab>
              <template #title>
                <div class="d-flex align-items-center">
                  <i class="fa fa-truck mr-2"></i>
                  <span>Logística</span>
                </div>
              </template>

              <div class="premium-section-title mb-4">
                <h6 class="text-primary font-weight-bold mb-0">Cronograma e Acompanhamento</h6>
                <small class="text-muted">Gestão de prazos e etapas de entrega</small>
              </div>

              <b-row class="mb-4">
                <b-col md="4">
                  <div class="modern-input-group">
                    <label class="modal-label-premium">Chegada Necessária (Pedido)</label>
                    <cec-input-data
                      id="edDT_CHEGADA_NECESSARIA" 
                      v-model="compra.DT_CHEGADA_NECESSARIA"
                      :disabled="compraFechada"
                      :state="!!compra.DT_CHEGADA_NECESSARIA"
                    />
                  </div>
                </b-col>
              </b-row>

              <div class="table-responsive rounded shadow-sm border">
                <table class="table table-hover mb-0">
                  <thead class="bg-light">
                    <tr>
                      <th class="border-0">Etapa Logística</th>
                      <th class="border-0">Previsão</th>
                      <th class="border-0">Efetivo / Realizado</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="align-middle font-weight-bold text-dark">
                        <i class="fa fa-ship mr-2 text-muted"></i>Carregamento (Origem)
                      </td>
                      <td>
                        <cec-input-data
                          id="edDT_PREVISAO_CARREGAMENTO" 
                          v-model="compra.DT_PREVISAO_CARREGAMENTO"
                          :disabled="compraFechada"
                          placeholderText="Previsão"
                        />
                      </td>
                      <td>
                        <cec-input-data
                          id="edDT_CARREGAMENTO_ORIGEM" 
                          v-model="compra.DT_CARREGAMENTO_ORIGEM"
                          :disabled="compraFechada"
                          placeholderText="Realizado"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td class="align-middle font-weight-bold text-dark">
                        <i class="fa fa-anchor mr-2 text-muted"></i>Saída do Porto
                      </td>
                      <td>
                        <cec-input-data
                          id="edDT_PREVISAO_SAIDA_PORTO" 
                          v-model="compra.DT_PREVISAO_SAIDA_PORTO"
                          :disabled="compraFechada" 
                          placeholderText="Previsão"
                        />
                      </td>
                      <td>
                        <cec-input-data
                          id="edDT_SAIDA_PORTO" 
                          v-model="compra.DT_SAIDA_PORTO"
                          :disabled="compraFechada" 
                          placeholderText="Realizado"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td class="align-middle font-weight-bold text-dark">
                        <i class="fa fa-building mr-2 text-muted"></i>Chegada no Porto
                      </td>
                      <td>
                        <cec-input-data
                          id="edDT_PREVISAO_CHEGADA_PORTO" 
                          v-model="compra.DT_PREVISAO_CHEGADA_PORTO"
                          :disabled="compraFechada"
                          placeholderText="Previsão"
                        />
                      </td>
                      <td>
                        <cec-input-data
                          id="edDT_CHEGADA_PORTO" 
                          v-model="compra.DT_CHEGADA_PORTO"
                          :disabled="compraFechada"
                          placeholderText="Realizado"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td class="align-middle font-weight-bold text-dark">
                        <i class="fa fa-dropbox mr-2 text-muted"></i>Descarregamento (Destino)
                      </td>
                      <td>
                        <cec-input-data
                          id="edDT_PREVISAO_DESCARREGAMENTO" 
                          v-model="compra.DT_PREVISAO_DESCARREGAMENTO"
                          :disabled="compraFechada" 
                          placeholderText="Previsão"
                        />
                      </td>
                      <td>
                        <div class="p-2 rounded bg-soft-success border border-success-subtle">
                          <div class="d-flex justify-content-between align-items-center mb-2">
                            <small class="font-weight-bold text-success">Início (Gera Estoque)</small>
                            <i class="fa fa-cubes text-success"></i>
                          </div>
                          <cec-input-data
                            id="edDT_CONFERENCIA_INICIO" 
                            v-model="compra.DT_CONFERENCIA_INICIO"
                            :disabled="compraFechada" 
                            placeholderText="Início"
                          />
                          <div class="mt-2">
                            <small class="text-muted d-block mb-1">Término Descarregamento</small>
                            <cec-input-data
                              id="edDT_CONFERENCIA_FIM" 
                              v-model="compra.DT_CONFERENCIA_FIM"
                              :disabled="true"
                              placeholderText="Término"
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-tab>

            <!-- ABA PAGAMENTO -->
            <b-tab>
              <template #title>
                <div class="d-flex align-items-center">
                  <i class="fa fa-credit-card mr-2"></i>
                  <span>Pagamento</span>
                </div>
              </template>

              <b-row>
                <b-col lg="5">
                  <b-card border-variant="light" class="shadow-sm mb-4">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <h6 class="font-weight-bold text-dark mb-0">Plano de Pagamento</h6>
                      <b-badge variant="soft-primary " pill>Parcelamento</b-badge>
                    </div>

                    <b-row>
                      <b-col sm="6">
                        <div class="modern-input-group">
                          <label class="modal-label-premium">Efetivação</label>
                          <b-form-input 
                            type="date" 
                            v-model="compra.DT_PEDIDO"
                            class="rounded-pill"
                            :disabled="!habilitarGrupoFinanceiro"
                          />
                        </div>
                      </b-col>
                      <b-col sm="6">
                        <div class="modern-input-group">
                          <label class="modal-label-premium">Parcelas</label>
                          <b-input-group>
                            <b-form-select 
                              v-model="compra.OP_PARCELAMENTO"
                              :disabled="!habilitarGrupoFinanceiro"
                              :options="dias"
                              class="rounded-left-pill"
                            />
                            <b-input-group-append>
                              <b-button 
                                variant="primary" 
                                class="rounded-right-pill px-3"
                                :disabled="!habilitarGrupoFinanceiro"
                                @click="gerarParcelamento()"
                              >
                                <i class="fa fa-magic"></i>
                              </b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </div>
                      </b-col>
                    </b-row>

                    <b-table 
                      striped 
                      hover 
                      :items="parcelamento.items" 
                      :fields="parcelamento.fields"
                      show-empty
                      empty-text="Nenhum parcelamento"
                      small
                      responsive 
                      bordered
                      class="mt-3"
                      head-variant="light"
                    >
                      <template #cell(VENCIMENTO)="item">
                        <b-button 
                          v-if="habilitarGrupoFinanceiro" 
                          variant="soft-info" 
                          size="sm" 
                          class="rounded-pill px-3"
                          @click.stop.prevent="abrirModalVencimento(item.item)"
                        >
                          {{ converterDataVencimento(item.item.VENCIMENTO) }}
                          <i class="fa fa-calendar ml-2"></i>
                        </b-button>
                        <span v-else>{{ converterDataVencimento(item.item.VENCIMENTO) }}</span>
                      </template>      
                    </b-table>
                  </b-card>
                </b-col>

                <b-col lg="7">
                  <b-card border-variant="light" class="shadow-sm">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <h6 class="font-weight-bold text-dark mb-0">Configuração Financeira</h6>
                      <b-form-checkbox 
                        id="cbOP_FINANCEIRO"
                        v-model="compra.OP_FINANCEIRO"
                        :disabled="!habilitarNaoGeraFinanceiro"
                        value="2"
                        unchecked-value="0"
                        switch
                        
                      >
                        <small class="font-weight-bold">Não Gerar Financeiro</small>
                      </b-form-checkbox>
                    </div>

                    <b-row>
                      <b-col md="6">
                        <div class="modern-input-group">
                          <label class="modal-label-premium">Grupo de Documentos</label>
                          <grupo-apagar-drop-down 
                            v-model="compra.GRUPO_APAGAR_ID"
                            :disabled="!habilitarGrupoFinanceiro"
                          />
                        </div>
                      </b-col>
                      <b-col md="6">
                        <div class="modern-input-group">
                          <label class="modal-label-premium">Centro de Custo</label>
                          <centro-custo-drop-down 
                            v-model="compra.CENTRO_CUSTO_ID"
                            :disabled="!habilitarGrupoFinanceiro"
                          />
                        </div>
                      </b-col>
                    </b-row>

                    <b-row class="mt-3">
                      <b-col md="6">
                        <div class="modern-input-group">
                          <label class="modal-label-premium">Tipo de Pagamento</label>
                          <b-form-select 
                            v-model="compra.OP_FORMA_PAGAMENTO"
                            :disabled="!habilitarGrupoFinanceiro"
                            :options="optionsOP_FORMA_PAGAMENTO"
                            class="rounded-pill"
                          />
                        </div>
                      </b-col>
                      <b-col md="6" class="d-flex align-items-end">
                        <b-button  
                          v-if="!habilitarBotaoCancelarFinanceiro"
                          :disabled="!habilitarBotaoGerarFinanceiro"
                          variant="primary"
                          block
                          class="rounded-pill py-2 font-weight-bold shadow-sm"
                          @click.stop.prevent="gerarFinanceiro"
                        >
                          <i class="fa fa-money mr-2"></i>Gerar Financeiro
                        </b-button>
                        <b-button  
                          v-if="habilitarBotaoCancelarFinanceiro"
                          variant="danger"
                          block
                          class="rounded-pill py-2 font-weight-bold shadow-sm"
                          @click.stop.prevent="abrirModalCancelarFinanceiro"
                        >
                          <i class="fa fa-ban mr-2"></i>Cancelar Financeiro
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>

            <!-- ABA CONFERÊNCIA -->
            <b-tab>
              <template #title>
                <div class="d-flex align-items-center">
                  <i class="fa fa-check-square-o mr-2"></i>
                  <span>Conferência</span>
                </div>
              </template>

              <div class="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-2">
                <b-form-checkbox
                  v-model="compra.OP_CONCLUIR_SEM_RECEPCAO"
                  switch
                  :disabled="!habilitarConcluirSemConferencia"
                  value="1"
                  unchecked-value="0"
                  @change="onChangeOpConcluirSemRecepcao"
                >
                  <span class="font-weight-bold">Concluir sem Conferência</span>
                </b-form-checkbox>

                <div class="d-flex gap-2">
                  <b-button v-if="habilitarBotaoAtualizarPelaConferencia" variant="soft-info" class="rounded-pill px-3" @click="atualizarPelaConferencia()">
                    <i class="fa fa-refresh mr-2"></i>Atualizar Produtos
                  </b-button>
                  <b-button v-if="habilitarBotaoSolicitarConferencia" variant="warning" class="rounded-pill px-3" @click="solicitarConferencia()">
                    <i class="fa fa-send mr-2"></i>Solicitar Conferência
                  </b-button>
                  <b-button v-if="habilitarBotaoCancelarConferencia" variant="danger" class="rounded-pill px-3" @click="cancelarSolicitacaoConferencia()">
                    <i class="fa fa-times mr-2"></i>Cancelar Solicitação
                  </b-button>
                  <b-button v-if="habilitarBotaoDevolverProTerminal" variant="info" class="rounded-pill px-3" @click="devolverProTerminal()">
                    <i class="fa fa-reply mr-2"></i>Devolver Terminal
                  </b-button>
                  <b-button v-if="['2','3'].includes(compra.OP_RECEPCAO)" variant="outline-primary" class="rounded-pill px-3" @click="imprimirEspelhoConferencia()">
                    <i class="fa fa-print mr-2"></i>Imprimir Espelho
                  </b-button>
                </div>
              </div>

              <b-row class="mb-4">
                <b-col md="3">
                  <div class="modern-input-group">
                    <label class="modal-label-premium">Solicitado em</label>
                    <b-form-input type="date" v-model="compra.DT_SOLICITA_CONFERENCIA" disabled class="rounded-pill bg-light" />
                  </div>
                </b-col>
                <b-col md="3">
                  <div class="modern-input-group">
                    <label class="modal-label-premium">Situação</label>
                    <div class="d-flex align-items-center p-2 border rounded-pill bg-light">
                      <i :class="['fa fa-circle mr-2', colorirOP_RECEPCAO(compra.OP_RECEPCAO)]"></i>
                      <span class="font-weight-bold">{{ traduzOP_RECEPCAO(compra.OP_RECEPCAO) }}</span>
                    </div>
                  </div>
                </b-col>
                <b-col md="3">
                  <div class="modern-input-group">
                    <label class="modal-label-premium">Autorizado Por</label>
                    <b-form-input v-model="compra.USUARIO_DIVERGENCIA" disabled class="rounded-pill bg-light" />
                  </div>
                </b-col>
                <b-col md="3">
                  <div class="modern-input-group">
                    <label class="modal-label-premium">Data Autorização</label>
                    <b-form-input type="date" v-model="compra.DATA_AUTORIZA_DIVERGENCIA" disabled class="rounded-pill bg-light" />
                  </div>
                </b-col>
              </b-row>

              <b-table 
                striped 
                hover 
                show-empty
                empty-text="Nenhum item conferido"
                small
                bordered
                responsive
                :busy="conferencia.loading"
                :items="conferencia.items" 
                :fields="conferencia.fields"
              >
                <template #table-busy>
                  <div class="text-center text-primary my-4">
                    <b-spinner class="align-middle mr-2"></b-spinner>
                    <strong>Carregando dados de conferência...</strong>
                  </div>
                </template>

                <template #cell(PECAS_DIFERENCA)="data">
                  <span 
                    :class="{
                      'font-weight-bold badge badge-success': data.value === 0,
                      'font-weight-bold badge badge-danger': data.value < 0,
                      'font-weight-bold badge badge-warning': data.value > 0
                    }"
                  >
                    {{ data.value != null ? data.value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2}) : '0,00' }}
                  </span>
                </template>

                <template #cell(QUANT_DIFERENCA)="data">
                  <span 
                    :class="{
                      'font-weight-bold badge badge-success': data.value === 0,
                      'font-weight-bold badge badge-danger': data.value < 0,
                      'font-weight-bold badge badge-warning': data.value > 0
                    }"
                  >
                    {{ data.value != null ? data.value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2}) : '0,00' }}
                  </span>
                </template>
              </b-table>
            </b-tab>

            <!-- ABA OBSERVAÇÕES -->
            <b-tab>
              <template #title>
                <div class="d-flex align-items-center">
                  <i class="fa fa-commenting-o mr-2"></i>
                  <span>Observações</span>
                </div>
              </template>
              <b-form-textarea
                v-model="compra.OBSERVACOES"
                placeholder="Notas internas, detalhes da entrega ou observações gerais..."
                :disabled="compraFechada"
                rows="6"
                class="modern-textarea shadow-sm"
              />
            </b-tab>
          </b-tabs>
        </b-card>
          
          
    
    </div>
    
    <b-modal
      ref="modal-lotes-item"
      id="modal-lotes-item"
      hide-header
      hide-footer
      body-class="p-0 overflow-hidden"
      content-class="border-0 shadow-lg"
      centered
      size="xl"
      no-close-on-backdrop
      no-close-on-esc
      @shown="focusModalLotes()"
    >
      <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #1f6f8b 0%, #154f64 100%) !important;">
        <div class="header-icon-wrapper-modal mr-3 bg-white-100">
          <i class="fa fa-clone text-white fa-lg"></i>
        </div>
        <div>
          <h5 class="mb-0 font-weight-bold text-white">Detalhamento de Lotes</h5>
          <small class="text-white opacity-75">Item {{ lotes.modal.item ? lotes.modal.item.PRODUTO_ID : '' }} - {{ lotes.modal.item ? lotes.modal.item.NOME_PRODUTO : '' }}</small>
        </div>
        <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="fecharModalLotes()">
          <i class="fa fa-times fa-lg"></i>
        </b-button>
      </div>

      <b-overlay :show="lotes.modal.loading || lotes.modal.saving" rounded="sm">
        <div class="p-4 bg-white">
          <div class="modal-info-bar mb-4 bg-light border shadow-sm p-3 rounded" v-if="lotes.modal.item">
            <b-row align-v="center">
              <b-col md="5">
                <small class="modal-label-premium">Produto</small>
                <h5 class="mb-0 font-weight-bold text-dark">{{ lotes.modal.item.PRODUTO_ID }} - {{ lotes.modal.item.NOME_PRODUTO }}</h5>
              </b-col>
              <b-col md="3" class="border-left">
                <small class="modal-label-premium">Quantidade / Peças do Item</small>
                <div class="font-weight-bold text-primary">{{ formatarNumeroResumoLote(lotesResumoAtual.quantidadeItem, 3) }}</div>
                <small class="text-muted font-weight-bold">{{ formatarNumeroResumoLote(lotesResumoAtual.pecasItem, 0) }} peças</small>
              </b-col>
              <b-col md="4" class="border-left text-right">
                <small class="modal-label-premium">Total do Item</small>
                <h5 class="mb-0 font-weight-bold text-success">{{ formatarMoeda(lotesResumoAtual.valorItem) }}</h5>
              </b-col>
            </b-row>
          </div>

          <div class="modal-section-title mb-3">
            <i class="fa fa-edit mr-2 text-primary"></i> Cadastro do Lote
          </div>

          <b-row class="mb-3">
            <b-col md="3">
              <label class="modal-label-premium">Lote Interno</label>
              <b-form-input
                ref="edLoteInterno"
                v-model="lotes.item.LOTE"
                class="rounded-pill shadow-xs"
                placeholder="Informe o lote interno"
              />
            </b-col>
            <b-col md="3">
              <label class="modal-label-premium">Lote do Fornecedor</label>
              <b-form-input
                v-model="lotes.item.LOTE_FORNECEDOR"
                class="rounded-pill shadow-xs"
                placeholder="Lote do fornecedor"
              />
            </b-col>
            <b-col md="2">
              <label class="modal-label-premium">Data Fabricação</label>
              <CecInputData
                v-model="lotes.item.DATA_FABRICACAO"
                placeholder-text="dd/mm/aaaa"
                input-class="rounded-pill shadow-xs"
              />
            </b-col>
            <b-col md="2">
              <label class="modal-label-premium">Data Validade</label>
              <CecInputData
                v-model="lotes.item.DATA_VALIDADE"
                placeholder-text="dd/mm/aaaa"
                input-class="rounded-pill shadow-xs"
              />
            </b-col>
            <b-col md="2">
              <label class="modal-label-premium">Custo Unitário</label>
              <vue-autonumeric
                v-model="lotes.item.VL_CUSTO_UNITARIO"
                :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalPlaces: 3, roundingMethod: 'U', minimumValue: '0' }"
                class="form-control rounded-pill shadow-xs text-right"
              />
            </b-col>
          </b-row>

          <b-row class="mb-3">
            <b-col md="2">
              <label class="modal-label-premium">Quantidade</label>
              <vue-autonumeric
                v-model="lotes.item.QUANTIDADE"
                :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalPlaces: '5', roundingMethod: 'U', minimumValue: '0' }"
                class="form-control rounded-pill shadow-xs text-right"
              />
            </b-col>
            <b-col md="2">
              <label class="modal-label-premium">Peças</label>
              <vue-autonumeric
                v-model="lotes.item.PECAS"
                :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalPlaces: '0', roundingMethod: 'U', minimumValue: '0' }"
                class="form-control rounded-pill shadow-xs text-right"
              />
            </b-col>
            <b-col md="8">
              <label class="modal-label-premium">Observação</label>
              <b-form-input
                v-model="lotes.item.OBSERVACAO"
                class="rounded-pill shadow-xs"
                placeholder="Observações do lote"
              />
            </b-col>
          </b-row>

          <div class="d-flex flex-wrap justify-content-between align-items-center mb-4">
            <small class="text-muted font-weight-bold mb-2 mb-md-0">
              Saldo disponível: Qtd {{ formatarNumeroResumoLote(saldoLoteAtual.quantidade, 3) }} | Peças {{ formatarNumeroResumoLote(saldoLoteAtual.pecas, 0) }}
            </small>
            <div class="d-flex flex-wrap justify-content-end">
              <b-button variant="soft-info" pill class="px-4 font-weight-bold mr-2 mb-2 mb-md-0" @click="preencherSaldoDisponivelLote()">
                <i class="fa fa-magic mr-1"></i> USAR SALDO
              </b-button>
              <b-button variant="soft-danger" pill class="px-4 font-weight-bold mr-2 mb-2 mb-md-0" @click="limparFormularioLote()">
                LIMPAR
              </b-button>
              <b-button
                v-if="!lotes.item.ID"
                variant="success"
                pill
                class="px-4 font-weight-bold shadow-sm"
                @click="postLoteItem()"
              >
                <i class="fa fa-save mr-1"></i> GRAVAR LOTE
              </b-button>
              <b-button
                v-else
                variant="primary"
                pill
                class="px-4 font-weight-bold shadow-sm"
                @click="editLoteItem()"
              >
                <i class="fa fa-save mr-1"></i> SALVAR ALTERAÇÕES
              </b-button>
            </div>
          </div>

          <div class="modal-section-title mb-3">
            <i class="fa fa-list mr-2 text-primary"></i> Lotes Lançados
          </div>

          <b-table
            striped
            hover
            small
            bordered
            responsive
            show-empty
            empty-text="Nenhum lote lançado para este item"
            :items="lotes.items"
            :fields="lotes.fields"
          >
            <template #cell(actions)="data">
              <b-button variant="soft-info" size="sm" class="rounded-circle mr-1" @click.stop.prevent="selecionarLoteEdicao(data.item)">
                <i class="fa fa-pencil"></i>
              </b-button>
              <b-button variant="soft-danger" size="sm" class="rounded-circle" @click.stop.prevent="deleteLoteItem(data.item)">
                <i class="fa fa-trash"></i>
              </b-button>
            </template>
          </b-table>

          <div class="modal-section-title mt-4 mb-3">
            <i class="fa fa-bar-chart mr-2 text-primary"></i> Resumo do Item
          </div>

          <b-row>
            <b-col md="4">
              <div class="p-3 bg-white rounded border shadow-xs text-center h-100">
                <small class="modal-label-premium">Total do Item</small>
                <h5 class="mb-1 font-weight-bold text-dark">{{ formatarMoeda(lotesResumoAtual.valorItem) }}</h5>
                <small class="text-muted d-block">Qtd: {{ formatarNumeroResumoLote(lotesResumoAtual.quantidadeItem, 3) }}</small>
                <small class="text-muted d-block">Peças: {{ formatarNumeroResumoLote(lotesResumoAtual.pecasItem, 0) }}</small>
              </div>
            </b-col>
            <b-col md="4">
              <div class="p-3 bg-white rounded border shadow-xs text-center h-100">
                <small class="modal-label-premium">Total Lançado nos Lotes</small>
                <h5 class="mb-1 font-weight-bold text-primary">{{ formatarMoeda(lotesResumoAtual.valorLotes) }}</h5>
                <small class="text-muted d-block">Qtd: {{ formatarNumeroResumoLote(lotesResumoAtual.quantidadeLotes, 3) }}</small>
                <small class="text-muted d-block">Peças: {{ formatarNumeroResumoLote(lotesResumoAtual.pecasLotes, 0) }}</small>
              </div>
            </b-col>
            <b-col md="4">
              <div :class="['p-3 rounded border shadow-sm text-center h-100', lotesAtuaisConsistentes ? 'border-success' : 'border-warning']">
                <small :class="['modal-label-premium', lotesAtuaisConsistentes ? 'text-success' : 'text-warning']">Diferença</small>
                <h5 :class="['mb-1 font-weight-bold', lotesAtuaisConsistentes ? 'text-success' : 'text-warning']">{{ formatarMoeda(lotesResumoAtual.diferencaValor) }}</h5>
                <small class="text-muted d-block">Qtd: {{ formatarNumeroResumoLote(lotesResumoAtual.diferencaQuantidade, 3) }}</small>
                <small class="text-muted d-block">Peças: {{ formatarNumeroResumoLote(lotesResumoAtual.diferencaPecas, 0) }}</small>
                <small :class="lotesAtuaisConsistentes ? 'text-success font-weight-bold' : 'text-warning font-weight-bold'">
                  {{ lotesAtuaisConsistentes ? 'Lotes consistentes' : 'Lotes pendentes ou divergentes' }}
                </small>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-overlay>

      <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between">
        <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="fecharModalLotes()">
          FECHAR
        </b-button>
        <b-badge :variant="lotesAtuaisConsistentes ? 'success' : 'warning'" pill class="px-3 py-2 align-self-center">
          {{ lotesAtuaisConsistentes ? 'Consistente' : 'Inconsistente' }}
        </b-badge>
      </div>
    </b-modal>

    <!-- MODAL INCLUIR DESPESAS -->
    <b-modal 
      ref="modal-despesas" 
      id="modal-despesas" 
      hide-header
      body-class="p-0"
      no-close-on-esc
      no-close-on-backdrop
      size="lg"
      @shown="focus_modalDespesa()"
      centered
    >
      <div class="modal-header-premium bg-info text-white p-3 d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <div class="bg-white-20 rounded-circle p-2 mr-3">
            <i class="fa fa-money fa-lg"></i>
          </div>
          <div>
            <h5 class="mb-0 font-weight-bold">Movimentação Financeira</h5>
            <small class="opacity-75">Pedido: {{compra.ID}} • {{despesas.modal.nomeFornecedor}}</small>
          </div>
        </div>
        <b-badge :variant="despesas.modal.tipoMovimento === 'DEBITO' ? 'danger' : 'success'" pill class="px-3 py-2">
          {{despesas.modal.tipoMovimento}}
        </b-badge>
      </div>

      <div class="p-4 bg-light">
        <b-row class="mb-3">
          <b-col md="6">
            <label class="modal-label-premium">Documento</label>
            <b-form-input 
              ref="edItemDocumento" 
              v-model="despesas.item.DOCUMENTO" 
              class="rounded-pill shadow-sm"
              :disabled="compraFechada"
              placeholder="Nº do Documento"
            />
          </b-col>
          <b-col md="6">
            <label class="modal-label-premium">Valor Documento R$</label>
            <vue-autonumeric 
              v-model="despesas.item.VALOR" 
              :options="'Brazilian'"  
              :disabled="compraFechada"
              class="form-control rounded-pill shadow-sm text-right font-weight-bold"
            />
          </b-col>
        </b-row>

        <b-row class="mb-3">
          <b-col md="6">
            <label class="modal-label-premium">Data Documento</label>
            <b-form-input 
              type="date" 
              v-model="despesas.item.DATA_MOVIMENTACAO"
              class="rounded-pill shadow-sm"
              :disabled="compraFechada"
            />
          </b-col>
          <b-col md="6">
            <label class="modal-label-premium">Data Vencimento</label>
            <b-form-input 
              type="date" 
              v-model="despesas.item.DATA_VENCIMENTO"
              class="rounded-pill shadow-sm"
              :disabled="compraFechada"
            />
          </b-col>
        </b-row>

        <div class="premium-section-title mb-3 mt-4">
          <h6 class="text-primary font-weight-bold mb-0">Classificação e Pagamento</h6>
        </div>

        <b-row class="mb-3">
          <b-col sm="12">
            <historico-pesquisa 
              @retornaId="despesas.item.HISTORICO_ID = $event"
              @retornaTipo="despesas.modal.tipoMovimento = $event"
              :desabilitar-input="compraFechada"
              :idInicial="despesas.item.HISTORICO_ID"
              label="Histórico Plano de Contas"
              :layoutLinear="false"
              :arredondado="true"
            />
          </b-col>
        </b-row>

        <b-row class="mb-3">
          <b-col sm="12">
            <cliente-pesquisa 
              @retornaId="despesas.item.CLIENTE_ID = $event"
              :idInicial="despesas.item.CLIENTE_ID"
              :desabilitar-input="compraFechada" 
              label="Cliente / Fornecedor (Opcional)"
              :layoutLinear="false"
              :arredondado="true"
            />
          </b-col>
        </b-row>

        <b-row class="mb-3">
          <b-col md="6">
            <label class="modal-label-premium">Tipo de Pagamento</label>
            <b-form-select 
              v-model="despesas.item.TIPO_PAGAMENTO_ID"
              :disabled="compraFechada"
              :options="despesas.tipoPagamento.items"
              class="rounded-pill shadow-sm"
            >
              <template slot="first">
                <option :value="null">Selecione o tipo...</option>
              </template>
            </b-form-select>
          </b-col>
          <b-col md="6">
            <label class="modal-label-premium">Centro de Custo</label>
            <centro-custo-drop-down 
              v-model="despesas.item.CENTRO_CUSTO_ID"
              :disabled="compraFechada"
              input-class="rounded-pill shadow-sm"
            />
          </b-col>
        </b-row>

        <b-row class="mb-3">
          <b-col sm="12">
            <label class="modal-label-premium">Descrição / Observações</label>
            <b-form-input 
              v-model="despesas.item.OBSERVACOES" 
              class="rounded-pill shadow-sm"
              :disabled="compraFechada"
              placeholder="Detalhes adicionais da movimentação"
            />
          </b-col>
        </b-row>

        <div class="d-flex justify-content-end mt-4">
          <b-form-checkbox
            v-model="despesas.item.OP_DESPESA"
            :disabled="compraFechada"
            value="1"
            unchecked-value="0"
            switch
            class="custom-switch-premium"
          >
            <span class="font-weight-bold text-muted">Esta movimentação é uma despesa?</span>
          </b-form-checkbox>
        </div>
      </div>

      <template #modal-footer="{ cancel }">
        <div class="d-flex gap-2 w-100 justify-content-end p-2">
          <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="cancel()">
            CANCELAR
          </b-button>
          <b-button 
            v-if="!despesas.item.ID" 
            variant="success" 
            pill 
            class="px-4 font-weight-bold shadow-sm" 
            @click="postDespesa()"
          >
            <i class="fa fa-save mr-2"></i>GRAVAR
          </b-button>
          <b-button 
            v-if="(despesas.item.ID && despesas.modal.fechada == false)" 
            variant="primary" 
            pill 
            class="px-4 font-weight-bold shadow-sm" 
            @click="editDespesa()"
          >
            <i class="fa fa-save mr-2"></i>SALVAR ALTERAÇÕES
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- MODAL ITENS -->
    <b-modal 
      ref="modalItem" 
      id="modalItem" 
      hide-header
      hide-footer
      body-class="p-0 overflow-hidden"
      size="xl"
      @shown="focusModalItem()"
      centered
      no-close-on-backdrop
      no-close-on-esc
      content-class="border-0 shadow-lg"
      dialog-class="modal-custom-width"
    >
      <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #2c3e50 0%, #000000 100%) !important;">
        <div class="header-icon-wrapper-modal mr-3 bg-white-100">
          <i class="fa fa-cube text-warning fa-lg"></i>
        </div>
        <div>
          <h5 class="mb-0 font-weight-bold text-white">{{ controles.itemAlteracao === true ? 'Editar Item do Pedido' : 'Adicionar Novo Item' }}</h5>
          <small class="text-white opacity-75">Informe os detalhes do produto e quantidades</small>
        </div>
        <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$refs.modalItem.hide()">
          <i class="fa fa-times fa-lg"></i>
        </b-button>
      </div>

      <div class="p-4 bg-white">
        <!-- Item Summary Bar REMOVIDO -->

        <b-row>
          <b-col md="12">
            <div class="modal-section-title mb-3">
              <i class="fa fa-info-circle mr-2 text-primary"></i> Identificação e Quantificação
            </div>
            
            <b-row class="mb-3">
              <b-col sm="4">
                <label v-if="compra.OP_TIPO_PEDIDO === 'I'" class="modal-label-premium">PRODUTO</label>
                <produto-pesquisa 
                  v-if="compra.OP_TIPO_PEDIDO === 'I'"
                  ref="edPRODUTO_ID"
                  @retornaId="onSelecionarProdutoItem($event)"
                  @retornaNome="item.TX_NOME_PRODUTO = $event"
                  :idInicial="item.PRODUTO_ID"
                  :classe-required="!valPRODUTO_ID"
                  :desabilitarInput="controles.itemAlteracao || somentePrecoEditavel"
                  label=""
                  place="Busque pelo código ou nome do produto..."
                  :arredondado="true"
                />
                <label v-if="compra.OP_TIPO_PEDIDO === 'A'" class="modal-label-premium">MATERIAL</label>
                <bens-pesquisa
                  v-if="compra.OP_TIPO_PEDIDO === 'A'"
                  ref="edPRODUTO_ID"
                  @retornaId="onSelecionarProdutoItem($event)"
                  @retornaNome="item.TX_NOME_PRODUTO = $event"
                  :idInicial="item.PRODUTO_ID"
                  :classe-required="!valPRODUTO_ID"
                  :desabilitarInput="controles.itemAlteracao || somentePrecoEditavel"
                  label=""
                  place="Busque pelo código do material..."
                  :arredondado="true"
                />
              </b-col>
            
              <b-col md="2">
                <label class="modal-label-premium">
                  Quantidade
                  <small class="text-muted ml-1">({{ unidadeComercialItem }})</small>
                </label>
                <vue-autonumeric 
                  ref="edQuant"
                  v-model="item.NR_PESO_LIQUIDO" 
                  :disabled="pesagem.manual || somentePrecoEditavel"
                  
                  :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalPlaces: '5', roundingMethod: 'U', minimumValue: '0' }"
                  :class="['form-control rounded-pill shadow-xs text-right', { 'is-invalid' : !valQuantidadeComercial }]"
                />
              </b-col>
              <b-col md="2">
                <label class="modal-label-premium">Peso Bruto</label>
                <vue-autonumeric
                  v-model="item.NR_PESO_BRUTO"
                  :disabled="somentePrecoEditavel"
                  :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalPlaces: '5', roundingMethod: 'U', minimumValue: '0' }"
                  class="form-control rounded-pill shadow-xs text-right"
                />
              </b-col>
              <b-col md="2">
                <label class="modal-label-premium">Volumes / Peças</label>
                <vue-autonumeric 
                  v-model="item.QT_PECAS" 
                  :disabled="pesagem.manual || somentePrecoEditavel"
                  :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalPlaces: '0', roundingMethod: 'U', minimumValue: '0' }"
                  :class="['form-control rounded-pill shadow-xs text-right', { 'is-invalid' : !valQT_PECAS }]"
                />
              </b-col>
              <b-col md="2">
                <label class="modal-label-premium">Preço Unitário R$</label>
                <vue-autonumeric 
                  
                  v-model="item.VL_UNITARIO_FOB" 
                  :disabled="compraFechada"
                  :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalPlaces: 5, roundingMethod: 'U', minimumValue: '0' }"
                  :class="['form-control rounded-pill shadow-xs text-right', { 'is-invalid' : !valVL_UNITARIO_FOB }]"

                />
                
              </b-col>
            </b-row>

            <!-- PESAGEM MANUAL SECTION -->
            <div v-if="compra.OP_TIPO_PEDIDO === 'I' && !somentePrecoEditavel"  class="bg-light p-3 rounded border mb-3 shadow-sm">
              <div class="d-flex align-items-center mb-2">
                <label class="modal-label-premium mb-0 mr-3">Lançamento por Peso (Pesagem Manual)</label>
                <b-badge variant="soft-info" pill>10 COLUNAS DISPONÍVEIS</b-badge>
              </div>
              <b-input-group @keyup.enter="lancarPeso()" class="mb-3">
                <vue-autonumeric
                  v-model="pesagem.peso"
                  id="edPeso"
                  ref="edPeso"
                  placeholder="Informe o peso e tecle ENTER"
                  :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', decimalPlaces: '3', roundingMethod: 'U', minimumValue: '0' }"
                  class="form-control rounded-pill-left shadow-xs px-4 text-right"
                />
                <b-input-group-append>
                  <b-button variant="primary" class="px-3" @click.stop.prevent="lancarPeso()"><i class="fa fa-plus mr-1"></i> LANÇAR</b-button>
                  <b-button variant="warning" class="px-3" @click.stop.prevent="excluirPeso()">DESFAZER</b-button>
                  <b-button variant="danger" class="rounded-pill-right px-3" @click.stop.prevent="excluirPesagem()">LIMPAR TUDO</b-button>
                </b-input-group-append>
              </b-input-group>

              <div class="bg-white rounded border shadow-xs overflow-hidden">
                <b-table
                  id="tblPesagem"
                  ref="tblPesagem"
                  sticky-header="150px"
                  small
                  hover
                  striped
                  :items="pesagem.items"
                  :fields="pesagem.fields"
                  class="mb-0 table-finance font-xs"
                >
                  <template #head(id)>Linha</template>
                  <template v-for="col in ['COL1','COL2','COL3','COL4','COL5','COL6','COL7','COL8','COL9','COL10']" #[`cell(${col})`]="data">
                    <div v-if="data.value !== null" class="d-flex justify-content-between align-items-center px-1 border-right" style="min-width: 70px;">
                      <span class="font-weight-bold">{{ data.value }}</span>
                      <b-button size="sm" variant="link" class="text-danger p-0" @click="limparCelulaPesagem(data.item.ID, col)">
                        <i class="fa fa-times-circle"></i>
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row class="mt-3">
           <b-col md="3">
            <div class="modal-section-title mb-3">
              <i class="fa fa-calculator mr-2 text-info"></i> Detalhes Fiscais
            </div>
            <div class="p-3 bg-white rounded border shadow-xs">
              <b-row class="mb-2">
                <b-col sm="12">
                  <label class="modal-label-premium">NCM</label>
                  <div class="form-control rounded-pill shadow-xs text-right bg-soft-secondary border-secondary font-weight-bold">
                    {{item.TX_NCM || '---'}}
                  </div>
                </b-col>

                <b-col sm="12">
                <label class="modal-label-premium">EAN / GTIN</label>
                <div class="form-control rounded-pill shadow-xs text-right bg-soft-secondary border-secondary font-weight-bold">
                  {{item.EAN || '---'}}
                </div>
              </b-col>
            </b-row>
            </div>
           </b-col>

           <b-col md="6">
            <div class="modal-section-title mb-3">
              <i class="fa fa-percent mr-2 text-info"></i> Impostos
            </div>
            
            <div class="p-3 bg-white rounded border shadow-xs">
              <b-row class="mb-2">
                <b-col sm="4">
                  <label class="modal-label-premium">ICMS</label>
                  <vue-autonumeric v-model="item.VL_ICMS" :disabled="somentePrecoEditavel" :options="'Brazilian'" class="form-control rounded-pill shadow-xs text-right bg-soft-info border-info font-weight-bold" />
                </b-col>
                <b-col sm="4">
                  <label class="modal-label-premium">ICMS ST</label>
                  <vue-autonumeric v-model="item.VL_ICMS_ST" :disabled="somentePrecoEditavel" :options="'Brazilian'" class="form-control rounded-pill shadow-xs text-right bg-soft-info border-info font-weight-bold" />
                </b-col>
              
                <b-col sm="4">
                  <label class="modal-label-premium">PIS</label>
                  <vue-autonumeric v-model="item.VL_PIS" :disabled="somentePrecoEditavel" :options="'Brazilian'" class="form-control rounded-pill shadow-xs text-right bg-soft-primary border-primary font-weight-bold" />
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <label class="modal-label-premium">PIS ST</label>
                  <vue-autonumeric v-model="item.VL_PIS_ST" :disabled="somentePrecoEditavel" :options="'Brazilian'" class="form-control rounded-pill shadow-xs text-right bg-soft-primary border-primary font-weight-bold" />
                </b-col>
                <b-col sm="4">
                  <label class="modal-label-premium">COFINS</label>
                  <vue-autonumeric v-model="item.VL_COFINS" :disabled="somentePrecoEditavel" :options="'Brazilian'" class="form-control rounded-pill shadow-xs text-right bg-soft-primary border-primary font-weight-bold" />
                </b-col>
                <b-col sm="4">
                  <label class="modal-label-premium">COFINS ST</label>
                  <vue-autonumeric v-model="item.VL_COFINS_ST" :disabled="somentePrecoEditavel" :options="'Brazilian'" class="form-control rounded-pill shadow-xs text-right bg-soft-info border-info font-weight-bold" />
                </b-col>
              </b-row>
            </div>
           </b-col>

           <b-col md="3">
             <div class="modal-section-title mb-3">
              <i class="fa fa-money mr-2 text-warning"></i> Totais e Estoque
            </div>
            <div class="p-3 bg-white rounded border shadow-xs">
              <b-row class="mb-2">
                <b-col sm="12">
                  <label class="modal-label-premium">Estoque Disponível</label>
                    <vue-autonumeric 
                        ref="edQuant"
                        v-model="estoqueProduto.QUANT" 
                        :disabled="true"
                        :options="{ digitGroupSeparator: '.', decimalCharacter: ',', roundingMethod: 'U', minimumValue: '0' }"
                        class="form-control rounded-pill shadow-xs text-right bg-soft-secondary border-secondary font-weight-bold"
                      />
                </b-col>
               <b-col sm="12">
                  <label class="modal-label-premium">Total do Item</label>
                  <vue-autonumeric 
                    v-model="totalBruto" 
                    :options="'Brazilian'"
                    :disabled="true" 
                    class="form-control rounded-pill shadow-xs text-right bg-soft-success border-success font-weight-bold" />
               </b-col>
            </b-row>
            </div>
           </b-col>
        </b-row>
      </div>

      <div class="modal-footer-premium p-3 bg-light border-top">
        <b-row class="w-100 m-0">
          <b-col class="p-0">
            <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="$refs.modalItem.hide()">
              CANCELAR
            </b-button>
          </b-col>
          <b-col class="p-0 text-right">
            <b-button 
              v-if="!controles.itemAlteracao" 
              variant="success" 
              pill 
              class="px-4 font-weight-bold shadow-sm" 
              @click="postItem()"
            >
              <i class="fa fa-plus-circle mr-1"></i> ADICIONAR AO PEDIDO
            </b-button>
            <b-button 
              v-else 
              variant="primary" 
              pill 
              class="px-4 font-weight-bold shadow-sm" 
              @click="editItem()"
            >
              <i class="fa fa-save mr-1"></i> SALVAR ALTERAÇÕES
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <!--  -----------------------------------------------------------------------------------
                                          MODAL CANCELAMENTO 
            ----------------------------------------------------------------------------------- -->
    <div>
      <b-modal ref="modal-excluir-item" 
          id="modal-excluir-item" 
          hide-header
          body-class="p-0"
          size="lg"
          @shown="focusModaldeleteItem()" 
          headerClass= "p-2 border-bottom-0" 
          title="REMOVER ITEM DA VENDA" >
        <b-overlay :show="cancelamento.parametros.overlayBaixando" 
                    no-wrap 
                    fixed 
                    z-index="1100" 
                    spinner-variant="primary"
                    spinner-type="border">
          <template #overlay>
            <div class="text-center">
              <b-icon icon="stopwatch" font-scale="3" animation="cylon"></b-icon>
              <p>Por favor. Aguarde!!!...</p>
            </div>
          </template>
        </b-overlay>
        <b-card bg-variant="light">
          <div slot="header">
              <i class='fa fa-align-justify'></i><strong>  Remover o Item da compra</strong>
          </div>
          
          <b-row class="mb-1">
            
            <b-col >
              <h5><strong>{{itemExcluir.CODIGO_NOME_PRODUTO}}</strong></h5>
            </b-col>
          </b-row>
          <hr>
          <b-row class="mb-1">
            <b-col cols="12" md="3">
              <label>Quantidade:</label>
            </b-col>
            <b-col cols="12" md="3">
              <strong>{{itemExcluir.QUANT_MASK}}</strong>
            </b-col>
            <b-col cols="12" md="3">
              <label>Peças:</label>
            </b-col>
            <b-col cols="12" md="3">
              <strong>{{itemExcluir.PECAS}}</strong>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col cols="12" md="3">
              <label>Preço:</label>
            </b-col>
            <b-col cols="12" md="3">
              <strong>{{itemExcluir.VL_UNT_MASK}}</strong>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col cols="12" md="3">
              <label>Valor Total:</label>
            </b-col>
            <b-col cols="12" md="3">
              <strong>{{itemExcluir.VL_TOTAL_BRUTO_MASK}}</strong>
            </b-col>
          </b-row>
        </b-card>

        <template #modal-footer="{ cancel }">
          <b-button  variant="success" @click="deleteItem()">
            REMOVER ITEM
          </b-button>
          <b-button    variant="danger" @click="cancel()">
            FECHAR
          </b-button>
        </template>
      </b-modal>
    </div>
    <!-- MODAL VENCIMENTO -->
    <b-modal 
      ref="modal-parcela" 
      id="modal-parcela" 
      hide-header
      body-class="p-0"
      size="sm"
      centered
    >
      <div class="modal-header-premium bg-info text-white p-3">
        <h6 class="mb-0 font-weight-bold"><i class="fa fa-calendar mr-2"></i>Alterar Vencimento</h6>
      </div>
      <div class="p-4">
        <label class="modal-label-premium">Nova Data de Vencimento</label>
        <b-form-input 
          type="date" 
          v-model="parcelamento.item.VENCIMENTO"
          class="rounded-pill shadow-sm"
        />
      </div>
      <template #modal-footer="{ cancel }">
        <b-button variant="soft-danger" pill size="sm" @click="cancel()">CANCELAR</b-button>
        <b-button variant="primary" pill size="sm" class="px-3" @click="editParcela(parcelamento.item)">CONFIRMAR</b-button>
      </template>
    </b-modal>
    <!-- MODAL REABRIR -->
    <b-modal 
      ref="modal-reabrir" 
      id="modal-reabrir" 
      hide-header
      body-class="p-0"
      size="md"
      centered
    >
      <div class="modal-header-premium bg-warning text-dark p-3 d-flex align-items-center">
        <div class="bg-white-20 rounded-circle p-2 mr-3">
          <i class="fa fa-unlock-alt fa-lg"></i>
        </div>
        <div>
          <h5 class="mb-0 font-weight-bold">Reabrir Pedido</h5>
          <small class="opacity-75">O pedido voltará ao status de 'Aberto'</small>
        </div>
      </div>

      <div class="p-4">
        <div class="alert alert-soft-warning border-0 mb-4">
          <i class="fa fa-info-circle mr-2"></i>
          Ao reabrir, as movimentações de estoque e financeiro poderão ser afetadas.
        </div>

        <div class="mb-3">
          <small class="text-muted d-block">Pedido</small>
          <strong class="h5">#{{compra.ID}}</strong>
        </div>

        <label class="modal-label-premium">Motivo da Reabertura</label>
        <b-form-textarea 
          v-model="modalReabrir.motivo"
          placeholder="Descreva o motivo para auditoria (mín. 20 caracteres)..."
          rows="3"
          class="modern-textarea mb-3"
        />
      </div>

      <template #modal-footer="{ cancel }">
        <div class="d-flex gap-2 w-100 justify-content-end p-2">
          <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="cancel()">
            CANCELAR
          </b-button>
          <b-button variant="warning" pill class="px-4 font-weight-bold shadow-sm" @click="reabrir()">
            CONFIRMAR REABERTURA
          </b-button>
        </div>
      </template>
    </b-modal>
    <!-- MODAL VINCULAR NOTA FISCAL -->
    <b-modal 
      ref="modal-nota-fiscal" 
      id="modal-nota-fiscal" 
      hide-header
      hide-footer
      body-class="p-0 overflow-hidden"
      content-class="border-0 shadow-lg"
      dialog-class="modal-custom-width"
      centered
    >
      <div class="modal-header-premium p-3 d-flex align-items-center text-white" 
           style="background: linear-gradient(135deg, #17a2b8 0%, #117a8b 100%) !important;">
        <div class="header-icon-wrapper-modal mr-3">
          <i class="fa fa-cloud-download text-white"></i>
        </div>
        <div>
          <h5 class="mb-0 font-weight-bold">Vincular XML (Sefaz)</h5>
          <small class="text-white opacity-75">Localize e vincule a nota fiscal importada do sistema da Sefaz</small>
        </div>
        <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$refs['modal-nota-fiscal'].hide()">
          <i class="fa fa-times fa-lg"></i>
        </b-button>
      </div>

      <div class="p-3 bg-light border-bottom">
        <b-alert show variant="info" class="border-0 shadow-sm d-flex align-items-center mb-3">
          <i class="fa fa-info-circle fa-2x mr-3"></i>
          <div>
            <strong>Instruções:</strong> Abaixo estão as notas fiscais importadas (distribuição).<br/>
            Para vincular a nota a esta compra, basta <strong>clicar sobre a linha</strong> correspondente.
          </div>
        </b-alert>

        <div class="modal-info-bar bg-white border shadow-sm p-3 rounded mb-0">
          <b-row align-v="center">
            <b-col md="6">
              <small class="modal-label-premium">Pedido de Compra</small>
              <h5 class="mb-0 font-weight-bold text-dark">#{{ compra.ID }}</h5>
            </b-col>
            <b-col md="6" class="border-left">
              <small class="modal-label-premium">Fornecedor da Compra</small>
              <h5 class="mb-0 font-weight-bold text-primary text-truncate">{{ descricaoFornecedorCompra() || 'Nenhum' }}</h5>
            </b-col>
          </b-row>
        </div>
      </div>

      <div class="p-4 bg-light" style="max-height: 60vh; overflow-y: auto;">
        <div class="table-conciliacao-wrapper border rounded bg-white shadow-xs p-2">
          <b-table 
            striped 
            hover 
            show-empty
            empty-text="Nenhuma nota encontrada na distribuição"
            stacked="md"
            small
            select-mode="single"
            selectable
            bordered
            responsive
            sticky-header="450px"
            class="modern-table mb-0 bg-white shadow-sm"
            :items="notaFiscal.items" 
            :fields="notaFiscal.fields"
            @row-clicked="associarNotaFiscal"
          >
            <template #cell(ACOES)="row">
              <b-button variant="soft-info" size="sm" class="rounded-circle" @click.stop="toggleDetalhesNotaFiscal(row)">
                <i :class="row.detailsShowing ? 'fa fa-angle-up' : 'fa fa-angle-down'"></i>
              </b-button>
            </template>

            <template #cell(TIPO_ARQUIVO)="item">
              <b-badge :variant="colorirNotaFiscalTIPO_ARQUIVO(item.item.TIPO_ARQUIVO)" pill class="px-3 py-1 shadow-xs">
                {{ item.item.TIPO_ARQUIVO }}
              </b-badge>
            </template>

            <template #row-details="row">
              <div class="p-3 bg-light border-top border-bottom">
                <div v-if="row.item.loading" class="text-center p-4">
                  <b-spinner small variant="primary" class="mr-2"></b-spinner>
                  <span class="text-muted font-weight-bold">Carregando itens da nota...</span>
                </div>
                <div v-else class="bg-white p-2 rounded shadow-sm border">
                  <b-table 
                    striped 
                    hover 
                    small
                    head-variant="dark"
                    bordered
                    responsive
                    class="modern-table mb-0"
                    :items="row.item.detalhes" 
                    :fields="notaFiscal.fieldsDetalhes"
                  />
                </div>
              </div>
            </template>
          </b-table>
        </div>
      </div>

      <div class="modal-footer-premium p-3 bg-white border-top d-flex justify-content-end">
        <b-button variant="soft-danger" pill class="px-5 font-weight-bold" @click="$refs['modal-nota-fiscal'].hide()">
          FECHAR
        </b-button>
      </div>
    </b-modal>
    <!--  -----------------------------------------------------------------------------------
                                          MODAL NOTA FISCAL
            ----------------------------------------------------------------------------------- -->
    <!-- MODAL CONCILIAR NOTA FISCAL -->
    <b-modal 
      ref="modal-conciliar" 
      id="modal-conciliar" 
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      body-class="p-0 overflow-hidden"
      content-class="border-0 shadow-lg"
      dialog-class="modal-custom-width"
      centered
    >
      <div class="modal-header-premium p-3 d-flex align-items-center text-white" 
           :style="compra.OP_TIPO_PEDIDO === 'A' ? 'background: linear-gradient(135deg, #28a745 0%, #1e7e34 100%) !important;' : 'background: linear-gradient(135deg, #20a8d8 0%, #1783ae 100%) !important;'">
        <div class="header-icon-wrapper-modal mr-3">
          <i class="fa fa-balance-scale text-white"></i>
        </div>
        <div>
          <h5 class="mb-0 font-weight-bold">
            {{ compra.OP_TIPO_PEDIDO === 'A' ? 'Entrada de Estoque via XML' : 'Mapeamento de XML (Indústria)' }}
          </h5>
          <small class="text-white opacity-75">
            {{ compra.OP_TIPO_PEDIDO === 'A' ? 'Vínculo e aceitação direta de estoque' : 'Mapeamento inicial para posterior conferência' }}
          </small>
        </div>
        <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$refs['modal-conciliar'].hide()">
          <i class="fa fa-times fa-lg"></i>
        </b-button>
      </div>

      <div class="p-3 bg-light border-bottom">
        <b-alert show :variant="compra.OP_TIPO_PEDIDO === 'A' ? 'success' : 'info'" class="border-0 shadow-sm d-flex align-items-center mb-3">
          <i class="fa fa-info-circle fa-2x mr-3"></i>
          <div v-if="compra.OP_TIPO_PEDIDO === 'A'">
            <strong>Atenção:</strong> A conciliação para o Almoxarifado indica que o estoque está sendo conferido e aceito. <br/>
            Se necessário, altere o <strong>Fator de Conversão</strong> (ex: A nota veio em 1 Caixa com 10 lápis e você deseja dar entrada nos lápis individualmente, informe Fator 10).
          </div>
          <div v-else>
            <strong>Atenção:</strong> Este procedimento fará apenas o mapeamento dos produtos para a Indústria.<br/>
            A quantidade real recebida será apontada pela doca no momento da <strong>Conferência</strong> física através das etiquetas.
          </div>
        </b-alert>

        <div class="modal-info-bar bg-white border shadow-sm p-3 rounded mb-0">
          <b-row align-v="stretch">
            <b-col md="6" class="d-flex flex-column justify-content-between">
              <div>
                <small class="modal-label-premium">Fornecedor do XML</small>
                <h6 class="mb-1 font-weight-bold text-dark text-truncate">{{ conciliacao.fornecedorXml.nome || 'Não informado' }}</h6>
              </div>
              <small class="text-muted">
                CNPJ: {{ formatarDocumentoFornecedor(conciliacao.fornecedorXml.cnpj) }}
                <span v-if="conciliacao.fornecedorXml.ie"> | IE: {{ conciliacao.fornecedorXml.ie }}</span>
              </small>
            </b-col>
            <b-col md="6" class="border-left d-flex flex-column justify-content-between">
              <div>
                <small class="modal-label-premium">Fornecedor da Compra</small>
                <h6 class="mb-1 font-weight-bold text-primary text-truncate">{{ descricaoFornecedorCompra() }}</h6>
              </div>
              <small class="text-muted">
                ID: {{ compra.FORNECEDOR_ID || 'Não informado' }}
                <span v-if="cliente.CGC"> | CNPJ: {{ formatarDocumentoFornecedor(cliente.CGC) }}</span>
              </small>
            </b-col>
          </b-row>
        </div>
      </div>

      <div class="p-4 bg-light" style="max-height: 55vh; overflow-y: auto;">
        <div class="modal-section-title mb-3">
          <i class="fa fa-list mr-2 text-primary"></i> Itens da Nota Fiscal e Mapeamento
        </div>
        <div class="table-conciliacao-wrapper border rounded bg-white shadow-xs p-2">
          <b-table 
            striped 
            hover 
            show-empty
            empty-text="Nenhum item para conciliar"
            small
            bordered
            sticky-header="400px"
            class="modern-table bg-white mb-0 shadow-sm"
            :tbody-tr-class="rowClassConciliado"
            :items="conciliacao.items" 
            :fields="conciliacao.fields"
          >
            <template #head()="data">
              <span class="text-primary">{{ data.label }}</span>
            </template>
            <template #cell(QUANT_CONFERIDO)="data">
              <vue-autonumeric
                v-model="data.item.QUANT_CONFERIDO"
                class="form-control rounded-pill text-right"
                :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalPlaces: 3, minimumValue: '0', currencySymbol: '' }"
              />
            </template>
            <template #cell(QUANT)="data">
              <vue-autonumeric
                v-model="data.item.QUANT"
                class="form-control rounded-pill text-right"
                :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalPlaces: 3, minimumValue: '0', currencySymbol: '' }"
              />
            </template>
            <template #cell(PRODUTO_VINCULADO)="data">
              <div class="position-relative">
                <produto-pesquisa 
                  v-if="compra.OP_TIPO_PEDIDO === 'I'"
                  @retornaId="onSelecionarProdutoConciliacao(data.item, $event)"
                  :idInicial="data.item.PRODUTO_ID"
                  place="Vincular produto..."
                  :arredondado="true"
                />
                <bens-pesquisa
                  v-if="compra.OP_TIPO_PEDIDO === 'A'"
                  @retornaId="onSelecionarProdutoConciliacao(data.item, $event)"
                  :idInicial="data.item.PRODUTO_ID"
                  place="Vincular material..."
                  :arredondado="true"
                />
              </div>
            </template>
            <template #cell(BOTAO)="data">
              <b-button variant="soft-info" size="sm" class="rounded-circle" @click.stop="abrirModalCopiarProduto(data.item)" v-b-tooltip.hover="'Cadastrar Novo Produto'">
                <i class="fa fa-plus"></i>
              </b-button>
            </template>
          </b-table>
        </div>
      </div>

      <div class="modal-footer-premium p-3 bg-white border-top d-flex justify-content-between">
        <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="$refs['modal-conciliar'].hide()">
          CANCELAR
        </b-button>
        <b-button variant="success" pill class="px-5 font-weight-bold shadow-sm" @click="postConciliar()">
          <i class="fa fa-save mr-2"></i> {{ compra.OP_TIPO_PEDIDO === 'A' ? 'CONFIRMAR ENTRADA' : 'GRAVAR MAPEAMENTO' }}
        </b-button>
      </div>
    </b-modal>

    <!-- MODAL COPIAR PRODUTO -->
    <b-modal 
      ref="modal-copiar-produto" 
      id="modal-copiar-produto" 
      hide-header
      body-class="p-0"
      size="lg"
      centered
    >
      <div class="modal-header-premium bg-info text-white p-3">
        <h5 class="mb-0 font-weight-bold"><i class="fa fa-copy mr-2"></i>Cadastrar Novo via Cópia</h5>
      </div>

      <div class="p-4 bg-light">
        <div class="alert alert-info border-0 mb-4">
          <small class="d-block text-uppercase font-weight-bold mb-1">Produto no XML:</small>
          <h6 class="mb-0">{{ conciliacao.nomeProdutoXML }}</h6>
        </div>

        <div class="modern-input-group mb-4">
          <label class="modal-label-premium">Nome do Novo Produto</label>
          <b-form-input 
            v-model="conciliacao.nomeProdutoACopiar"
            placeholder="Digite o nome como será gravado no sistema..."
            class="rounded-pill shadow-sm"
          />
        </div>

        <div class="modern-input-group">
          <label v-if="compra.OP_TIPO_PEDIDO === 'I'" class="modal-label-premium">Produto Base para Cópia</label>
          <produto-pesquisa 
            v-if="compra.OP_TIPO_PEDIDO === 'I'"
            @retornaId="conciliacao.produtoCopiadoId = $event"
            :idInicial="conciliacao.produtoCopiadoId"
            label="Selecione um produto similar para copiar as configurações"
            :arredondado="true"
          />
          <label v-if="compra.OP_TIPO_PEDIDO === 'A'" class="modal-label-premium">Material Base para Cópia</label>
          <bens-pesquisa
            v-if="compra.OP_TIPO_PEDIDO === 'A'"
            @retornaId="conciliacao.produtoCopiadoId = $event"
            :idInicial="conciliacao.produtoCopiadoId"
            label="Selecione um material similar para copiar as configurações"
            :arredondado="true"
          />
        </div>
      </div>

      <template #modal-footer="{ cancel }">
        <div class="d-flex gap-2 w-100 justify-content-end p-2">
          <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="cancel()">CANCELAR</b-button>
          <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm" @click="copiarProdutoConciliacao()">
            <i class="fa fa-check mr-2"></i>CRIAR E VINCULAR
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- MODAL CANCELAR FINANCEIRO -->
    <b-modal
      ref="modal-cancelar-financeiro"
      id="modal-cancelar-financeiro"
      hide-header
      body-class="p-0"
      size="md"
      centered
      no-close-on-esc
      no-close-on-backdrop
    >
      <div class="modal-header-premium bg-danger text-white p-3 d-flex align-items-center">
        <div class="bg-white-20 rounded-circle p-2 mr-3">
          <i class="fa fa-ban fa-lg"></i>
        </div>
        <div>
          <h5 class="mb-0 font-weight-bold">Cancelar Financeiro</h5>
          <small class="opacity-75">Esta operação irá estornar os títulos gerados</small>
        </div>
      </div>

      <div class="p-4">
        <div class="alert alert-danger border-0 mb-4">
          <i class="fa fa-exclamation-triangle mr-2"></i>
          Atenção! Os títulos a pagar gerados para este pedido serão excluídos.
        </div>

        <b-row class="mb-3">
          <b-col md="12">
            <div class="d-flex justify-content-between align-items-center p-3 rounded bg-light border mb-2">
              <span class="text-muted">Fornecedor</span>
              <strong>{{ cliente.NOME }}</strong>
            </div>
            <div class="d-flex justify-content-between align-items-center p-3 rounded bg-light border mb-2">
              <span class="text-muted">Documento</span>
              <strong>{{ compra.NUMERO_EXTERNO }}</strong>
            </div>
            <div class="d-flex justify-content-between align-items-center p-3 rounded bg-light border mb-2">
              <span class="text-muted">Valor do Pedido</span>
              <strong class="text-danger">{{ Number(compra.VL_PEDIDO || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</strong>
            </div>
            <div class="d-flex justify-content-between align-items-center p-3 rounded bg-light border">
              <span class="text-muted">Parcelas</span>
              <strong>{{ parcelamento.items.length }}</strong>
            </div>
          </b-col>
        </b-row>

        <label class="modal-label-premium">Motivo do Cancelamento <small class="text-danger">(mín. 10 caracteres)</small></label>
        <b-form-textarea
          v-model="modalCancelarFinanceiro.motivo"
          placeholder="Descreva o motivo do cancelamento financeiro..."
          rows="3"
          class="modern-textarea"
          :state="modalCancelarFinanceiro.motivo && modalCancelarFinanceiro.motivo.length >= 10 ? true : (modalCancelarFinanceiro.motivo && modalCancelarFinanceiro.motivo.length > 0 ? false : null)"
        />
        <small v-if="modalCancelarFinanceiro.motivo" class="text-muted">
          {{ modalCancelarFinanceiro.motivo.length }} caracteres
        </small>
      </div>

      <template #modal-footer="{ cancel }">
        <div class="d-flex gap-2 w-100 justify-content-end p-2">
          <b-button variant="soft-secondary" pill class="px-4 font-weight-bold" @click="cancel()">FECHAR</b-button>
          <b-button
            variant="danger"
            pill
            class="px-4 font-weight-bold shadow-sm"
            :disabled="!modalCancelarFinanceiro.motivo || modalCancelarFinanceiro.motivo.length < 10"
            @click="cancelarFinanceiro()"
          >
            <i class="fa fa-ban mr-2"></i>CONFIRMAR CANCELAMENTO
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- MODAL IMPORTAR XML -->
    <CompraImportarXML 
      ref="modalImportarXML" 
      :compra="compra"
      @importacao-concluida="onImportacaoXMLConcluida"
    />
  </div>
</template>

<script>
import VendedorPesquisa from '../../pesquisa/VendedorPesquisa.vue'
import ClientePesquisa from '../../pesquisa/ClientePesquisa.vue'
import ProdutoPesquisa from '../../pesquisa/ProdutoPesquisa.vue'
import BensPesquisa from '../../pesquisa/BensPesquisa.vue'
import HistoricoPesquisa from '../../pesquisa/HistoricoPesquisa.vue'

import FuncionarioDropdown from '../../componentes/dropdown/FuncionarioDropdown.vue'
import TransportadoraDropDown from '../../componentes/dropdown/TransportadoraDropDown.vue'
import CentroEstoqueDropDown from '../../componentes/dropdown/CentroEstoqueDropDown.vue'
import CentroEstoqueAlmoxarifadoDropDown from '../../componentes/dropdown/CentroEstoqueAlmoxarifadoDropDown.vue'
import EmpresaDropDown from '../../componentes/dropdown/EmpresaDropDown.vue'
import GrupoApagarDropDown from '../../componentes/dropdown/GrupoApagarDropDown.vue'
import CentroCustoDropDown from '../../componentes/dropdown/CentroCustoDropDown.vue'

import VueAutonumeric from 'vue-autonumeric'
import moment from 'moment'
import Tools from '@/tools/tools.js'
import { imprimirEspelhoCompra } from '@/utils/RelatorioCompraHTML.js'
import { Callout } from '../../../components'
import CecInputData from '@/components/Cec/CecInputData.vue'
import HeaderPadrao from '@/components/Cec/HeaderPadrao.vue'
import CompraImportarXML from '@/modals/CompraImportarXML.vue'
import CompraConferenciaReport from '@/utils/reports/CompraConferenciaReport'

export default {
  components: {
    Callout,
    VendedorPesquisa,
    ClientePesquisa,
    ProdutoPesquisa,
    BensPesquisa,
    HistoricoPesquisa,
    VueAutonumeric,
    FuncionarioDropdown,
    TransportadoraDropDown,
    CentroEstoqueDropDown,
    CentroEstoqueAlmoxarifadoDropDown,
    EmpresaDropDown,
    GrupoApagarDropDown,
    CentroCustoDropDown,
    CecInputData,
    HeaderPadrao,
    CompraImportarXML
  },
  data () {
    return {
      tabIndex: 0,
      tabIndexItem: 0,
      precoTabelado: false,
      compraIdEditar: null,
      diasIniciarPagamento: null,
      empresas: {
        id: null,
        items : [],
        options: [
          { value: null, text: '' }
        ]
      },
      tipoMovimentacoes : {
        selected: null,
        options: null,
        items: []
      },
      conciliacao: {
         edNumero: 0,
         edCFOPTraducao: '',
         edChave: '',
         edDtEntrada: null,
         edDTEmissao: null,
         edRazaoXML: '',
         edCNPJXML: '',
         edIEXML: '',
         edEnderecoXML: '',
         edUFXML: '',
         edPIS_BASE: 0.00,
         edPIS: 0.00,
         edCOFINS_BASE: 0.00,
         edCOFINS: 0.00,
         edBaseIPI: 0.00,
         edIPI: 0.00,
         edICMS_ST_BASE: 0.00,
         edICMS_ST: 0.00,
         edBaseICMS: 0.00,
         edICMS: 0.00,
         edOutros: 0.00,
         edFrete: 0.00,
         edDespesas: 0.00,
         edSeguro: 0.00,
         edDesconto: 0.00,
         edProdutos: 0.00,
         edTotal: 0.00,
         produtoCopiadoId: null,
         nomeProdutoACopiar : null,
         nomeProdutoXML: null,
         registroCopiarProduto: null,
         fornecedorXml: {
           nome: null,
           cnpj: null,
           ie: null
         },
         
         items: [],
         fields: [
          {
            key: "CODIGO",
            class:'align-middle text-center p-0',
            thStyle: { width: "5%" },
            label: 'ID'
          },
          {
            key: "PRODUTO",
            class:'align-middle text-left p-0',
            thStyle: { width: "20%" },
            label: 'Produto'
          },
          {
            key: "PRODUTO_VINCULADO",
            class:'align-middle  p-0',
            thStyle: { width: "20%" },
            label: 'Vinculado'
          },
          {
            key: "BOTAO",
            class:'align-middle text-center p-0',
            label: '',
            thStyle: { width: "3%" }
          },
          {
            key: "QUANT_NFE",
            class:'align-middle text-right p-0',
            label: 'Quant NFE',
            thStyle: { width: "10%" },
            class:'text-right', 
            formatter: (value, key, item) => 
                value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0.00
          },
          {
            key: "QUANT_CONFERIDO",
            label: 'Quant Confe',
            class:'align-middle text-right p-0',
            
            thStyle: { width: "10%" },
            formatter: (value, key, item) => 
                value && value > 0.00 ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0.00
          },
          {
            key: "QUANT",
            label: 'Unidades',
            thStyle: { width: "8%" },
            class:'align-middle text-right p-0',
            formatter: (value, key, item) => 
                value && value > 0.00 ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0.00
          },
          {
            key: 'VL_UNT', 
            class:'align-middle text-right p-0',
            thStyle: { width: "10%" },
            label: 'Preço',
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
          },
          {
            key: 'VL_VENDA', 
            class:'align-middle text-right p-0',
            thStyle: { width: "10%" },
            label: 'Total',
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
          }
        ]

      },
      notaFiscal: {
        loadding: false,
        items: [],
        fields: [
          {
            key: "ACOES",
            class:'align-middle text-center p-0',
            label: '',
            thStyle: { width: "20%" }
          },
          {
            key: "TIPO_ARQUIVO",
            class:'align-middle text-center p-0',
            label: 'Tipo'
          },
          {
            key: "CNPJ_DESTINATARIO",
            label: 'Destinatário'
          },
          {
            key: "CHAVE_ACESSO",
            label: 'Chave'
          },
          {
            key: "CNPJ",
            label: 'Emissor'
          },
          {
            key: "FORNECEDOR",
            label: 'Fornecedor'
          },
          {
            key: "DATA_CONSULTA_NSE",
            label: 'Consulta', 
            sortable: true,
            formatter: (value, key, item) => 
              value ? moment(String(value)).format('DD/MM/YYYY') : null
          },
          {
            key: "NSU",
            label: 'NSU'
          },
          {
            key: 'VALOR', 
            class:'text-right', 
            label: 'Valor (R$)',
            formatter: (value, key, item) => 
                value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
          },
          {
            key: "DATA_NFE",
            label: 'Data', 
            sortable: true,
            formatter: (value, key, item) => 
              value ? moment(String(value)).format('DD/MM/YYYY') : null
          },
          {
            key: "CFOP",
            label: 'CFOP'
          },
          {
            key: "VENDA_ID",
            label: 'PréFatura'
          }
        ],
        fieldsDetalhes: [
          {
            key: "CODIGO_PRODUTO",
            label: 'Produto ID'
          },
          {
            key: "PRODUTO",
            label: 'Nome Produto'
          },
          {
            key: "EAN",
            label: 'Barras'
          },
          {
            key: "UND",
            label: 'UND'
          },
          {
            key: "QUANT",
            label: 'Quantidade',
            class:'text-right', 
            formatter: (value, key, item) => 
                value && value > 0.00 ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0.00
          },
          {
            key: 'VL_UNT', 
            class:'text-right', 
            label: 'Preço (R$)',
            formatter: (value, key, item) => 
                value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
          },
          {
            key: 'VL_TOTAL', 
            class:'text-right', 
            label: 'Total (R$)',
            formatter: (value, key, item) => 
                value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
          }
        ]

        

      },
      despesas: {
        edMovimentoCredito: 0,
        edMovimentoDebito: 0,
        edAreceberGerados: 0,
        edApagarGerados: 0,
        edAreceberAberto: 0,
        edAPagarAberto: 0,
        edDespesa: 0,
        modal: {
          nomeFornecedor: null,
          tipoMovimento: null,
          fechada: null,
        },
        item: {
          ID                 : null,
          PEDIDO_COMPRA_ID   : null,
          HISTORICO_ID       : null,
          OP_TIPO_MOVIMENTO  : null,
          VALOR              : null,
          OBSERVACOES        : null,
          USUARIO_CADASTRO   : null,
          DATA_CADASTRO      : null,
          USUARIO_EXCLUSAO   : null,
          DATA_EXCLUSAO      : null,
          DATA_MOVIMENTACAO  : null,
          DATA_PAGAMENTO     : null,
          DOCUMENTO          : null,
          TIPO_PAGAMENTO_ID  : null,
          USUARIO_ALTERACAO  : null,
          DATA_ALTERACAO     : null,
          OP_STATUS          : null,
          OP_GERA_TITULO     : null,
          APAGAR_ID          : null,
          ARECEBER_ID        : null,
          CENTRO_CUSTO_ID    : null,
          USUARIO_GERACAO    : null,
          DATA_GERACAO       : null,
          CLIENTE_ID         : null,
          DATA_VENCIMENTO    : null,
          OP_DESPESA         : null,
        },
        tipoPagamento:{
          items:[]
        },
        items: [],
        fields: [
          {
            key: "OP_GERA_TITULO",
            class:'align-middle text-center p-0',
            label: 'GERA'
          },
          {
            key: "DOCUMENTO",
            label: 'Documento'
          },
          {
            key: "NOME_CLIENTE",
            label: 'Cliente/Fornecedor'
          },
          {
            key: "OP_DESPESA",
            class:'align-middle text-center p-0',
            label: 'Despesa'
          },
          {
            key: 'VALOR', 
            class:'text-right', 
            label: 'Valor (R$)',
            formatter: (value, key, item) => 
                value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
          },
          {
            key: "DESCRICAO",
            label: 'Historico'
          },
          {
            key: "DATA_MOVIMENTACAO",
            label: 'Data', 
            sortable: true,
            formatter: (value, key, item) => 
              value ? moment(String(value)).format('DD/MM/YYYY') : null
          },
          {
            key: "OBSERVACOES",
            label: 'Observações'
          },
          
          {
            key: "actions" ,
            class:'align-middle text-center p-0',
            label: 'Ações' 
          }
        ]
      },
      lotes: {
        modal: {
          item: null,
          loading: false,
          saving: false,
        },
        item: {
          ID                  : null,
          PEDIDO_COMPRA_ID    : null,
          PEDIDO_COMPRA_ITEM_ID: null,
          PRODUTO_ID          : null,
          CENTRO_ESTOQUE_ID   : null,
          LOTE                : null,
          LOTE_FORNECEDOR     : null,
          DATA_FABRICACAO     : null,
          DATA_VALIDADE       : null,
          QUANTIDADE          : 0.00,
          PECAS               : 0,
          VL_CUSTO_UNITARIO   : 0.00,
          VL_CUSTO_TOTAL      : 0.00,
          OP_STATUS           : '1',
          USUARIO_CADASTRO    : null,
          USUARIO_ALTERACAO   : null,
          DATA_CADASTRO       : null,
          DATA_ALTERACAO      : null,
          OBSERVACAO          : null,
        },
        items: [],
        fields: [
          {
            key: 'LOTE',
            label: 'Lote Interno'
          },
          {
            key: 'LOTE_FORNECEDOR',
            label: 'Lote Fornecedor'
          },
          {
            key: 'DATA_FABRICACAO',
            label: 'Fabricação',
            formatter: value => value ? moment(String(value)).format('DD/MM/YYYY') : null
          },
          {
            key: 'DATA_VALIDADE',
            label: 'Validade',
            formatter: value => value ? moment(String(value)).format('DD/MM/YYYY') : null
          },
          {
            key: 'QUANTIDADE',
            label: 'Quantidade',
            class: 'text-right',
            formatter: value => Number(value || 0).toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 3 })
          },
          {
            key: 'PECAS',
            label: 'Peças',
            class: 'text-right',
            formatter: value => Number(value || 0).toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 0 })
          },
          {
            key: 'VL_CUSTO_UNITARIO',
            label: 'Custo Unit.',
            class: 'text-right',
            formatter: value => Number(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 3, maximumFractionDigits: 3 })
          },
          {
            key: 'VL_CUSTO_TOTAL',
            label: 'Custo Total',
            class: 'text-right',
            formatter: value => Number(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          },
          {
            key: 'OBSERVACAO',
            label: 'Observação'
          },
          {
            key: 'actions',
            label: 'Ações',
            class: 'text-center p-0'
          }
        ]
      },
      controles: {
        montagemTelaConcluida : false,
        compraAlteracao: false,
        compraReaberta: false,
        fechada: false,
        falhaNaAbertura: false,
        itemAlteracao: false,
        montandoItem: false,
        carregandoDados: false,
        situacaoCliente : 'Cliente',
        OP_ICMS_SITUACAO_TRIBUTARIA: null,
        PRODUTO_ID: null,
        botaoGerarDocumento: {
          value: 'Some value',
          busy: false,
          clicou: false
        }
      },
      cliente: {
        CODIGO: null,
        NOME: null,
        RAZAOSOCIAL: null,
        ID_UF: null,
        FIZ_JUR: null,
        ISENTO_ICMS: null,
        COD_VEND: null,
        CGC: null,
        VL_CREDITO: 0.00,
        LIMITE_CREDITO: 0.00,
        NOTAS_EM_ABERTO: 0,
        PRAZO: null,
        TIPO_CLI: null,
        GRUPO_ARECEBER_ID: null
      },
      compra: {
        ID                            : null,
        DT_PEDIDO                     : null,
        DT_CHEGADA_PREVISTA           : null,
        OP_TIPO_PEDIDO                : null,
        CLIENTE_ID                    : null,
        VL_PEDIDO                     : null,
        NR_DIAS_PAGAMENTO             : null,
        VENDEDOR_ID                   : null,
        FORNECEDOR_ID                 : null,
        DT_ENVIO                      : null,
        DT_EMBARQUE                   : null,
        TX_USUARIO_INC                : null,
        TX_USUARIO_ALT                : null,
        DT_ALTERACAO                  : null,
        VL_ICMS                       : null,
        VL_PIS                        : null,
        VL_COFINS                     : null,
        VL_IPI                        : null,
        VL_II                         : null,
        VL_FRETE                      : null,
        VL_OUTROS                     : null,
        NR_PESO_BRUTO                 : null,
        NR_PESO_LIQUIDO               : null,
        DT_CHEGADA_EFETIVA            : null,
        DT_CHEGADA_NECESSARIA         : null,
        OP_INCOTERMS                  : null,
        OB_GERAIS                     : null,
        OP_STATUS                     : null,
        DT_CADASTRO                   : null,
        VL_SEGURO                     : null,
        COMPRADOR_ID                  : null,
        VL_DESCONTO_IMPOSTO           : null,
        TRANSPORTADORA_ID             : null,
        VL_CIF                        : null,
        VL_FOB                        : null,
        QT_PECAS                      : null,
        OP_FORMA_PAGAMENTO            : null,
        OP_PARCELAMENTO               : null,
        DT_ENTREGA_PREVISTA           : null,
        DT_ENTREGA_EFETIVA            : null,
        VL_TOTAL_DESCONTO             : null,
        EMBARQUE_REPRESENTA_ID        : null,
        VL_CREDITO                    : null,
        VL_DEBITO                     : null,
        DT_PREVISAO_CARREGAMENTO      : null,
        DT_PREVISAO_CHEGADA_PORTO     : null,
        DT_PREVISAO_CEHGADA_PORTO     : null,
        DT_PREVISAO_SAIDA_PORTO       : null,
        DT_DESCARREGAMENTO_DESTINO    : null,
        DT_SAIDA_PORTO                : null,
        DT_CHEGADA_PORTO              : null,
        DT_CARREGAMENTO_ORIGEM        : null,
        NOTA_FISCAL                   : null,
        OP_EMBARCADO                  : null,
        CENTRO_ESTOQUE_ID             : null,
        NFE_DISTRIBUICAO_ID           : null,
        GRUPO_APAGAR_ID               : null,
        CENTRO_CUSTO_ID               : null,
        OP_FINANCEIRO                 : null,
        OP_XML                        : null,
        OP_CONCLUIR_SEM_NOTA          : null,
        RECEPCAO_ID                   : null,
        USUARIO_DIVERGENCIA           : null,
        DATA_AUTORIZA_DIVERGENCIA     : null,
        OP_RECEPCAO                   : null,
        USUARIO_FECHAMENTO            : null,
        DATA_FECHAMENTO               : null,
        EMPRESA_ID                    : null,
        OP_CONCLUIR_SEM_RECEPCAO      : null,
        CONFERENTE_ID                 : null,
        DT_CONFERENCIA_INICIO         : null,
        DT_CONFERENCIA_FIM            : null,
        USUARIO_CONFERENCIA           : null,
        USUARIO_REABERTURA            : null,
        DT_SOLICITA_CONFERENCIA       : null,
        USUARIO_SOLICITA_CONFERENCIA  : null,
        PLACA                         : null,
        MSG_SEFAZ                     : null,
        DATA_CONFIRMACAO              : null,
        PROTOCOLO                     : null,
        DATA_REABERTURA               : null,
        MOTIVO_REABERTURA             : null,
        TEMPERATURA_INICIAL           : null,
        TEMPERATURA_MEIO              : null,
        TEMPERATURA_FINAL             : null,
        NOME_ARQUIVO_CARGA_XML        : null,
        DATA_CARGA_XML                : null,
        USUARIO_CARGA_XML             : null,
        OP_CARGA_XML                  : null,
        NUMERO_EXTERNO                : null,
        OP_GERA_ESTOQUE               : null,
        USUARIO_CANCELAMENTO          : null,
        OBS_CANCELAMENTO              : null,
        DATA_CANCELAMENTO             : null,
        DT_PREVISAO_DESCARREGAMENTO   : null,
        VL_TOTAL_DESPESA              : null,
        USUARIO_LIBERA_DEVOLUCAO      : null,
        DATA_LIBERA_DEVOLUCAO         : null,
        MOTIVO_LIBERA_DEVOLUCAO       : null,
      },
      tabelaPreco:{
        selected: null,
        options:[]
      },
      itemExcluir: {
        ID: null,
        PRODUTO_ID: null,
        COD_CENTRO: null,
        CODIGO_NOME_PRODUTO: '',
        QUANT: 0.00,
        PECAS: 0,
        TX_UNIDADE_COMERCIAL: '',
        VL_UNT: 0.00,
        VL_DESCONTO: 0.00,
        VL_TOTAL: 0.00
      },
      cancelamento: {
        parametros: {
          overlayBaixando: false,
          processando: false,
          busy: false
        }
      },
      modalReabrir: {
        motivo: null,
        valorPedido: 0.00,
        parametros: {
          overlayBaixando: false,
          processando: false,
          busy: false,
        }
      },
      modalCancelarFinanceiro: {
        motivo: null,
      },
      parametros: {},
      item: {
        ID                 : null,
        PEDIDO_COMPRA_ID   : null,
        PRODUTO_ID         : null,
        ID_UNIDADE_COMERCIAL: null,
        TX_NOME_PRODUTO    : null,
        TX_NCM             : null,
        EAN                : null,
        QT_PECAS           : null,
        VL_ICMS            : null,
        VL_PIS             : null,
        VL_COFINS          : null,
        VL_IBS             : null,
        VL_CBS             : null,
        VL_IS              : null,
        VL_IPI             : null,
        VL_II              : null,
        VL_UNITARIO_FOB    : null,
        VL_FRETE           : null,
        VL_OUTROS          : null,
        NR_PESO_BRUTO      : null,
        NR_PESO_LIQUIDO    : null,
        VL_TOTAL_CIF       : null,
        VL_TOTAL_FOB       : null,
        VL_UNITARIO_CIF    : null,
        USUARIO_CADASTRO   : null,
        USUARIO_ALTERACAO  : null,
        DATA_CADASTRO      : null,
        DATA_ALTERACAO     : null,
        USUARIO_EXCLUSAO   : null,
        DATA_EXCLUSAO      : null,
        OP_STATUS          : null,
        QUANT_NFE          : null,
        PECAS_NFE          : null,
        VL_UNT_NFE         : null,
        VL_TOTAL_NFE       : null,
        CENTRO_ESTOQUE_ID  : null,
        PECAS_CONFERENCIA  : null,
        QUANT_CONFERENCIA  : null,
        VL_ICMS_ST         : null,
        VL_PIS_ST          : null,
        VL_COFINS_ST        : null,
        OP_CONTROLA_LOTE   : '0',
        OP_MATERIA_PRIMA   : '0',
        OP_IMPORTADO       : '0'

      },
      pesagem: {
        peso: 0.00,
        manual: false,
        fields: [
          { key: 'ID', stickyColumn: true, isRowHeader: true, variant: 'primary' },
          {key: 'COL1',
            formatter: (value, key, item) => 
                typeof value === 'number' ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3, maximumFractionDigits: 3}) : null
          },
          {key: 'COL2',
            formatter: (value, key, item) => 
                typeof value === 'number' ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3, maximumFractionDigits: 3}) : null
          },
          {key: 'COL3',
            formatter: (value, key, item) => 
                typeof value === 'number' ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3, maximumFractionDigits: 3}) : null
          },
          {key: 'COL4',
            formatter: (value, key, item) => 
                typeof value === 'number' ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3, maximumFractionDigits: 3}) : null
          },
          {key: 'COL5',
            formatter: (value, key, item) => 
                typeof value === 'number' ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3, maximumFractionDigits: 3}) : null
          },
          {key: 'COL6',
            formatter: (value, key, item) => 
                typeof value === 'number' ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3, maximumFractionDigits: 3}) : null
          },
          {key: 'COL7',
            formatter: (value, key, item) => 
                typeof value === 'number' ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3, maximumFractionDigits: 3}) : null
          },
          {key: 'COL8',
            formatter: (value, key, item) => 
                typeof value === 'number' ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3, maximumFractionDigits: 3}) : null
          },
          {key: 'COL9',
            formatter: (value, key, item) => 
                typeof value === 'number' ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3, maximumFractionDigits: 3}) : null
          },
          {key: 'COL10',
            formatter: (value, key, item) => 
                typeof value === 'number' ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3, maximumFractionDigits: 3}) : null
          },
        ],
        items:[]
      },
      optionsOP_RECEPCAO: [
        { value: '0', text: 'NAO SOLICITADO' },
        { value: '1', text: 'CONF ABERTA' },
        { value: '2', text: 'EM CONFERENCIA' },
        { value: '3', text: 'CONFERIDO' },
      ],
      optionsOP_FINANCEIRO: [
        { value: '0', text: 'ABERTO' },
        { value: '1', text: 'FECHADO' },
        { value: '2', text: 'NÃO GERA' },
      ],
      optionsOP_STATUS: [
        { value: '0', text: 'CANCELADO' },
        { value: '1', text: 'CADASTRANDO' },
        { value: '2', text: 'CONCLUIDO'}
      ],
      optionsOP_CARGA_XML: [
        { value: null, text: 'Sem XML' },
        { value: '1', text: 'Sem XML' },
        { value: '1', text: 'XML Carregado' },
      ],
      optionsOP_FORMA_PAGAMENTO: [
        {value: null, text:  '' },
        {value: '00', text: 'Boleto' },
        {value: '01', text: 'Espécie' },
        {value: '02', text: 'Depósito' },
        {value: '03', text: 'Cheque' },
        {value: '04', text: 'Duplicata' },
        {value: '05', text: 'PIX' },
        {value: '06', text: 'CARTAO' },
        {value: '09', text: 'NENHUM' },
      ],
      optionsOP_TIPO_PEDIDO: [
        { value: 'I', text: 'Industria/Comércio' },
        { value: 'A', text: 'Almoxarifado' },
      ],
      optionsOP_GERA_ESTOQUE: [
        { value: 'S', text: 'Sim' },
        { value: 'N', text: 'Não' },
      ],
      optionsOP_INCOTERMS: [
        { value: 'FOB', text: 'FOB - Frete a Bordo' },
        { value: 'CIF', text: 'CIF- Custo, Seguro e Frete' },
      ],
      optionsOP_XML: [
        { value: '0', text: 'Não vinculada' },
        { value: '1', text: 'Divergente' },
        { value: '2', text: 'Vinculada'},
        { value: '3', text: 'Confirmada Sefaz'}
      ],
      
      
      parcelasVezes: [],
      dias:[],
      parcelamento: {
        item: {
          ID: null,
          PEDIDO_COMPRA_ID: null,
          PARCELA: null,
          VENCIMENTO: null,
          JUROS: null,
          VALOR: null
        },
        fields: [
          {
            key: "PARCELA",
            label: 'Parcela'
          },
          {
            key: 'VENCIMENTO',
            label: 'Vencimento',
            class:'text-center', 
            formatter: (value, key, item) => 
              moment(value).format("DD/MM/YYYY")
          },
          {
            key: 'VALOR', 
            class:'text-right', 
            label: 'Valor (R$)',
            formatter: (value, key, item) => 
                value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
          }
        ],
        items: []
      },
      estoqueProduto: {
        options: [],
        QUANT: 0.00,
        PECAS: 0,
      },
      conferencia: {
        items: [],
        loading: false,
        fields: [
          {
            key: "PRODUTO_ID",
            label: 'ID'
          },
          {
            key: "DESCRICAO",
            label: 'Produto'
          },
          {
            key: 'PECAS_PEDIDO', 
            class:'text-right', 
            label: 'Volumes CX Pedido', 
            formatter: (value, key, item) => 
                value && value > 0.00 ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2}) : 0.00
          },
          {
            key: 'PECAS_RECEPCAO', 
            class:'text-right', 
            label: 'Peças Conferido', 
            formatter: (value, key, item) => 
                value && value > 0.00 ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2}) : 0.00
          },
          {
            key: 'PECAS_DIFERENCA', 
            class:'text-right', 
            label: 'Peças Diferença'
          },
          {
            key: 'QUANT_PEDIDO', 
            class:'text-right', 
            label: 'Peso Pedido', 
            formatter: (value, key, item) => 
               value && value > 0.00 ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2}) : 0.00
          },
          {
            key: 'QUANT_RECEPCAO', 
            class:'text-right', 
            label: 'Peso Conferido', 
            formatter: (value, key, item) => 
               value && value > 0.00 ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2}) : 0.00
          },
          {
            key: 'QUANT_DIFERENCA', 
            class:'text-right', 
            label: 'Peso Diferença'
          }
        ]
      },
      tabelaItens: {
        fields: [
          {
            key: "PRODUTO_ID",
            label: 'ID'
          },
          {
            key: "NOME_PRODUTO",
            label: 'Produto'
          },
          {
            key: "LANCOU_ROMANEIO",
            class: "text-center",
            label: 'R'
          },
          {
            key: "NR_PESO_BRUTO",
            label: 'Quantidade',
            class:'text-right', 
            formatter: (value, key, item) => 
                value && value > 0.00 ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0.00
          },
          {
            key: 'QT_PECAS', 
            class:'text-right', 
            label: 'Volumes', 
            formatter: (value, key, item) => 
                value && value > 0.00 ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2}) : 0.00
          },
          {
            key: 'QUANT_NFE', 
            class:'text-right', 
            label: 'Quant NFE Almox', 
            formatter: (value, key, item) => 
               value && value > 0.00 ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2}) : 0.00
          },
          {
            key: 'VL_UNITARIO_FOB', 
            class:'text-right', 
            label: 'FOB R$', 
            formatter: (value, key, item) => 
                value && value > 0.00 ?  value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL', minimumFractionDigits: 3, maximumFractionDigits: 3}) : 0.000
          },
          {
            key: 'VL_TOTAL_FOB', 
            class:'text-right', 
            label: 'Total FOB R$', 
            formatter: (value, key, item) => 
                value && value > 0.00 ?  value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
          },
          
          {
            key: "actions" ,
            class:'text-center p-0',
            label: 'Ações' 
          }
        ],
        items: []
      },
      produto: {
        id: null,
        quantidade : 0.00,
        pecas : 0,
        valor: 0.00,
        total: 0.00
      },
      modalItem:{
        overlayBaixando: false,
        icms: {
          opTipoSituacaoTributariaSimples: [
            { value : '00', text : 'ICMS 00 -Tributada Integralmente'},
            { value : '10', text : 'ICMS 10 - Tributada com cobrança do ICMS por Substituição Tributária'},
            { value : '20', text : 'ICMS 20 - Com redução na base de cálculo'},
            { value : '30', text : 'ICMS 30 - Isenta ou não tributada com cobrança do ICMS por substituição tributária'},
            { value : '40', text : 'ICMS 40 - Isenta'},
            { value : '41', text : 'ICMS 41 - Não tributada'},
            { value : '50', text : 'ICMS 50 - Suspensão'},
            { value : '51', text : 'ICMS 51 - Diferimento'},
            { value : '60', text : 'ICMS 60 - Cobrado anteriormente por substiruição tributária'},
            { value : '70', text : 'ICMS 70 - Com redução da base de cálculo e cobrança do ICMS por substituição tributária'},
            { value : '90', text : 'ICMS 90 - Outras'},
          ],
          opTipoSituacaoTributariaNormal: [
            { value: '101', text: 'ICMS 101 - Tributada com permissão de crédito'},
            { value: '102', text: 'ICMS 102 - Trib utada sem permissão de crédito'},
            { value: '103', text: 'ICMS 103 - Isenção do ICMS para faixa de receita bruta'},
            { value: '201', text: 'ICMS 201 - Tributada com permissão de crédito e com cobrança do ICMS por ST'},
            { value: '202', text: 'ICMS 202 - Tributada sem permissão de crédito e com cobrança do ICMS por ST'},
            { value: '203', text: 'ICMS 203 - Isenção do ICMS para faixa de receita bruta e com cobrança do ICMS por ST'},
            { value: '300', text: 'ICMS 300 - Imune'},
            { value: '400', text: 'ICMS 400 - Não tributada'},
            { value: '500', text: 'ICMS 500 - ICMS cobrado anteriormente por ST ou por antecipação'},
            { value: '900', text: 'ICMS 900 - Outros'}
          ],
          opOrigemMercadoria: [
            { value: '0', text: 'Nacional'},
            { value: '1', text: 'Extrangeira - Importação Direta'},
            { value: '2', text: 'Extrangeira - Adquirida no Mercado Interno'},
          ],
          opModalidade: [
            { value: '0', text: 'Margem Valor Agregado'},
            { value: '1', text: 'Pauta Valor'},
            { value: '2', text: 'Preço tabelado Max. Valor'},
            { value: '3', text: 'Valor da Operação'},
          ],
          opMotivoDesoneracao: [
            { value: '', text: ''},
            { value: '1', text: 'Taxi'},
            { value: '2', text: 'Deficiente Fisico'},
            { value: '3', text: 'Produto Agropecuário'},
            { value: '4', text: 'Frotista/Locadora'},
            { value: '5', text: 'Diplomata/Consultor'},
            { value: '9', text: 'Outros'},
            { value: '6', text: 'Utilit. e Motoc. da Amazônia Ocidental'},
            { value: '7', text: 'SUFRAMA'},
          ],
          opModalidadeST: [
            { value: '0', text: 'Preço Tabelado ou Máximo Sugerido'},
            { value: '1', text: 'Lista Negativa (Valor)'},
            { value: '2', text: 'Lista Positiva (valor)'},
            { value: '3', text: 'Lista Neutra (valor)'},
            { value: '4', text: 'Margem Valor Agregado (%)'},
            { value: '5', text: 'Pauta (valor)'},
          ],
        },
        pis:{
          opTipoSituacaoTributaria: [
            { value: '01', text : 'PIS 01 - Operação Tributável - Base de Cálculo = Valor da Operação Alíquota Normal (Cumulativo/Não Cumulativo)'},
            { value: '02', text : 'PIS 02 - Operação Tributável - Base de Cálculo = Valor da Operação (Alíquota Diferenciada)'},
            { value: '03', text : 'PIS 03 - Operação Tributável - Base de Cálculo = Quantidade Vendida x Alíquota por Unidade de Produto'},
            { value: '04', text : 'PIS 04 - Operação Tributável - Tributação Monofásica - (Alíquota Zero)'},
            { value: '06', text : 'PIS 06 - Operação Tributável - Alíquota Zero'},
            { value: '07', text : 'PIS 07 - Operação Isenta da Contribuição'},
            { value: '08', text : 'PIS 08 - Operação sem Incidência da Contribuição'},
            { value: '09', text : 'PIS 09 - Operação com Suspensão da Contribuição'},
            { value: '99', text : 'PIS 99 - Outras Operações'}
          ],
          opTipoCalculo: [
            { value: '', text : ''},
            { value: '1', text : 'Percentual'},
            { value: '2', text : 'Valor'}
          ],
          opTipoCalculoST: [
            { value: '', text : ''},
            { value: '1', text : 'Percentual'},
            { value: '2', text : 'Valor'}
          ]
        },
        cofins:{
          opTipoSituacaoTributaria: [
            { value: '01', text: 'COFINS 01 - Operação Tributável - Base de Cálculo = Valor da Operação Alíquota Normal (Cumulativo/Não Cumulativo)'},
            { value: '02', text: 'COFINS 02 - Operação Tributável - Base de Cálculo = Valor da Operação (Alíquota Diferenciada)'},
            { value: '03', text: 'COFINS 03 - Operação Tributável - Base de Cálculo = Quantidade Vendida x Alíquota por Unidade de Produto'},
            { value: '04', text: 'COFINS 04 - Operação Tributável - Tributação Monofásica - (Alíquota Zero)'},
            { value: '06', text: 'COFINS 06 - Operação Tributável - Alíquota Zero'},
            { value: '07', text: 'COFINS 07 - Operação Isenta da Contribuição'},
            { value: '08', text: 'COFINS 08 - Operação sem Incidência da Contribuição'},
            { value: '09', text: 'COFINS 09 - Operação com Suspensão da Contribuição'},
            { value: '99', text: 'COFINS 99 - Outras Operações'}
          ],
          opTipoCalculo: [
            { value: '', text : ''},
            { value: '1', text : 'Percentual'},
            { value: '2', text : 'Valor'}
          ],
          opTipoCalculoST: [
            { value: '', text : ''},
            { value: '1', text : 'Percentual'},
            { value: '2', text : 'Valor'}
          ]
        }
      },   
      icms: {
        habilitado: {
          comboOP_ICMS_ORIGEM              : true, // Sempre Visivel
          
          //Grupo ICMS Normal
          comboOP_ICMS_MODAL_DETERM_BC     : false,
          edVL_ICMS_PERCENT_REDUC_BC       : false,
          edVL_ICMS_BASE_CALC              : false,
          edVL_ICMS_ALIQUOTA               : false,
          edVL_ICMS_PERC_BC_OPER_PROPRIA   : false,
          edVL_ICMS                        : false,

          comboOP_MOTIVO_DESONERACAO       : false,

          //Grupo ICMS Normal ST
          comboOP_ICMS_MODAL_DETERM_BC_ST  : false,
          edVL_ICMS_PERCENT_REDUC_BC_ST    : false,
          edVL_ICMS_MARGEM_VL_ADIC_ST      : false,
          edVL_ICMS_BASE_CALC_ST           : false,
          edVL_ICMS_ALIQUOTA_ST            : false,
          edVL_ICMS_ST                     : false,
          comboID_UF_ICMS_ST               : false,

          //Grupo ICMS Simples
          edVL_ALIQ_APLICAVEL_CALC_CREDITO : false,
          edVL_CREDITO_ICMS_APROVEITADO    : false,

          //Grupo ICMS Simples ST
          edVL_ICMS_BC_ST_RETIDO_ANT       : false,
          edVL_ICMS_ST_RETIDO_ANT          : false,

          
        }
      },

    }
  },
  
  computed: {
    lotesResumoAtual() {
      return this.calcularResumoLotes(this.lotes.modal.item, this.lotes.items)
    },
    lotesAtuaisConsistentes() {
      return this.validarConsistenciaResumoLotes(this.lotesResumoAtual)
    },
    saldoLoteAtual() {
      return this.calcularSaldoDisponivelLote(this.lotes.modal.item, this.lotes.item, this.lotes.items)
    },
    compraFechada() {
      return (['2'].includes(this.compra.OP_STATUS))
    },
    somentePrecoEditavel() {
      return (this.item.OP_IMPORTADO === '1') || (this.compra.OP_RECEPCAO === '3')
    },
    habilitarGeraEstoque() {
      return (!this.compraFechada)
    },
    habilitarNaoGeraFinanceiro() {
      const semParcelas = this.parcelamento.items.length === 0
      return semParcelas && ( !(this.compraFechada) || (['2'].includes(this.compra.OP_FINANCEIRO ) ) )
      
    },
    habilitaBotaoIncluirMovimentacao() {
      return !this.compraFechada
    },
    habilitarGrupoFinanceiro() {
      return (['0'].includes(this.compra.OP_FINANCEIRO) && (!this.compraFechada))
    },
    habilitarBotaoGerarFinanceiro() {
      if (!this.habilitarGrupoFinanceiro) return false
      if (this.parcelamento.items.length === 0) return false
      if (!this.compra.OP_PARCELAMENTO || Number(this.compra.OP_PARCELAMENTO) === 0) return false
      if (!this.compra.CENTRO_CUSTO_ID) return false
      if (!this.compra.GRUPO_APAGAR_ID) return false
      if (!this.compra.OP_FORMA_PAGAMENTO) return false
      return true
    },
    habilitarBotaoCancelarFinanceiro() {
      return !this.compraFechada && this.compra.OP_FINANCEIRO === '1'
    },
    produtoTotal: {
       get() {
        return 0.00
       },
       set() {

       }
    },
    habilitarConcluirSemNota() {
      //compra.OP_XML
      //0 -Não vinculada
      //1 -Divergente
      //2 -Vinculada
      //3 -Confirmada Sefaz
      return (['0'].includes(this.compra.OP_XML) && !this.compraFechada)
    },
    habilitarBotaoVincularXml() {
      //compra.OP_XML
      //0 -Não vinculada
      //1 -Divergente
      //2 -Vinculada
      //3 -Confirmada Sefaz
      return ((['0'].includes(this.compra.OP_XML)) && (['0'].includes(this.compra.OP_CONCLUIR_SEM_NOTA)) && !this.compraFechada )
    },
    habilitarBotaoRemoverXml() {
      return (['1','2'].includes(this.compra.OP_XML) && !this.compraFechada)
    },
    habilitarBotaoConciliarXml() {
      return (['1'].includes(this.compra.OP_XML) && !this.compraFechada)
    },
    habilitarBotaoConfirmarSefaz() {
      return (['3'].includes(this.compra.OP_XML) && !this.compraFechada)
    },
    habilitarBotaoVisualizarDanfe() {
      return (['1','2'].includes(this.compra.OP_XML))
    },

    habilitarBotoesImportarXml() {
      //Pedido Ainda esta em Cadastro
      return   (this.compra.OP_STATUS === '1') 
            && (this.compra.OP_RECEPCAO === '0') 
            && (this.compra.OP_CARGA_XML === '0')
            && (!this.compraFechada)
    },
    habilitarBotoesItens() {
      return   (this.compra.OP_STATUS === '1') 
            && (this.compra.OP_RECEPCAO === '0' || this.compra.OP_RECEPCAO === '3') 
            && (this.compra.OP_CARGA_XML === '0')
            && (this.compra.OP_XML === '0')
            && (!this.compraFechada)
    },
    habilitarConcluirSemConferencia() {
      //Foi solicitado conferencia 
      //'0 NAO SOLICITADO'
      //'1 CONF ABERTA'
      //'2 EM CONFERENCIA'
      //'3 CONFERIDO'
      //Pedido Ainda esta em Cadastro
      return (this.compra.OP_STATUS === '1') && (['0'].includes(this.compra.OP_RECEPCAO) && (!this.compraFechada))
    },
    habilitarBotaoDevolverProTerminal() {
      //Foi solicitado conferencia 
      //'0 NAO SOLICITADO'
      //'1 CONF ABERTA'
      //'2 EM CONFERENCIA'
      //'3 CONFERIDO'
      //Pedido Ainda esta em Cadastro
      return (this.compra.OP_STATUS === '1') && (['3'].includes(this.compra.OP_RECEPCAO) && (!this.compraFechada))
    },
    habilitarBotaoAtualizarPelaConferencia() {
      //Foi solicitado conferencia 
      //'0 NAO SOLICITADO'
      //'1 CONF ABERTA'
      //'2 EM CONFERENCIA'
      //'3 CONFERIDO'
      //Pedido Ainda esta em Cadastro
      return (this.compra.OP_STATUS === '1') && (['3'].includes(this.compra.OP_RECEPCAO) && (!this.compraFechada))
    },
    habilitarBotaoCancelarConferencia() {
      //Foi solicitado conferencia 
      //'0 NAO SOLICITADO'
      //'1 CONF ABERTA'
      //'2 EM CONFERENCIA'
      //'3 CONFERIDO'
      //Pedido Ainda esta em Cadastro
      return (this.compra.OP_STATUS === '1') && (['1','2'].includes(this.compra.OP_RECEPCAO) && (!this.compraFechada))
    },
    habilitarBotaoSolicitarConferencia() {
      //Não foi solicitado conferencia 
      //'0 NAO SOLICITADO'
      //'1 CONF ABERTA'
      //'2 EM CONFERENCIA'
      //'3 CONFERIDO'
      //Pedido Ainda esta em Cadastro
      return ((this.compra.OP_STATUS === '1') && (['0'].includes(this.compra.OP_RECEPCAO)) && (this.compra.OP_CONCLUIR_SEM_RECEPCAO === '0') && (!this.compraFechada))
    },
    
    habilitarBotaoReabrir() {
      //Pedido esta fechado
      return (this.compraFechada)
    },
    habilitarBotaoFinalizar() {
      //Pedido esta em cadastro
      return ((this.compra.OP_STATUS === '1') && (!this.compraFechada))
    },
    habilitaBotaoGravar() {
      const status = (this.compra.OP_STATUS?.trim()) ?? '0'
      return (!this.compra.ID) && (['1'].includes(status) && (!this.compraFechada))
    },
    habilitaBotaoEditar() {
      const status = (this.compra.OP_STATUS?.trim()) ?? '0'
      return (this.compra.ID) && (['1'].includes(status) && (!this.compraFechada))
    },
    valFORNECEDOR_ID(){
      return ((this.compra.FORNECEDOR_ID ) && (this.compra.FORNECEDOR_ID > 0)) ? true : false
    },
    valOP_FORMA_PAGAMENTO() {
      //return ((this.compra.OP_FORMA_PAGAMENTO ) && (this.compra.OP_FORMA_PAGAMENTO != '')) ? true : false
    },
    valOP_PARCELAMENTO() {
      return this.compra.OP_PARCELAMENTO == null ? false : true
    },
    valPRODUTO_ID(){
      return ((this.item.PRODUTO_ID ) && (this.item.PRODUTO_ID > 0)) ? true : false
    },
    valQuantidadeComercial(){
      return Number(this.item.NR_PESO_LIQUIDO || 0) > 0
    },
    valNR_PESO_BRUTO(){
      return Number(this.item.NR_PESO_BRUTO || 0) >= 0
    },
    valQT_PECAS(){
      return this.item.QT_PECAS > 0 ?? false
    },
    valVL_UNITARIO_FOB(){
      return this.item.VL_UNITARIO_FOB > 0 ?? false
    },
    totalBruto: {
      get() {
        return this.item.VL_TOTAL_FOB ?? 0.00
      },
      set(value) {
        this.item.VL_TOTAL_FOB = Number(value) || 0
      }
    },
    totalPIS() {
      return this.compra.VL_TOTAL_PIS?? 0
    },
    totalCOFINS() {
      return this.compra.VL_TOTAL_COFINS?? 0
    },
    totalICMS() {
      return this.compra.VL_TOTAL_ICMS?? 0
    },
    compraAlmoxarifado() {
      return this.compra.OP_TIPO_PEDIDO === 'A'
    },
    camposTabelaItens() {
      return this.montarCamposTabelaItens()
    },
    rotuloTipoPedidoTabela() {
      return this.compraAlmoxarifado ? 'Visão Almoxarifado' : 'Visão Indústria'
    },
    descricaoTabelaItens() {
      return this.compraAlmoxarifado
        ? 'Grade com foco em quantidade de NF-e, pesos e tributos do material comprado.'
        : 'Grade com foco em pesos e composição fiscal dos produtos comprados.'
    },
    unidadeComercialItem() {
      const unidade = String(this.item.ID_UNIDADE_COMERCIAL || '').trim()
      return unidade || 'UND'
    },
    
    totalQuant(){
      let soma = 0.00
      if (this.tabelaItens.items){
        if (this.tabelaItens.items.length && this.tabelaItens.items.length > 0) {
          [...this.tabelaItens.items].forEach(it => {
            soma += Number(it.NR_PESO_LIQUIDO || 0)
          })
        } 
        return soma
      } else {
        return 0.00
      }
    },
    totalPecas(){
      let soma = 0
      if (this.tabelaItens.items){
        if (this.tabelaItens.items.length && this.tabelaItens.items.length > 0) {
          [...this.tabelaItens.items].forEach(it => {
            soma += it.PECAS
          })
        } 
        return soma
      } else {
        return 0
      }
    },
    tamanhocampoPagina () {
      if (this.compra.PAGINA) {
        return this.compra.PAGINA.length > 2 ? null : false
      }
      return false
    },
    textoImposto() {
      return this.cliente.ISENTO_ICMS ? (this.cliente.ISENTO_ICMS == 1 ? 'ISENTO' : 'SUJEITO') : 'AUSENTE'
    },
    valMotivoReabertura() {
      return (this.modalReabrir.motivo && this.modalReabrir.motivo.length > 10) ? true : false
    },
    mostrarDropdownAlmoxarifado() {
      return this.compra.OP_TIPO_PEDIDO === 'A'
    },
    mostrarDropdownIndustria() {
      return this.compra.OP_TIPO_PEDIDO !== 'A'
    }
  },
  methods: {
    formatarMoeda(valor) {
      return Number(valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    formatarMoeda3Casas(valor) {
      return Number(valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 3, maximumFractionDigits: 3 })
    },
    formatarNumeroTabelaItem(valor, casas = 2) {
      return Number(valor || 0).toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: casas, maximumFractionDigits: casas })
    },
    formatarMoedaTabelaItem(valor, casas = 2) {
      return Number(valor || 0).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: casas,
        maximumFractionDigits: casas
      })
    },
    montarCamposTabelaItens() {
      const campos = [
        { key: 'PRODUTO_ID', label: 'ID' },
        { key: 'NOME_PRODUTO', label: this.compraAlmoxarifado ? 'Material' : 'Produto' },
        {
          key: 'QT_PECAS',
          class: 'text-right',
          label: 'Volumes',
          formatter: value => this.formatarNumeroTabelaItem(value, 2)
        },
        {
          key: 'NR_PESO_LIQUIDO',
          class: 'text-right',
          label: 'Quantidade',
          formatter: value => this.formatarNumeroTabelaItem(value, 3)
        },
        {
          key: 'ID_UNIDADE_COMERCIAL',
          class: 'text-center',
          label: 'Unid.'
        },
        {
          key: 'NR_PESO_BRUTO',
          class: 'text-right',
          label: 'Peso Bruto',
          formatter: value => this.formatarNumeroTabelaItem(value, 3)
        }
      ]

      if (this.compraAlmoxarifado) {
        campos.push({
          key: 'QUANT_NFE',
          class: 'text-right',
          label: 'Qtd. NF-e Almox',
          formatter: value => this.formatarNumeroTabelaItem(value, 2)
        })
      }

      campos.push(
        {
          key: 'VL_UNITARIO_FOB',
          class: 'text-right',
          label: 'FOB Unit.',
          formatter: value => this.formatarMoedaTabelaItem(value, 3)
        },
        {
          key: 'VL_TOTAL_FOB',
          class: 'text-right',
          label: 'Total FOB',
          formatter: value => this.formatarMoedaTabelaItem(value, 2)
        },
        {
          key: 'VL_ICMS',
          class: 'text-right',
          label: 'ICMS',
          formatter: value => this.formatarMoedaTabelaItem(value, 2)
        },
        {
          key: 'VL_PIS',
          class: 'text-right',
          label: 'PIS',
          formatter: value => this.formatarMoedaTabelaItem(value, 2)
        },
        {
          key: 'VL_COFINS',
          class: 'text-right',
          label: 'COFINS',
          formatter: value => this.formatarMoedaTabelaItem(value, 2)
        },
        {
          key: 'VL_IBS',
          class: 'text-right',
          label: 'IBS',
          formatter: value => this.formatarMoedaTabelaItem(value, 2)
        },
        {
          key: 'VL_CBS',
          class: 'text-right',
          label: 'CBS',
          formatter: value => this.formatarMoedaTabelaItem(value, 2)
        },
        {
          key: 'VL_IS',
          class: 'text-right',
          label: 'IIS',
          formatter: value => this.formatarMoedaTabelaItem(value, 2)
        },
        {
          key: 'actions',
          class: 'text-center p-0',
          label: 'Ações'
        }
      )

      return campos
    },
    normalizarItemTabela(item) {
      return {
        ...item,
        OP_CONTROLA_LOTE: String(item.OP_CONTROLA_LOTE ?? '0').trim(),
        OP_MATERIA_PRIMA: String(item.OP_MATERIA_PRIMA ?? '0').trim(),
        ID_UNIDADE_COMERCIAL: String(item.ID_UNIDADE_COMERCIAL || 'UND').trim() || 'UND',
        NR_PESO_BRUTO: Number(item.NR_PESO_BRUTO ?? 0),
        NR_PESO_LIQUIDO: Number(item.NR_PESO_LIQUIDO ?? 0),
        QT_PECAS: Number(item.QT_PECAS ?? 0),
        PECAS: Number(item.PECAS ?? item.QT_PECAS ?? 0),
        QUANT_NFE: Number(item.QUANT_NFE ?? 0),
        VL_UNITARIO_FOB: Number(item.VL_UNITARIO_FOB ?? 0),
        VL_TOTAL_FOB: Number(item.VL_TOTAL_FOB ?? 0),
        VL_ICMS: Number(item.VL_ICMS ?? 0),
        VL_PIS: Number(item.VL_PIS ?? 0),
        VL_COFINS: Number(item.VL_COFINS ?? 0),
        VL_IBS: Number(item.VL_IBS ?? 0),
        VL_CBS: Number(item.VL_CBS ?? 0),
        VL_IS: Number(item.VL_IS ?? 0)
      }
    },
    async onTabActivated(newTabIndex, prevTabIndex, bvEvt) {
      // Índice 4 = Aba CONFERÊNCIA (Produtos=0, Financeiro=1, Logística=2, Pagamento=3, Conferência=4)
      if (newTabIndex === 4 && this.compra.ID) {
        this.conferencia.loading = true
        try {
          await this.getConferencia(this.compra.ID)
        } catch (err) {
          console.error('Erro ao carregar dados de conferência:', err)
        } finally {
          this.conferencia.loading = false
        }
      }
    },
    voltar() {
      this.$router.push(`/movimentos/compras/listagem`)
    },
    rowClassConciliado(item, type) {
      if (item && type === 'row') {
        return this.itemConciliadoValido(item) ? 'table-success' : ''
      }
    },
    descricaoFornecedorCompra() {
      return this.$refs.edFORNECEDOR_ID?.$refs?.auto?.display || this.cliente.RAZAOSOCIAL || 'Fornecedor não informado na compra'
    },
    formatarDocumentoFornecedor(valor) {
      const numero = String(valor || '').replace(/\D/g, '')
      if (!numero) return 'Não informado'
      if (numero.length === 14) {
        return numero.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
      }
      if (numero.length === 11) {
        return numero.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
      }
      return numero
    },
    normalizarNumeroConciliacao(valor) {
      if (typeof valor === 'number') return valor
      if (valor == null) return 0
      const texto = String(valor).trim()
      if (!texto) return 0
      const semMascara = texto.replace(/\s/g, '').replace(/R\$/g, '').replace(/\./g, '').replace(',', '.')
      const numero = Number(semMascara)
      return Number.isFinite(numero) ? numero : 0
    },
    normalizarProdutoConciliacaoId(valor) {
      if (valor == null) return 0
      if (typeof valor === 'object') {
        return this.normalizarProdutoConciliacaoId(valor.ID ?? valor.CODIGO ?? valor.value ?? null)
      }
      const numero = Number(String(valor).trim())
      return Number.isFinite(numero) ? numero : 0
    },
    onSelecionarProdutoConciliacao(item, valor) {
      const produtoId = this.normalizarProdutoConciliacaoId(valor)
      this.$set(item, 'PRODUTO_ID', produtoId > 0 ? produtoId : null)
    },
    itemConciliadoValido(item) {
      const produtoId = this.normalizarProdutoConciliacaoId(item?.PRODUTO_ID)
      return produtoId > 0
    },
    async manifestarSefaz() {
      if (!this.compra.NOTA_FISCAL) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe a chave de acesso da NF-e')
        return
      }
      try {
        this.$store.commit('controle/setAguardando', true)
        await this.$http.post('/api/protected/gestaoCompra/manifestarSefaz', {
          compraId: this.compra.ID,
          chaveAcesso: this.compra.NOTA_FISCAL,
          empresaId: this.compra.EMPRESA_ID,
          login: window.localStorage.getItem('login')
        })
        this.compra.OP_XML = '3'
        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Confirmação de Operação enviada à SEFAZ!')
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', err?.response?.data?.erro || String(err))
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async abrirModalConciliarNFE() {
      if (!this.compra.NOTA_FISCAL) {
        Tools.exibirMensagem(this.$store, 'Erro', 'warning', 'Informe a chave de Acesso')
        return
      }
      if (!this.compra.OP_TIPO_PEDIDO) {
        Tools.exibirMensagem(this.$store, 'Erro', 'warning', 'Informe o interesse da Compra')
        return
      }


      try {
        this.$store.commit('controle/setAguardando', true)

        const body = {
          pedidoCompraId: this.compra.ID,
          chaveAcesso: this.compra.NOTA_FISCAL,
        }

        const response = await this.$http.post(`/api/protected/notaFiscal/distribuicao/getDadosNotaFiscal/`, body)

        const cabecalho = (response.data?.cabecalho) ?? null
        const itensXML = (response.data?.itens) ?? null

        if (!cabecalho || !Array.isArray(itensXML) || itensXML.length === 0) {
          const erro = response.data?.erro || 'Não foi possível Ler os dados dessa Nota.'
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', erro)
          return
        }
        
        // Aplicar dados fiscais do cabeçalho à compra
        const cabecalhoFiscal = response.data?.cabecalhoFiscal || null
        this.conciliacao.fornecedorXml = {
          nome: cabecalho.FORNECEDOR || null,
          cnpj: cabecalho.CNPJ || null,
          ie: cabecalho.IE || null
        }

        if (cabecalhoFiscal) {
          this.compra.VL_BC_ICMS    = cabecalhoFiscal.VL_BC_ICMS    || 0
          this.compra.VL_ICMS       = cabecalhoFiscal.VL_ICMS       || 0
          this.compra.VL_ICMS_ST    = cabecalhoFiscal.VL_ICMS_ST    || 0
          this.compra.VL_BC_ICMS_ST = cabecalhoFiscal.VL_BC_ICMS_ST || 0
          this.compra.VL_PIS        = cabecalhoFiscal.VL_PIS        || 0
          this.compra.VL_COFINS     = cabecalhoFiscal.VL_COFINS     || 0
          this.compra.NUMERO_NFE    = cabecalhoFiscal.NUMERO_NFE     || null
          this.compra.SERIE_NFE     = cabecalhoFiscal.SERIE_NFE      || null
        }

        this.conciliacao.fields = this.compra.OP_TIPO_PEDIDO === 'A' ? [
          { key: 'PRODUTO', label: 'Item na NFE', thClass: 'text-left', tdClass: 'align-middle' },
          { key: 'PRODUTO_VINCULADO', label: 'Material Vinculado', thClass: 'text-left', tdClass: 'align-middle' },
          { key: 'QUANT_NFE', label: 'Qtd. NFE', thClass: 'text-center', tdClass: 'align-middle text-center' },
          { key: 'QUANT', label: 'Fator (Conv.)', thClass: 'text-center', tdClass: 'align-middle text-center', thStyle: 'width: 120px;' },
          { key: 'BOTAO', label: '', thClass: 'text-center', tdClass: 'align-middle text-center' }
        ] : [
          { key: 'PRODUTO', label: 'Item na NFE', thClass: 'text-left', tdClass: 'align-middle' },
          { key: 'PRODUTO_VINCULADO', label: 'Produto Vinculado', thClass: 'text-left', tdClass: 'align-middle' },
          { key: 'QUANT_NFE', label: 'Qtd. NFE', thClass: 'text-center', tdClass: 'align-middle text-center' },
          { key: 'BOTAO', label: '', thClass: 'text-center', tdClass: 'align-middle text-center' }
        ];

        this.conciliacao.items = []
        for (const i of itensXML) {
          const itemXML = {
            CODIGO:            i.CODIGO,
            PRODUTO:           i.PRODUTO,
            PRODUTO_ID:        i.PRODUTO_ID,
            PRODUTO_VINCULADO: null,
            QUANT_NFE:         i.QUANT_NFE,
            QUANT_CONFERIDO:   i.QUANT_NFE, // default to avoid breaking backend API
            QUANT:             1,
            VL_UNT:            i.VL_UNT,
            VL_VENDA:          i.VL_TOTAL,
            // Campos fiscais por item
            CFOP:          i.CFOP          || null,
            NCM:           i.NCM           || null,
            CEST:          i.CEST          || null,
            CST_ICMS:      i.CST_ICMS      || null,
            VL_BC_ICMS:    i.VL_BC_ICMS    || 0,
            ALIQ_ICMS:     i.ALIQ_ICMS     || 0,
            VL_ICMS:       i.VL_ICMS       || 0,
            VL_BC_ICMS_ST: i.VL_BC_ICMS_ST || 0,
            VL_ICMS_ST:    i.VL_ICMS_ST    || 0,
            CST_PIS:       i.CST_PIS       || null,
            VL_BC_PIS:     i.VL_BC_PIS     || 0,
            ALIQ_PIS:      i.ALIQ_PIS      || 0,
            VL_PIS:        i.VL_PIS        || 0,
            CST_COFINS:    i.CST_COFINS     || null,
            VL_BC_COFINS:  i.VL_BC_COFINS   || 0,
            ALIQ_COFINS:   i.ALIQ_COFINS    || 0,
            VL_COFINS:     i.VL_COFINS      || 0,
            CST_IPI:       i.CST_IPI        || null,
            VL_BC_IPI:     i.VL_BC_IPI      || 0,
            ALIQ_IPI:      i.ALIQ_IPI       || 0,
            VL_IPI:        i.VL_IPI         || 0,
            VL_IBS:        i.VL_IBS         || 0,
            VL_CBS:        i.VL_CBS         || 0,
            VL_IS:         i.VL_IS          || 0
          }
          this.conciliacao.items.push(itemXML)
        }

        this.$refs['modal-conciliar'].show()      
        

      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        console.error('Erro em gerarXML:', err)
        return new Error(err)
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async postConciliar() {
      if (!this.compra.FORNECEDOR_ID) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o fornecedor na compra antes de conciliar o XML.' )
        return  
      }

      for (const item of this.conciliacao.items) {
        if (!this.itemConciliadoValido(item)) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'É necessário Vincular todos os produtos!' )
          return
        }
      }

      // Validar se todos os itens lançados previamente na compra estão mapeados na conciliação
      const itensManuais = this.tabelaItens.items || []
      if (itensManuais.length > 0) {
        const mappedXmlProductIds = new Set(
          this.conciliacao.items.map(item => this.normalizarProdutoConciliacaoId(item.PRODUTO_ID))
        )
        for (const itemManual of itensManuais) {
          const manualProdId = this.normalizarProdutoConciliacaoId(itemManual.PRODUTO_ID)
          if (!mappedXmlProductIds.has(manualProdId)) {
            const nomeProduto = itemManual.NOME_PRODUTO || `Produto ID ${itemManual.PRODUTO_ID}`
            Tools.exibirMensagem(
              this.$store,
              'Erro de Validação',
              'danger',
              `O produto "${nomeProduto}" (ID: ${manualProdId}) já foi lançado na compra, mas não está vinculado a nenhum item do XML. Ajuste a conciliação.`
            )
            return
          }
        }
      }

      try {
        this.$store.commit('controle/setAguardando', true)

        const produtosFornecedor = this.conciliacao.items.map(item => ({
          ...item,
          PRODUTO_ID: this.normalizarProdutoConciliacaoId(item.PRODUTO_ID),
          QUANT: this.normalizarNumeroConciliacao(item.QUANT),
          QUANT_CONFERIDO: this.normalizarNumeroConciliacao(item.QUANT_CONFERIDO),
          QUANT_NFE: this.normalizarNumeroConciliacao(item.QUANT_NFE),
          VL_UNT: this.normalizarNumeroConciliacao(item.VL_UNT),
          VL_VENDA: this.normalizarNumeroConciliacao(item.VL_VENDA)
        }))

        const compraParaConciliar = {
          ...this.compra,
          OP_XML: '2'
        }

        const pacote = {
          compra: compraParaConciliar,
          produtosFornecedor,
          login: window.localStorage.getItem('login')
        }

        try {
          
          await this.$http.post(`/api/protected/gestaoCompra/conciliarXML`, pacote)
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Operação Indisponível! Não foi possível registrar os dados do Pedido' )
          return
        }

        //Atualizar o Registro Principal - COMPRA
        try {
           await this.getCompra(this.compra.ID)
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Operação Indisponível! Não foi possível registrar as alterações' )
          this.$refs['modal-conciliar'].hide()
          return
        }

        try {
          await this.getItens(this.compra.ID)
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          this.$refs['modal-conciliar'].hide()
          return
        }

       
        this.$refs['modal-conciliar'].hide()
        
        
      } finally {
          this.$store.commit('controle/setAguardando', false)
      }
    },
    async toggleDetalhesNotaFiscal(row) {
      if (row.detailsShowing) {
        row.toggleDetails()
        return
      }

      if (!row.item.detalhes && !row.item.loading) {
        this.$set(row.item, 'loading', true)

        try {
          const detalhes = await this.buscarDetalhesNotaFiscal(row.item.ID)
          this.$set(row.item, 'detalhes', detalhes)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err?.response?.data?.erro || err?.message || 'Não foi possível carregar os itens da nota fiscal.')
          return
        } finally {
          this.$set(row.item, 'loading', false)
        }
      }

      row.toggleDetails()
    },

    async onToggleDetails(row, expanded) {
      // Apenas necessário se quiser reagir diretamente ao evento
    },

    async buscarDetalhesNotaFiscal(id) {
      // Simula chamada backend

      const itensResult = await this.$http.get(`/api/protected/gestaoCompra/notaFiscal/listarItensDaNota/${id}`)
      return itensResult.data ?? null

    },
    focus_modalDespesa() {
      this.$refs.edItemDocumento.focus()
    },
    focusModalLotes() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.edLoteInterno && this.$refs.edLoteInterno.focus && this.$refs.edLoteInterno.focus()
        }, 80)
      })
    },
    itemExigeControleLote(item) {
      return String(item?.OP_CONTROLA_LOTE ?? '0').trim() === '1'
    },
    normalizarTextoLote(valor) {
      return String(valor || '').trim().toUpperCase()
    },
    obterQuantidadeReferenciaItem(item) {
      const valores = this.compraAlmoxarifado
        ? [item?.QUANT_CONFERENCIA, item?.QUANT_NFE, item?.NR_PESO_LIQUIDO, item?.NR_PESO_BRUTO]
        : [item?.QUANT_CONFERENCIA, item?.NR_PESO_LIQUIDO, item?.QUANT_NFE, item?.NR_PESO_BRUTO]
      for (const valor of valores) {
        const numero = Number(valor || 0)
        if (numero > 0) return numero
      }
      return 0
    },
    obterPecasReferenciaItem(item) {
      const valores = [item?.PECAS_CONFERENCIA, item?.PECAS_NFE, item?.QT_PECAS]
      for (const valor of valores) {
        const numero = Number(valor || 0)
        if (numero > 0) return numero
      }
      return 0
    },
    formatarNumeroResumoLote(valor, casas) {
      return Number(valor || 0).toLocaleString('pt-BR', {
        style: 'decimal',
        minimumFractionDigits: casas,
        maximumFractionDigits: casas
      })
    },
    calcularCustoTotalLote(lote) {
      const custoUnitario = Number(lote?.VL_CUSTO_UNITARIO || 0)
      const baseCalculo = Number(lote?.QUANTIDADE || 0) > 0
        ? Number(lote?.QUANTIDADE || 0)
        : Number(lote?.PECAS || 0)

      return Number((custoUnitario * baseCalculo).toFixed(6))
    },
    calcularResumoLotes(item, lotesOverride = null) {
      const resumoVazio = {
        quantidadeItem: 0,
        quantidadeLotes: 0,
        diferencaQuantidade: 0,
        pecasItem: 0,
        pecasLotes: 0,
        diferencaPecas: 0,
        valorItem: 0,
        valorLotes: 0,
        diferencaValor: 0,
        exigeQuantidade: false,
        exigePecas: false,
      }

      if (!item) return resumoVazio

      const quantidadeItem = this.obterQuantidadeReferenciaItem(item)
      const pecasItem = this.obterPecasReferenciaItem(item)
      const valorItem = Number(item.VL_TOTAL_FOB || 0)
      const quantidadeLotes = Array.isArray(lotesOverride)
        ? lotesOverride.reduce((acc, lote) => acc + Number(lote.QUANTIDADE || 0), 0)
        : Number(item.QUANTIDADE_LOTES || 0)
      const pecasLotes = Array.isArray(lotesOverride)
        ? lotesOverride.reduce((acc, lote) => acc + Number(lote.PECAS || 0), 0)
        : Number(item.PECAS_LOTES || 0)
      const valorLotes = Array.isArray(lotesOverride)
        ? lotesOverride.reduce((acc, lote) => acc + Number(lote.VL_CUSTO_TOTAL || 0), 0)
        : Number(item.VL_TOTAL_LOTES || 0)

      return {
        quantidadeItem,
        quantidadeLotes,
        diferencaQuantidade: quantidadeItem - quantidadeLotes,
        pecasItem,
        pecasLotes,
        diferencaPecas: pecasItem - pecasLotes,
        valorItem,
        valorLotes,
        diferencaValor: valorItem - valorLotes,
        exigeQuantidade: quantidadeItem > 0,
        exigePecas: pecasItem > 0,
      }
    },
    calcularSaldoDisponivelLote(item, loteAtual = null, lotesOverride = null) {
      if (!item) {
        return {
          quantidade: 0,
          pecas: 0,
          valor: 0,
        }
      }

      const lotesBase = Array.isArray(lotesOverride) ? lotesOverride : []
      const lotesSemAtual = lotesBase.filter(lote => Number(lote?.ID || 0) !== Number(loteAtual?.ID || 0))
      const resumo = this.calcularResumoLotes(item, lotesSemAtual)

      return {
        quantidade: resumo.exigeQuantidade ? Math.max(Number((resumo.quantidadeItem - resumo.quantidadeLotes).toFixed(3)), 0) : 0,
        pecas: resumo.exigePecas ? Math.max(Number(resumo.pecasItem || 0) - Number(resumo.pecasLotes || 0), 0) : 0,
        valor: Math.max(Number((resumo.valorItem - resumo.valorLotes).toFixed(6)), 0),
      }
    },
    validarConsistenciaResumoLotes(resumo) {
      if (!resumo) return true

      const quantidadeOk = !resumo.exigeQuantidade || Math.abs(Number(resumo.diferencaQuantidade || 0)) <= 0.0005
      const pecasOk = !resumo.exigePecas || Number(resumo.diferencaPecas || 0) === 0

      return quantidadeOk && pecasOk
    },
    itemLoteConsistente(item) {
      if (!this.itemExigeControleLote(item)) return true
      return this.validarConsistenciaResumoLotes(this.calcularResumoLotes(item))
    },
    listarItensLoteInconsistentes() {
      return (this.tabelaItens.items || []).filter(item => this.itemExigeControleLote(item) && !this.itemLoteConsistente(item))
    },
    existeDuplicidadeLote(loteAtual = this.lotes.item) {
      const lote = this.normalizarTextoLote(loteAtual?.LOTE)
      const loteFornecedor = this.normalizarTextoLote(loteAtual?.LOTE_FORNECEDOR)

      if (!lote) return false

      return (this.lotes.items || []).some(item =>
        Number(item?.ID || 0) !== Number(loteAtual?.ID || 0) &&
        this.normalizarTextoLote(item?.LOTE) === lote &&
        this.normalizarTextoLote(item?.LOTE_FORNECEDOR) === loteFornecedor
      )
    },
    getLoteItemLimpo(itemCompra = null) {
      return {
        ID: null,
        PEDIDO_COMPRA_ID: itemCompra?.PEDIDO_COMPRA_ID || this.compra.ID,
        PEDIDO_COMPRA_ITEM_ID: itemCompra?.ID || null,
        PRODUTO_ID: itemCompra?.PRODUTO_ID || null,
        CENTRO_ESTOQUE_ID: itemCompra?.CENTRO_ESTOQUE_ID || this.compra.CENTRO_ESTOQUE_ID,
        LOTE: null,
        LOTE_FORNECEDOR: null,
        DATA_FABRICACAO: null,
        DATA_VALIDADE: null,
        QUANTIDADE: 0.00,
        PECAS: 0,
        VL_CUSTO_UNITARIO: Number(itemCompra?.VL_UNITARIO_FOB || 0),
        VL_CUSTO_TOTAL: 0.00,
        OP_STATUS: '1',
        USUARIO_CADASTRO: window.localStorage.getItem('login'),
        USUARIO_ALTERACAO: null,
        DATA_CADASTRO: null,
        DATA_ALTERACAO: null,
        OBSERVACAO: null,
      }
    },
    limparFormularioLote() {
      this.lotes.item = this.getLoteItemLimpo(this.lotes.modal.item)
    },
    fecharModalLotes() {
      this.$refs['modal-lotes-item'].hide()
      this.lotes.modal.item = null
      this.lotes.items = []
      this.limparFormularioLote()
    },
    async abrirModalLotes(item) {
      if (!this.itemExigeControleLote(item)) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Este item não exige detalhamento de lote')
        return
      }

      this.lotes.modal.item = { ...item }
      this.limparFormularioLote()
      this.lotes.modal.loading = true

      try {
        await this.getLotesItem(item.ID)
        this.$refs['modal-lotes-item'].show()
        this.focusModalLotes()
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err.message || err)
      } finally {
        this.lotes.modal.loading = false
      }
    },
    async getLotesItem(itemId) {
      const response = await this.$http.get(`/api/protected/gestaoCompra/itemLote/getByItemId/${itemId}`)
      this.lotes.items = response.data ?? []
    },
    selecionarLoteEdicao(lote) {
      this.lotes.item = {
        ...lote,
        DATA_FABRICACAO: lote.DATA_FABRICACAO ? Tools.formatarDataParaInput(lote.DATA_FABRICACAO) : null,
        DATA_VALIDADE: lote.DATA_VALIDADE ? Tools.formatarDataParaInput(lote.DATA_VALIDADE) : null,
        VL_CUSTO_UNITARIO: Number(lote.VL_CUSTO_UNITARIO || this.lotes.modal.item?.VL_UNITARIO_FOB || 0),
      }
      this.focusModalLotes()
    },
    preencherSaldoDisponivelLote() {
      const saldo = this.saldoLoteAtual
      const exigeQuantidade = this.obterQuantidadeReferenciaItem(this.lotes.modal.item) > 0
      const exigePecas = this.obterPecasReferenciaItem(this.lotes.modal.item) > 0

      if (!exigeQuantidade && !exigePecas) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Este item não possui saldo controlado por quantidade ou peças')
        return
      }

      if (exigeQuantidade) {
        this.lotes.item.QUANTIDADE = saldo.quantidade
      }
      if (exigePecas) {
        this.lotes.item.PECAS = saldo.pecas
      }
      if (!Number(this.lotes.item.VL_CUSTO_UNITARIO || 0)) {
        this.lotes.item.VL_CUSTO_UNITARIO = Number(this.lotes.modal.item?.VL_UNITARIO_FOB || 0)
      }
    },
    validarFormularioLote() {
      if (!this.lotes.item.LOTE || !String(this.lotes.item.LOTE).trim()) {
        return 'Informe o lote interno'
      }

      const quantidadeReferencia = this.obterQuantidadeReferenciaItem(this.lotes.modal.item)
      const pecasReferencia = this.obterPecasReferenciaItem(this.lotes.modal.item)
      const quantidade = Number(this.lotes.item.QUANTIDADE || 0)
      const pecas = Number(this.lotes.item.PECAS || 0)

      if (quantidadeReferencia > 0 && quantidade <= 0) {
        return 'Informe a quantidade do lote'
      }
      if (pecasReferencia > 0 && pecas <= 0) {
        return 'Informe as peças do lote'
      }
      if (quantidade <= 0 && pecas <= 0) {
        return 'Informe a quantidade ou as peças do lote'
      }

      if (this.lotes.item.DATA_FABRICACAO && this.lotes.item.DATA_VALIDADE && this.lotes.item.DATA_VALIDADE < this.lotes.item.DATA_FABRICACAO) {
        return 'A data de validade não pode ser menor que a data de fabricação'
      }

      if (this.existeDuplicidadeLote()) {
        return 'Já existe um lote com o mesmo lote interno e lote do fornecedor para este item'
      }

      const custoTotalAtual = this.calcularCustoTotalLote(this.lotes.item)
      const saldoDisponivel = this.saldoLoteAtual
      const totalProjetado = Number((custoTotalAtual + Number(this.lotesResumoAtual.valorLotes || 0) - Number(this.lotes.item.ID ? Number((this.lotes.items || []).find(item => Number(item.ID) === Number(this.lotes.item.ID))?.VL_CUSTO_TOTAL || 0) : 0)).toFixed(6))

      if (Number(this.lotesResumoAtual.valorItem || 0) > 0 && custoTotalAtual > Number((Number(this.lotesResumoAtual.valorItem || 0) + 0.01).toFixed(6))) {
        return 'O valor total do lote não pode ser maior que o valor total do item da compra'
      }

      if (Number(this.lotesResumoAtual.valorItem || 0) > 0 && totalProjetado > Number(this.lotesResumoAtual.valorItem || 0) + 0.01) {
        return `O total dos lotes não pode ultrapassar o valor do item. Saldo disponível: ${this.formatarMoeda(saldoDisponivel.valor)}`
      }

      return null
    },
    async atualizarResumoItemLoteAtual() {
      await this.getItens(this.compra.ID)
      if (this.lotes.modal.item?.ID) {
        const itemAtualizado = (this.tabelaItens.items || []).find(item => item.ID === this.lotes.modal.item.ID)
        if (itemAtualizado) {
          this.lotes.modal.item = { ...itemAtualizado }
          this.lotes.item.PEDIDO_COMPRA_ID = itemAtualizado.PEDIDO_COMPRA_ID
          this.lotes.item.PEDIDO_COMPRA_ITEM_ID = itemAtualizado.ID
          this.lotes.item.PRODUTO_ID = itemAtualizado.PRODUTO_ID
          this.lotes.item.CENTRO_ESTOQUE_ID = itemAtualizado.CENTRO_ESTOQUE_ID
        }
      }
    },
    async postLoteItem() {
      const erroValidacao = this.validarFormularioLote()
      if (erroValidacao) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', erroValidacao)
        return
      }

      this.lotes.modal.saving = true
      try {
        await this.$http.post('/api/protected/gestaoCompra/itemLote/post', { lote: this.lotes.item })
        await this.getLotesItem(this.lotes.modal.item.ID)
        await this.atualizarResumoItemLoteAtual()
        this.limparFormularioLote()
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err)
      } finally {
        this.lotes.modal.saving = false
      }
    },
    async editLoteItem() {
      const erroValidacao = this.validarFormularioLote()
      if (erroValidacao) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', erroValidacao)
        return
      }

      this.lotes.modal.saving = true
      try {
        await this.$http.post('/api/protected/gestaoCompra/itemLote/edit', { lote: this.lotes.item })
        await this.getLotesItem(this.lotes.modal.item.ID)
        await this.atualizarResumoItemLoteAtual()
        this.limparFormularioLote()
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err)
      } finally {
        this.lotes.modal.saving = false
      }
    },
    async deleteLoteItem(lote) {
      const msg = await this.$bvModal.msgBoxConfirm('Excluir este lote do item?', {
        title: 'Excluir Lote',
        size: 'sm',
        buttonSize: 'xl',
        okVariant: 'success',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
        noCloseOnEsc: true,
        noCloseOnBackdrop: true
      })

      if (msg === false) return

      this.lotes.modal.saving = true
      try {
        await this.$http.post('/api/protected/gestaoCompra/itemLote/delete', { id: lote.ID })
        await this.getLotesItem(this.lotes.modal.item.ID)
        await this.atualizarResumoItemLoteAtual()
        if (this.lotes.item.ID === lote.ID) {
          this.limparFormularioLote()
        }
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err)
      } finally {
        this.lotes.modal.saving = false
      }
    },
    converterDataVencimento(data) {
      return Tools.formatarDataBR(data)
    },
    rowClassSelecionadoParcela(item, type) {
      if (type !== 'row' || !item) return ''
      
      return 'cec-row-selected' 
    },
    
    abrirModalVencimento(item) {
      this.parcelamento.item = JSON.parse(JSON.stringify(item)) // deep clone
      this.parcelamento.item.VENCIMENTO = Tools.formatarDataParaInput(this.parcelamento.item.VENCIMENTO)
      this.$refs['modal-parcela'].show()      
    },
    abrirModalCopiarProduto(item) {
      this.conciliacao.registroCopiarProduto = item
      this.conciliacao.produtoCopiadoId = null
      this.conciliacao.nomeProdutoACopiar = null
      this.conciliacao.nomeProdutoXML = item.PRODUTO

      this.$refs['modal-copiar-produto'].show()      
    },
    async copiarProdutoConciliacao() {
      if (!this.conciliacao.produtoCopiadoId) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Produto a ser Copiado!' )
        return
      }

      if (!String(this.conciliacao.nomeProdutoACopiar || '').trim()) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o nome do novo produto!' )
        return
      }

      try {
        this.$store.commit('controle/setAguardando', true)  
        let auxResult = null
        const body = {
            produtoId: this.conciliacao.produtoCopiadoId,
            nomeProduto: String(this.conciliacao.nomeProdutoACopiar).trim()
        }
        try {
          auxResult = await this.$http.post(`api/protected/gestaoCompra/copiarProdutoConciliacao`, body)
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação negada! Não foi possível copiar o produto')
          return
        }
        
        const novoId =  (auxResult.data?.novoId) ?? null

        if (!novoId) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação negada! Não foi possível copiar o produto')
          return
        }

        this.conciliacao.registroCopiarProduto.PRODUTO_ID = novoId
        this.$refs['modal-copiar-produto'].hide()      
        
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

      
    },
    async desvincularXML() {
      const msg = await this.$bvModal.msgBoxConfirm('Desvincular e Remover o XML?', {
        title: 'Desvincular',
        size: 'sm',
        buttonSize: 'xl',
        okVariant: 'success',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
        noCloseOnEsc: true, 
        noCloseOnBackdrop: true
      })
      
      if (msg == false) return

      if (!(['1','2'].includes(this.compra.OP_XML))) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'O XML não foi vinculado' )
        return
      }

      try {
        this.$store.commit('controle/setAguardando', true)  
        const body = {
            compra: this.compra,
            login: window.localStorage.getItem('login')
        }
        try {
          await this.$http.post(`api/protected/gestaoCompra/desvincularNotaFiscal`, body)
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err)
          return
        }
        
        //Atualizar o Registro Principal - COMPRA
        try {
           await this.getCompra(this.compra.ID)
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Operação Indisponível! Não foi possível registrar as alterações' )
          this.$refs['modal-conciliar'].hide()
          return
        }

        try {
          await this.getItens(this.compra.ID)
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          this.$refs['modal-conciliar'].hide()
          return
        }

        
        
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

      
    },    
    async editParcela(parcela) {
      try {
        this.$store.commit('controle/setAguardando', true)  
        try {
          await this.$http.post(`api/protected/gestaoCompra/parcelamento/edit`, parcela)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          return
        }
        
        try {
          await this.getParcelamento()
        } catch (err) {
          throw new Error(`O parcelamento da Venda/Prefatura, não foi encontrado!!`)
        }
        
      } finally {
        this.$refs['modal-parcela'].hide()
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async post() {
      if (!this.valFORNECEDOR_ID) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Informe o Fornecedor!!!` )
        return
      } 
      
      try{
        this.$store.commit('controle/setAguardando', true)
        let idAux = this.compra.ID
        try {
          
          let postResult = null
          try {
            postResult = await this.$http.post(`/api/protected/gestaoCompra/post`, this.compra)
          } catch (err) {
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
            return
          }

          //Recebe um novo ID
          idAux = postResult.data?.ID
          if (!idAux) {
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação indisponível! Não foi possivel gerar um Identificador novo' )
            return
          }
          
          //Atualizar listagem da pagina de Pesquisa
          this.$store.commit("compra/SET_REGISTRO_SELECIONADO_ID", idAux)
        

          //Atualizar o Registro Principal - COMPRA
          let compraResponse
          try {
            compraResponse = await this.$http.get(`/api/protected/gestaoCompra/getById/${idAux}`)
          } catch(err) {
            console.log(err)
            Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
            return
          }
          this.compra = compraResponse?.data?.[0]?? null
          if (!this.compra) {
            this.controles.falhaNaAbertura = true // pra deixar tudo fechado
            throw new Error('A Venda/Prefatura não foi localizada!')
          }


          this.ajustarCamposTabelaPrincipal()
                    
          this.compraIdEditar = idAux

          //Controla se o form esta em alteracao
          this.controles.compraAlteracao = true

          //Controla se o usuario clicou no botao reabrir
          this.controles.compraReaberta = false
          
          Tools.exibirMensagem(this.$store, 'Aviso', 'success', `Pedido de Compra Gravado com Successo!!!` )
          this.$router.replace('/movimentos/compras/edit/'+this.compra.ID);

          return
        } catch (err) {
          const mensagemErro =
            (err.response && err.response.data && (err.response.data.message || JSON.stringify(err.response.data))) ||
            err.message || 'Erro inesperado'

          this.$root.$bvToast.toast(`Aviso: ${mensagemErro}`, {
            title: 'Erro',
            autoHideDelay: 3000,
            variant: 'warning',
            appendToast: true
          })
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
      
    },
    async edit() {
      if (!this.valFORNECEDOR_ID) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Informe o Fornecedor!!!` )
        return
      } 
      
      try {
        this.$store.commit('controle/setAguardando', true)
        let idAux = this.compra.ID
        try {
          

          //Atualizar o Registro Principal - COMPRA
          let compraResponse
          try {
            compraResponse = await this.$http.post(`/api/protected/gestaoCompra/edit`, this.compra)  
          } catch(err) {
            console.log(err)
            Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
            return
          }
          this.compra = compraResponse?.data ?? null
          if (!this.compra) {
            this.controles.falhaNaAbertura = true // pra deixar tudo fechado
            throw new Error('A Compra não foi localizada!')
          }

          this.ajustarCamposTabelaPrincipal()
          
          this.compraIdEditar = idAux

          //Controla se o form esta em alteracao
          this.controles.compraAlteracao = true

          //Controla se o usuario clicou no botao reabrir
          this.controles.compraReaberta = false
          
          Tools.exibirMensagem(this.$store, 'Aviso', 'success', `Pedido de Compra Gravado com Successo!!!` )

          return
        } catch (err) {
          const mensagemErro =
            (err.response && err.response.data && (err.response.data.message || JSON.stringify(err.response.data))) ||
            err.message || 'Erro inesperado'

          this.$root.$bvToast.toast(`Aviso: ${mensagemErro}`, {
            title: 'Erro',
            autoHideDelay: 3000,
            variant: 'warning',
            appendToast: true
          })
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
      
    },
    async onChangeOpConcluirSemRecepcao(novoValor) {
      // Guarda o valor anterior
      const valorAnterior = novoValor === '1' ? '0' : '1'
      
      try {
        // Solicita confirmação do usuário
        const resultado = await this.$bvModal.msgBoxConfirm(
          novoValor === '1' 
            ? 'Deseja marcar este pedido para CONCLUIR SEM CONFERÊNCIA? Esta alteração será gravada imediatamente.'
            : 'Deseja desmarcar a opção de CONCLUIR SEM CONFERÊNCIA? Esta alteração será gravada imediatamente.',
          {
            title: 'Confirmar Alteração',
            size: 'md',
            buttonSize: 'md',
            okVariant: 'primary',
            okTitle: 'Sim, Confirmar',
            cancelTitle: 'Não, Cancelar',
            footerClass: 'p-3',
            headerClass: 'bg-primary text-white',
            bodyClass: 'p-4',
            centered: true
          }
        )

        if (resultado) {
          // Usuário confirmou, executa o método edit
          await this.edit()
        } else {
          // Usuário cancelou, reverte o valor
          this.$nextTick(() => {
            this.compra.OP_CONCLUIR_SEM_RECEPCAO = valorAnterior
          })
        }
      } catch (error) {
        // Em caso de erro, reverte o valor
        this.compra.OP_CONCLUIR_SEM_RECEPCAO = valorAnterior
        console.error('Erro ao alterar OP_CONCLUIR_SEM_RECEPCAO:', error)
      }
    },
    async onChangeOpGeraEstoque(novoValor) {
      // Guarda o valor anterior
      const valorAnterior = novoValor === 'S' ? 'S' : 'N'
      
      try {
        // Solicita confirmação do usuário
        const resultado = await this.$bvModal.msgBoxConfirm(
          novoValor === 'S'
            ? 'Deseja marcar este pedido para GERAR ESTOQUE? Esta alteração será gravada imediatamente.'
            : 'Deseja marcar este pedido como NÃO GERAR ESTOQUE? Esta alteração será gravada imediatamente.',
          {
            title: 'Confirmar Alteração',
            size: 'md',
            buttonSize: 'md',
            okVariant: 'primary',
            okTitle: 'Sim, Confirmar',
            cancelTitle: 'Não, Cancelar',
            footerClass: 'p-3',
            headerClass: 'bg-primary text-white',
            bodyClass: 'p-4',
            centered: true
          }
        )

        if (resultado) {
          // Usuário confirmou, executa o método edit
          await this.edit()
        } else {
          // Usuário cancelou, reverte o valor
          this.$nextTick(() => {
            this.compra.OP_GERA_ESTOQUE = valorAnterior
          })
        }
      } catch (error) {
        // Em caso de erro, reverte o valor
        this.compra.OP_GERA_ESTOQUE = valorAnterior
        console.error('Erro ao alterar OP_GERA_ESTOQUE:', error)
      }
    },
    async associarNotaFiscal(item) {
      
      try{
        this.$store.commit('controle/setAguardando', true)
        let idAux = this.compra.ID
        try {
          
          this.compra.NOTA_FISCAL = item.CHAVE_ACESSO
          this.compra.NFE_DISTRIBUICAO_ID = item.ID
          this.compra.OP_XML = '1' //Divergente

          

          let compraResponse
          try {
            compraResponse = await this.$http.post(`/api/protected/gestaoCompra/edit`, this.compra)      
          } catch(err) {
            console.log(err)
            Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
            return
          }
          this.compra = compraResponse?.data ?? null
          if (!this.compra) {
            this.controles.falhaNaAbertura = true // pra deixar tudo fechado
            throw new Error('A compra não foi Localizada!')
          }

          this.ajustarCamposTabelaPrincipal()

          this.$refs['modal-nota-fiscal'].hide()
          
          Tools.exibirMensagem(this.$store, 'Aviso', 'success', `Pedido de Compra Gravado com Successo!!!` )

          return
        } catch (err) {
          const mensagemErro =
            (err.response && err.response.data && (err.response.data.message || JSON.stringify(err.response.data))) ||
            err.message || 'Erro inesperado'

          this.$root.$bvToast.toast(`Aviso: ${mensagemErro}`, {
            title: 'Erro',
            autoHideDelay: 3000,
            variant: 'warning',
            appendToast: true
          })
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
      
    },
    
    async atualizarPaginaPesquisa(ctx) {
      try {
        await this.$store.dispatch('compra/GERAR_LISTA')
        return true
      } catch (error) {
        return false
      }
    },
    itensAtuaisVieramDaCarga() {
      const itens = this.tabelaItens.items || []
      if (!itens.length) return false
      if (this.compra.OP_CARGA_XML === '1') return true
      return itens.every(item => String(item.OP_IMPORTADO || '0') === '1')
    },
    /* ****************************  NOTA FISCAL *****************/
    async abrirModalVincularNotaFiscal () {
      
      if ( (!this.compra.ID) || (this.compra.ID <= 0)) {
        await this.$bvModal.msgBoxOk('É necessário GRAVAR O PEDIDO antes de Vincular a Nota Fiscal!!!.', {
          title: 'Gravar Pedido',
          size: 'md',
          buttonSize: 'lg',
          okVariant: 'info',
          okTitle: 'OK',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
          noCloseOnEsc: true, 
          noCloseOnBackdrop: true
        })
        return
      }


     
      try {
        this.$store.commit('controle/setAguardando', true)

        const result = await this.$http.get(`/api/protected/gestaoCompra/notaFiscal/listarNotas/${this.cliente.CGC}`)

        this.notaFiscal.items = result.data ?? null
          
        this.$refs['modal-nota-fiscal'].show()

      } catch (err) {
        console.log(err.message || err)
        
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

    },
    /* ****************************  ITEM *****************/
    async importarXML() {
      // Validações similares ao Delphi
      
      // Verifica se a carga XML já foi feita
      if (this.compra.OP_CARGA_XML === '1') {
        await this.$bvModal.msgBoxOk('A Carga XML já foi feita no sistema, produtos estão no estoque!', {
          title: 'Aviso',
          size: 'md',
          okVariant: 'warning',
          centered: true
        })
        return
      }

      // Verifica se o fornecedor foi informado
      if (!this.compra.FORNECEDOR_ID) {
        await this.$bvModal.msgBoxOk('É Necessário informar o fornecedor', {
          title: 'Aviso',
          size: 'md',
          okVariant: 'warning',
          centered: true
        })
        return
      }

      // Itens fiscais conciliados pela NF-e podem receber a carga/etiquetas.
      // Itens manuais continuam bloqueados para evitar duplicidade fora do fluxo fiscal.
      if (this.tabelaItens.items.length > 0 && this.compra.OP_XML !== '2') {
        await this.$bvModal.msgBoxOk('Já existem itens cadastrados no Pedido.\nExclua os itens antes de importar a carga ou concilie a NF-e antes da carga.', {
          title: 'Aviso',
          size: 'md',
          okVariant: 'warning',
          centered: true
        })
        return
      }

      if (this.tabelaItens.items.length > 0 && this.compra.OP_XML === '2') {
        const confirmouCargaSobreNfe = await this.$bvModal.msgBoxConfirm(
          'A NF-e já foi conciliada e gerou os itens fiscais. A carga será vinculada aos produtos existentes, atualizando peso/peças e criando as etiquetas. Continuar?',
          {
            title: 'Importar carga sobre NF-e conciliada',
            size: 'md',
            okVariant: 'primary',
            okTitle: 'SIM',
            cancelTitle: 'NÃO',
            centered: true
          }
        )

        if (!confirmouCargaSobreNfe) return
      }

      // Verifica se o centro de estoque foi informado (se necessário)
      if (!this.compra.CENTRO_ESTOQUE_ID && this.compra.OP_CONCLUIR_SEM_RECEPCAO !== '1') {
        await this.$bvModal.msgBoxOk('É Necessário informar o Centro de Estoque', {
          title: 'Aviso',
          size: 'md',
          okVariant: 'warning',
          centered: true
        })
        return
      }

      // Verifica se o comprador foi informado
      if (!this.compra.COMPRADOR_ID) {
        await this.$bvModal.msgBoxOk('É Necessário informar o Comprador', {
          title: 'Aviso',
          size: 'md',
          okVariant: 'warning',
          centered: true
        })
        return
      }

      // Não permite importar XML para almoxarifado
      if (this.compra.OP_TIPO_PEDIDO === 'A') {
        await this.$bvModal.msgBoxOk('Não é possível importar XML para Almoxarifado', {
          title: 'Aviso',
          size: 'md',
          okVariant: 'warning',
          centered: true
        })
        return
      }

      // Verifica se já existem produtos coletados na conferência
      try {
        this.$store.commit('controle/setAguardando', true)
        const response = await this.$http.post('/api/protected/compra/validar-importacao-xml', {
          pedidoCompraId: this.compra.ID
        })

        if (response.data.bloqueado) {
          await this.$bvModal.msgBoxOk('Operação Bloqueada!\nJá existem Produtos Coletados na Conferência!', {
            title: 'Aviso',
            size: 'md',
            okVariant: 'warning',
            centered: true
          })
          return
        }
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Erro ao validar importação')
        console.error(err)
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

      // Salvar o cabeçalho antes de importar para garantir persistência (ex: Centro de Estoque)
      try {
        this.$store.commit('controle/setAguardando', true)
        if (!this.compra.ID || this.compra.ID <= 0) {
          await this.post()
        } else {
          await this.edit()
        }
        
        if (!this.compra.ID || this.compra.ID <= 0) {
          return
        }
      } catch (err) {
        console.error(err)
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

      // Abrir o modal de importação
      if (this.$refs.modalImportarXML) {
        this.$refs.modalImportarXML.abrir()
      } else {
        console.error('Modal não foi encontrado nas refs!')
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Erro ao abrir modal de importação')
      }
    },
    
    async onImportacaoXMLConcluida() {
      // Recarregar dados do pedido
      try {
        this.$store.commit('controle/setAguardando', true)
        await this.getCompra(this.compra.ID)
        await this.getItens(this.compra.ID)
        await this.getConferencia(this.compra.ID)
      } catch (err) {
        console.error('Erro ao recarregar dados:', err)
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async abrirModalItemNovo () {
      
      
      // A VENDA AINDA NÃO FOI SALVA
      if ( (!this.compra.ID) || (this.compra.ID <= 0)) {
        await this.$bvModal.msgBoxOk('É necessário GRAVAR O PEDIDO antes de Lançar os Itens!!!.', {
          title: 'Gravar Pedido',
          size: 'md',
          buttonSize: 'lg',
          okVariant: 'info',
          okTitle: 'OK',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
          noCloseOnEsc: true, 
          noCloseOnBackdrop: true
        })
        return
      }
     

      // CONTROLES ATUALIZADOS
      this.compraIdEditar = this.compra.ID
      this.controles.compraAlteracao = true


      this.tabIndexItem = 0
      this.controles.montandoItem = false

      this.preencherItem(false, {})
      //this.limparAliquotasICMS()

      this.pesagem.items = []
      this.pesagem.manual = false
      this.atualizarTabelaPesagem()

      this.item.PEDIDO_COMPRA_ID     = this.compra.ID
      

      this.controles.PRODUTO_ID = null
      this.controles.itemAlteracao = false

      this.$refs.modalItem.show()
    },
    async abrirModalItemEditar(item, index, event) {
      // Regra de exceção: Se for item importado OU se a compra estiver conferida, permitimos abrir o modal 
      // mesmo que as regras gerais de edição de itens (habilitarBotoesItens) estejam bloqueadas (ex: por XML vinculado)
      const isExcecaoPermitida = (item.OP_IMPORTADO === '1' || this.compra.OP_RECEPCAO === '3') && this.compra.OP_STATUS === '1'
      
      if (this.habilitarBotoesItens == false && !isExcecaoPermitida) return
      
      this.tabIndexItem = 0

      try {
        
        this.$store.commit('controle/setAguardando', true)
        const result = await this.$http.get(`/api/protected/gestaoCompra/item/getById/${item.ID}`)
        if (!result.data.length) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Operação Indisponivel. O produto não não foi localizado!!!` )
          return  
        }

        this.preencherItem(true, result.data[0])
        await this.atualizarDadosDoProduto(this.item.PRODUTO_ID)

        this.gerarPesagemAlteracao(item.ID)

        this.controles.itemAlteracao = true
        this.$refs['modalItem'].show()

      } catch (err) {
        console.log(err.message || err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Operação Indisponivel. O produto não não foi localizado!!!` )
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

    },
    async abrirModalDespesaNovo() { 
      // A VENDA AINDA NÃO FOI SALVA
      if ( (!this.compra.ID) || (this.compra.ID <= 0)) {
        await this.$bvModal.msgBoxOk('É necessário GRAVAR O PEDIDO antes de Lançar Movimentações!!!.', {
          title: 'Gravar Pedido',
          size: 'md',
          buttonSize: 'lg',
          okVariant: 'info',
          okTitle: 'OK',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
          noCloseOnEsc: true, 
          noCloseOnBackdrop: true
        })
        return
      }
     
      try {
        this.despesas.modal.nomeFornecedor = this.$refs.edFORNECEDOR_ID.$refs.auto.display
        this.despesas.modal.tipoMovimento = null
        this.despesas.modal.fechada = false
        this.despesas.item.PEDIDO_COMPRA_ID = this.compra.ID
        this.despesas.item.OP_STATUS = '1'
        this.despesas.item.OP_GERA_TITULO = '0'
        this.despesas.item.OP_DESPESA = '0'
        this.despesas.item.DATA_CADASTRO = Tools.getDataAtual()
        this.despesas.item.DATA_MOVIMENTACAO = Tools.formatarDataParaInput(Tools.getDataAtual())
        this.despesas.item.DATA_VENCIMENTO = Tools.formatarDataParaInput(Tools.getDataAtual())
        this.despesas.item.USUARIO_CADASTRO = window.localStorage.getItem('login')
        
        this.despesas.item.ID                 = null
        this.despesas.item.HISTORICO_ID       = null
        this.despesas.item.OP_TIPO_MOVIMENTO  = null
        this.despesas.item.VALOR              = null
        this.despesas.item.OBSERVACOES        = null
        this.despesas.item.USUARIO_EXCLUSAO   = null
        this.despesas.item.DATA_EXCLUSAO      = null
        this.despesas.item.DATA_PAGAMENTO     = null
        this.despesas.item.DOCUMENTO          = null
        this.despesas.item.TIPO_PAGAMENTO_ID  = null
        this.despesas.item.USUARIO_ALTERACAO  = null
        this.despesas.item.DATA_ALTERACAO     = null
        this.despesas.item.APAGAR_ID          = null
        this.despesas.item.ARECEBER_ID        = null
        this.despesas.item.CENTRO_CUSTO_ID    = null
        this.despesas.item.USUARIO_GERACAO    = null
        this.despesas.item.DATA_GERACAO       = null
        this.despesas.item.CLIENTE_ID         = null

        await this.getTipoPagamento()
      } catch (err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel abrir os tipos de Pagamentos' )
        return
      }
      
      this.$refs['modal-despesas'].show()
    },
    async abrirModalDespesaEditar(item, index, event) {
      try {

        this.despesas.modal.nomeFornecedor = this.$refs.edFORNECEDOR_ID.$refs.auto.display
        this.despesas.modal.tipoMovimento = null
        
        this.$store.commit('controle/setAguardando', true)
        const result = await this.$http.get(`/api/protected/gestaoCompra/despesa/getById/${item.ID}`)
        if (!result.data.length) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Operação Indisponivel. A despesa não foi localizada!!!` )
          return  
        }

        this.despesas.item =  (result.data?.[0]) ?? null
        if (!this.despesas.item) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Operação Indisponivel. A despesa não foi localizada!!!` )
          return  
        }

        await this.getTipoPagamento()

        this.despesas.item.DATA_MOVIMENTACAO =  this.despesas.item.DATA_MOVIMENTACAO ? Tools.formatarDataParaInput(this.despesas.item.DATA_MOVIMENTACAO   ) : null
        this.despesas.item.DATA_VENCIMENTO =  this.despesas.item.DATA_VENCIMENTO ? Tools.formatarDataParaInput(this.despesas.item.DATA_VENCIMENTO   ) : null
        
        this.despesas.modal.fechada = this.despesas.item.OP_GERA_TITULO === '1' ? true : false
        
        this.$refs['modal-despesas'].show()

      } catch (err) {
        console.log(err.message || err)
        this.$root.$bvToast.toast(`Não foi possivel ler o Item!!`, {
          title: 'Erro',
          autoHideDelay: 6000,
          variant: 'danger',
          appendToast: true
        })
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

    },
    async postDespesa() {
      if (this.despesas.modal.tipoMovimento === 'CREDITO') 
        this.despesas.item.OP_TIPO_MOVIMENTO = '0'
      else this.despesas.item.OP_TIPO_MOVIMENTO = '1'

      if (this.avisosDespesa()) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Preencha todas as informações OBRIGATÓRIAS!!!` )
        return  
      }
      try {
        this.$store.commit('controle/setAguardando', true)
        const pacote = {
          compra: this.compra,
          despesa: this.despesas.item
        }

        try {
          await this.$http.post(`/api/protected/gestaoCompra/despesa/post`, pacote)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return
        }

        try {
           await this.getDespesas(this.compra.ID)
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Não foi possível listar as despesas cadastradas' )
          return
        }
        
        try {
           await this.getCompra(this.compra.ID)
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Operação Indisponível! Não foi possível registrar as alterações' )
          return
        }
        
        
        this.$refs['modal-despesas'].hide()
        
        
      } finally {
          this.$store.commit('controle/setAguardando', false)
      }
    },
    async editDespesa() {
      if (this.avisosDespesa()) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Preencha todas as informações OBRIGATÓRIAS!!!` )
        return  
      }
      try {
        this.$store.commit('controle/setAguardando', true)
        const pacote = {
          compra: this.compra,
          despesa: this.despesas.item
        }

        try {
          await this.$http.post(`/api/protected/gestaoCompra/despesa/edit`, pacote)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return
        }

        try {
           await this.getDespesas(this.compra.ID)
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Não foi possível listar as despesas cadastradas' )
          return
        }
        
        try {
           await this.getCompra(this.compra.ID)
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Operação Indisponível! Não foi possível registrar as alterações' )
          return
        }
        
        
        this.$refs['modal-despesas'].hide()
        
        
      } finally {
          this.$store.commit('controle/setAguardando', false)
      }
    },
    async gerarFinanceiroDespesa(item) {
     const msg = await this.$bvModal.msgBoxConfirm('Gerar Financeiro dessa Movimentação?.', {
        title: 'Gerar Financeiro',
        size: 'sm',
        buttonSize: 'xl',
        okVariant: 'success',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
        noCloseOnEsc: true, 
        noCloseOnBackdrop: true
      })
      
      if (msg == false) return


      try {
        this.$store.commit('controle/setAguardando', true)
        const pacote = {
          login: window.localStorage.getItem('login'),
          despesaId: item.ID
        }

        try {
          await this.$http.post(`/api/protected/gestaoCompra/despesa/gerarFinanceiro`, pacote)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return
        }

        try {
           await this.getDespesas(this.compra.ID)
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Não foi possível listar as despesas cadastradas' )
          return
        }
        
        try {
           await this.getCompra(this.compra.ID)
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Operação Indisponível! Não foi possível registrar as alterações' )
          return
        }
        
        
      } finally {
          this.$store.commit('controle/setAguardando', false)
      }
    },
    async deleteDespesa(item) {
     const msg = await this.$bvModal.msgBoxConfirm('Remover a Despesa da Compra?.', {
        title: 'Aviso Despesa',
        size: 'sm',
        buttonSize: 'xl',
        okVariant: 'success',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
        noCloseOnEsc: true, 
        noCloseOnBackdrop: true
      })
      
      if (msg == false) return


      try {
        this.$store.commit('controle/setAguardando', true)
        const pacote = {
          compra: this.compra,
          id: item.ID
        }

        try {
          await this.$http.post(`/api/protected/gestaoCompra/despesa/delete`, pacote)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return
        }

        try {
           await this.getDespesas(this.compra.ID)
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Não foi possível listar as despesas cadastradas' )
          return
        }
        
        try {
           await this.getCompra(this.compra.ID)
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Operação Indisponível! Não foi possível registrar as alterações' )
          return
        }
        
        
      } finally {
          this.$store.commit('controle/setAguardando', false)
      }
    },
    async postItem() {
      if (! this.avisosItem()) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Preencha todas as informações OBRIGATÓRIAS!!!` )
        return  
      }
      try {
        this.$store.commit('controle/setAguardando', true)
        this.limparPesagemEmBranco()

         // Clona para não sujar o estado caso falhe
        const item = { ...this.item, PEDIDO_COMPRA_ID: this.compra.ID };

        const pacote = {
          compra: this.compra,
          item
        }

        let postResult = null
        try {
          postResult = await this.$http.post(`/api/protected/gestaoCompra/item/post`, pacote)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return
        }

        const compraAux = (postResult?.data?.compra) ?? null
        const itensAux = (postResult?.data?.itens) ?? null
        if (!compraAux || !itensAux) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Operação Indisponível! Os dados do pedido não foram registrados corretamente. Entre em contato com a TI' )
          return
        }
        
        this.compra = compraAux
        this.tabelaItens.items = (itensAux || []).map(item => this.normalizarItemTabela(item))
        
        this.ajustarCamposTabelaPrincipal()

        this.$refs['modalItem'].hide()
        
        
      } finally {
          this.$store.commit('controle/setAguardando', false)
      }
    },
    async editItem(){
      try {
        this.$store.commit('controle/setAguardando', true)
        this.limparPesagemEmBranco()
        
        
        
        let bodyItem = {
          item : this.item,
          pesagem : this.pesagem.items
        }
        try {
          await this.$http.post(`/api/protected/gestaoCompra/item/edit`, bodyItem)
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Operação Indisponível! Não foi possível registrar os dados do Pedido' )
          return
        }

        try {
          this.compra.OP_STATUS = '1' //LANCANDO
          await this.$http.post(`/api/protected/gestaoCompra/edit`, this.compra)
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Operação Indisponível! Não foi possível registrar os dados do Pedido' )
          return
        }
       
        try {
          await this.getItens(this.compra.ID)
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Operação Indisponível! Não foi possível registrar as alterações' )
          return
        }
        
        try {
           await this.getCompra(this.compra.ID)
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Operação Indisponível! Não foi possível registrar as alterações' )
          return
        }
              
        this.$refs['modalItem'].hide()
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
        

    },
    async deleteItem(){
      
      try { 
        this.$store.commit('controle/setAguardando', true)  
        
      
        let pacote = {
          id: this.itemExcluir.ID
        }
        try {
          await this.$http.post(`/api/protected/gestaoCompra/item/delete`, pacote)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return
        }
        

        try {
          this.compra.OP_STATUS = '1' //LANCANDO
          await this.$http.post(`/api/protected/gestaoCompra/edit`, this.compra)
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Operação Indisponível! Não foi possível registrar os dados do Pedido' )
          return
        }

        try {
          await this.getItens(this.compra.ID)
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Operação Indisponível! Não foi possível registrar as alterações' )
          return
        }
        
        try {
           await this.getCompra(this.compra.ID)
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Operação Indisponível! Não foi possível registrar as alterações' )
          return
        }
        
        
      } finally {
        this.$refs['modal-excluir-item'].hide()
        this.$store.commit('controle/setAguardando', false)
      }
      
    },
    gerarComboParcelas() {
      this.parcelasVezes = [] 
      for (let i = 0; i < 48; i++) {
        this.parcelasVezes.push({ value: (i+1).toString() , text: (i+1)+'X' })
      }
    },
    gerarDias() {
      this.dias = [] 
      this.dias.push({ value: '0' , text: '0' })
      for (let i = 0; i < 60; i++) {
        this.dias.push({ value: ( i + 1 ).toString() , text: (i+1)+' X' })
      }
    },
    calcularFinanceiro() {
      const viewDespesas = this.despesas.items
      let auxMovimentoCredito = 0
      let auxMovimentoDebito = 0
      let auxAreceberGerados = 0
      let auxApagarGerados = 0
      let auxAreceberAberto = 0
      let auxAPagarAberto = 0
      let auxDespesa = 0

      for (const row of viewDespesas) {
        const tipoMovimento = row.OP_TIPO_MOVIMENTO
        const geraTitulo = row.OP_GERA_TITULO
        const valor = Number(row.VALOR) || 0
        const valorAberto = Number(row.VALOR_ABERTO) || 0
        const isDespesa = row.OP_DESPESA === '1'

        if (tipoMovimento === '0') { // Crédito
          auxMovimentoCredito += valor
          if (geraTitulo === '1') {
            auxAreceberGerados += valor
            auxAreceberAberto += valorAberto
          }
        } else if (tipoMovimento === '1') { // Débito
          auxMovimentoDebito += valor
          if (geraTitulo === '1') {
            auxApagarGerados += valor
            auxAPagarAberto += valorAberto
          }
        }

        if (isDespesa) {
          auxDespesa += valor
        }
      }

      this.despesas.edMovimentoCredito = this.arredondar(auxMovimentoCredito)
      this.despesas.edMovimentoDebito = this.arredondar(auxMovimentoDebito)
      this.despesas.edAreceberGerados = this.arredondar(auxAreceberGerados)
      this.despesas.edApagarGerados = this.arredondar(auxApagarGerados)
      this.despesas.edAreceberAberto = this.arredondar(auxAreceberAberto)
      this.despesas.edAPagarAberto = this.arredondar(auxAPagarAberto)
      this.despesas.edDespesa = this.arredondar(auxDespesa)
    },
    arredondar(valor) {
      return Number(valor.toFixed(2))
    },
    async finalizar() {
      const compra = this.compra
      const parcelas = this.parcelamento.items

      if (!['0','1'].includes(this.parametros.OP_ESTOQUE_ETIQUETADO)) {
        return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'O sistema não esta configurado para Tipo de Estoque Etiquetado ou Não Etiquetado.')
      }
      const estoqueEtiquetado = this.parametros.OP_ESTOQUE_ETIQUETADO === '1' ? true : false
      // === CRÍTICAS BÁSICAS ===

      // Fornecedor obrigatório
      if (!compra.FORNECEDOR_ID)
        return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'É Necessário informar o fornecedor')

      // Comprador obrigatório
      if (!compra.COMPRADOR_ID)
        return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'É Necessário informar o Comprador')

      // Empresa obrigatória
      if (!compra.EMPRESA_ID)
        return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'É Necessário informar a Empresa')

      // Valor do Pedido deve ser maior que zero
      if (!compra.VL_PEDIDO || Number(compra.VL_PEDIDO) <= 0) 
        return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'O Valor do Pedido deve ser maior que zero')  

      // Placa obrigatória
      if (!compra.PLACA)
        return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'É Necessário informar a Placa')

      // Transportadora obrigatória
      if (!compra.TRANSPORTADORA_ID)
        return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'É Necessário informar a Transportadora')

      // Nota fiscal obrigatória, a menos que marcado "concluir sem nota"
      if (!compra.NOTA_FISCAL?.trim() && compra.OP_CONCLUIR_SEM_NOTA !== '1')
        return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe a Nota Fiscal\nOu marque a opção concluir sem Nota Fiscal')

      // Número externo obrigatório
      if (!compra.NUMERO_EXTERNO?.trim())
        return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Número Externo')

      // Data de chegada necessária obrigatória
      if (!compra.DT_CHEGADA_NECESSARIA)
        return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'É Necessário informar a Data de Chegada Necessária')

      // Data de conferência obrigatória
      if (!compra.DT_CONFERENCIA_INICIO)
        return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe a Data de Descarregamento - Descarregamento no Destino')

      // Opção de financeiro obrigatória
      if (!compra.OP_FINANCEIRO)
        return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Verifique as condições de pagamento\nÉ necessário informar a Opção de Financeiro')

      // === CRÍTICAS DO FINANCEIRO ===
      if (['2'].includes(compra.OP_FINANCEIRO)) { // 1 - Não gera Financeiro
        // Não pode ter grupo apagar
        if (Number(compra.GRUPO_APAGAR_ID) > 0)
          return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'A Opção GERAR FINANCEIRO esta desmarcada\nRemova o Grupo Apagar')

        // Não pode ter centro de custo
        if (Number(compra.CENTRO_CUSTO_ID) > 0)
          return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'A Opção GERAR FINANCEIRO esta desmarcada\nRemova o Centro de Custo')

        // Não pode ter parcelamento
        if (this.compra.OP_PARCELAMENTO != '0' && this.compra.OP_PARCELAMENTO != '')
          return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Remova a quantidade de Parcelas\nA Opção GERAR FINANCEIRO esta desmarcada')  
        
        // Não pode ter parcelas geradas
        if (Array.isArray(parcelas) && parcelas.length > 0)
          return Tools.exibirMensagem(this.$store, 'Aviso', 'warning',
        'A Opção GERAR FINANCEIRO esta desmarcada\nÉ necessário excluir o Parcelamento, e remover os códigos do Centro de Custo e Histórico do Caixa')

        // Não pode ter forma de pagamento
        if (this.compra.OP_FORMA_PAGAMENTO) 
          return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'É necessário remover a Opção de Forma de Pagamento')

      } 
      else  { // -- Gera Financeiro
        // Grupo apagar obrigatório
        if (!compra.GRUPO_APAGAR_ID || compra.GRUPO_APAGAR_ID <= 0)
          return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'É necessário informar o Grupo Apagar')

        // Centro de custo obrigatório
        if (!compra.CENTRO_CUSTO_ID || compra.CENTRO_CUSTO_ID <= 0)
          return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'É necessário informar o Centro de Custo')

        // Parcelamento obrigatório
        if (!this.compra.OP_PARCELAMENTO ||  this.compra.OP_PARCELAMENTO === '0' || this.compra.OP_PARCELAMENTO === '')
          return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'É necessário informar a Opção de Parcelamento')
        
        // Parcelas obrigatórias
        if (!parcelas || parcelas.length <= 0)
          return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'FINANCEIRO\nÉ necessário gerar o Parcelamento')
        
        // Forma de pagamento obrigatória
        if (!this.compra.OP_FORMA_PAGAMENTO) 
          return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'É necessário informar a Opção de Forma de Pagamento')
       
        // Verifica se o parcelamento está correto (soma das parcelas igual ao total do pedido)
        const totalParcelas = parcelas.reduce((acc, parcela) => acc + Number(parcela.VALOR || 0), 0)
        const totalPedido = Number(this.compra.VL_PEDIDO || 0)
        // Arredonda para 2 casas decimais antes de comparar
        const arredonda = v => Math.round((v + Number.EPSILON) * 100) / 100
        if (arredonda(totalParcelas) !== arredonda(totalPedido)) {
          return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'A soma das parcelas é diferente do TOTAL DO PEDIDO DE COMPRA!\nCorrija o Parcelamento!')
        }  
      }

      // === CRÍTICAS DE ESTOQUE ===

      // Se marcou para gerar estoque, centro de estoque é obrigatório
      if (compra.OP_GERA_ESTOQUE === 'S' && !compra.CENTRO_ESTOQUE_ID) {
        return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'É Necessário informar o Centro de Estoque')
      }

      // Validação: Para pedido de Almoxarifado, o centro de estoque deve ser do tipo 3 (Almoxarifado)
      if (compra.OP_TIPO_PEDIDO === 'A' && compra.OP_GERA_ESTOQUE === 'S' && compra.CENTRO_ESTOQUE_ID) {
        try {
          const centroEstoqueResult = await this.$http.get(`/api/protected/centroestoque/getById/${compra.CENTRO_ESTOQUE_ID}`)
          const centroEstoque = centroEstoqueResult?.data?.[0]
          
          if (!centroEstoque) {
            return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 
              'Centro de Estoque não encontrado!')
          }
          
          if (centroEstoque.TIPO !== '3') {
            return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 
              'Para compras de Almoxarifado, o Centro de Estoque deve ser do tipo Almoxarifado (Tipo 3)!')
          }
        } catch (err) {
          console.error('Erro ao validar centro de estoque:', err)
          return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 
            'Não foi possível validar o Centro de Estoque')
        }
      }

      // === REGRAS ESPECÍFICAS POR TIPO DE ESTOQUE E PEDIDO ===
      
      if (estoqueEtiquetado) {
        // --- ESTOQUE ETIQUETADO + INDÚSTRIA ---
        if (compra.OP_TIPO_PEDIDO === 'I') {
          // Obrigatório gerar estoque
          if (compra.OP_GERA_ESTOQUE === 'N') {
            return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 
              'Estoque Etiquetado: É obrigatório marcar GERAR ESTOQUE para pedidos de Indústria')
          }

          // Não pode concluir sem conferência
          if (compra.OP_CONCLUIR_SEM_RECEPCAO === '1') {
            return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 
              'Estoque Etiquetado: Não é permitido CONCLUIR SEM CONFERÊNCIA\nA entrada de estoque só ocorre via conferência de etiquetas')
          }

          // Deve ter solicitado conferência
          if (compra.OP_RECEPCAO === '0') {
            return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 
              'Estoque Etiquetado: É necessário solicitar a conferência antes de finalizar')
          }

          /* OP_RECEPCAO - Status da conferência:
             '0' - NÃO SOLICITADO
             '1' - CONF ABERTA
             '2' - EM CONFERENCIA  
             '3' - CONFERIDO */
          if (['1', '2'].includes(compra.OP_RECEPCAO)) {
            return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 
              'A mercadoria ainda não foi conferida\nAguarde a conclusão da conferência para finalizar a compra')
          }
        }
        
        // --- ESTOQUE ETIQUETADO + ALMOXARIFADO ---
        if (compra.OP_TIPO_PEDIDO === 'A') {
          // Almoxarifado com estoque etiquetado: permite finalizar normalmente
          // Estoque será gerado em ESTOQUE_MOVIMENTO
          if (compra.OP_GERA_ESTOQUE === 'S' && !compra.CENTRO_ESTOQUE_ID) {
            return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 
              'É Necessário informar o Centro de Estoque')
          }
        }

      } else {
        // --- ESTOQUE NÃO ETIQUETADO (Acumulado) ---
        
        // Não permite conferência para estoque acumulado
        if (compra.OP_RECEPCAO !== '0') {
          return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 
            'Estoque Não Etiquetado: Não é permitido usar conferência\nCancele a solicitação de conferência')
        }

        // Obrigatório concluir sem conferência
        if (compra.OP_CONCLUIR_SEM_RECEPCAO !== '1') {
          return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 
            'Estoque Não Etiquetado: Marque a opção CONCLUIR SEM CONFERÊNCIA')
        }

        // Obrigatório gerar estoque
        if (compra.OP_GERA_ESTOQUE !== 'S') {
          return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 
            'Estoque Não Etiquetado: É obrigatório marcar GERAR ESTOQUE\nO estoque será gerado diretamente na finalização')
        }
      }

      const itensLoteInconsistentes = this.listarItensLoteInconsistentes()
      if (itensLoteInconsistentes.length) {
        const detalhes = itensLoteInconsistentes
          .map(item => `${item.PRODUTO_ID} - ${item.NOME_PRODUTO}`)
          .join('\n')
        return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Existem itens com lotes pendentes ou inconsistentes:\n${detalhes}`)
      }

      // Verifica se há item sem preço ou quantidade
      const existeItemSemPreco = Array.isArray(this.tabelaItens.items) && this.tabelaItens.items.some(item =>
        (parseFloat(item.VL_TOTAL_FOB) || 0) <= 0
      )

      // Bloqueia se houver item sem preço ou quantidade
      if (existeItemSemPreco)
        return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação Não Permitida!\nExistem Itens sem Preço ou Sem quantidade')

      // Confirmação final
      const msg = await this.$bvModal.msgBoxConfirm('Finalizar a Compra?', {
        title: 'Finalizar',
        size: 'sm',
        buttonSize: 'xl',
        okVariant: 'success',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
        noCloseOnEsc: true, 
        noCloseOnBackdrop: true
      })
      
      if (msg == false) return


      try { 
        this.$store.commit('controle/setAguardando', true)  
        
        const bodyFinalizar = {
          compra : this.compra,
          login: window.localStorage.getItem('login'),
        }
        try {
          await this.$http.post(`/api/protected/gestaoCompra/finalizar`, bodyFinalizar)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return
        }

        try {
          await this.getCompra(this.compra.ID)
        } catch {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return
        }

        // Atualiza listagem na store ANTES de navegar
        await this.$store.dispatch('compra/GERAR_LISTA')
        
        Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Compra Finalizada com Successo!' )
        this.$store.commit("compra/SET_REGISTRO_SELECIONADO_ID", this.compra.ID)
        
        // NÃO desliga loading aqui - será desligado no finally
        this.$router.push(`/movimentos/compras/listagem/`)
        
      } finally {
        this.$store.commit('controle/setAguardando', false)  
      }
    },

    async devolverProTerminal() {
      const compra = this.compra

      if (compra.USUARIO_DIVERGENCIA) { // Almoxarifado
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'É Necessário Remover a autorização de Divergência primeiro')
        return
      }



      const msg = await this.$bvModal.msgBoxConfirm('Devolver ao Terminal de Coleta?', {
        title: 'Conferir',
        size: 'sm',
        buttonSize: 'xl',
        okVariant: 'success',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
        noCloseOnEsc: true, 
        noCloseOnBackdrop: true
      })
      
      if (msg == false) return


      try { 
        this.$store.commit('controle/setAguardando', true)  
        
        const bodyDevolver = {
          id : this.compra.ID,
          login: window.localStorage.getItem('login'),
        }
        try {
          await this.$http.post(`/api/protected/gestaoCompra/devolverTerminal`, bodyDevolver)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return
        }

        try {
          await this.getCompra(this.compra.ID)
        } catch {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return
        }
        
        this.conferencia.items = []

      } finally {
        this.$store.commit('controle/setAguardando', false)  
      }

    },
    async cancelarSolicitacaoConferencia() {
      const compra = this.compra

      if (compra.OP_CARGA_XML === '1') { // Almoxarifado
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não é permitido alterar a Conferência porque o XML de Carga já entrou no Estoque')
        return
      }


      
      if (compra.OP_CONCLUIR_SEM_RECEPCAO === '1') {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Desmarque a opção concluir sem Conferência')
        return
      }
      
      if (compra.USUARIO_DIVERGENCIA) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'É Necessário Remover a autorização de Divergência primeiro')
        return
      }

      let existeEtiquetasResult = null
      try {
        existeEtiquetasResult = await this.$http.get(`api/protected/estoqueetiqueta/totalizarPorPedidoCompra/${this.compra.ID}`)
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação indisponíve! Não foi possivel verificar a conferência dos produtos!')
        return
      }

      const existeConferencia = existeEtiquetasResult?.data?.total ?? null
      
      if (existeConferencia === null) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação indisponíve! Não foi possivel verificar a conferência dos produtos!')
        return
      }
      if (existeConferencia > 0) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação Negada! Já existem Produtos Coletados na Conferência!!')
        return
      }

      const msg = await this.$bvModal.msgBoxConfirm('Cancelar Solicitação de Conferencia dos produtos?', {
        title: 'Conferir',
        size: 'sm',
        buttonSize: 'xl',
        okVariant: 'success',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
        noCloseOnEsc: true, 
        noCloseOnBackdrop: true
      })
      
      if (msg == false) return


      this.compra.OP_RECEPCAO = '0' //Não Vinculada
      this.compra.DT_SOLICITA_CONFERENCIA = null
      this.compra.USUARIO_SOLICITA_CONFERENCIA = null

      try { 
        this.$store.commit('controle/setAguardando', true)  
        
        try {
          await this.$http.post(`/api/protected/gestaoCompra/edit`, this.compra)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return
        }

        try {
          await this.getCompra(this.compra.ID)
        } catch {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return
        }
        
        this.conferencia.items = []

      } finally {
        this.$store.commit('controle/setAguardando', false)  
      }

    },
    async solicitarConferencia() {
      const compra = this.compra
      
      if (!compra.ID) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'É Necessário Gravar o Pedido antes de Solicitar Conferência ')
        return
      }

      if (!compra.FORNECEDOR_ID) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'É Necessário informar o fornecedor')
        return
      }

      if (compra.OP_TIPO_PEDIDO === 'A') { //Compra da Industria
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Pedido para Interesse do ALMOXARIFADO não permite Soliciar Conferência')
          return
      }

      if (this.compra.OP_GERA_ESTOQUE === 'N') { // Não gera Estoque
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação Não Permitida!\nA opção para não gerar Estoque esta acionada')
        return
      }

      if (!compra.CENTRO_ESTOQUE_ID) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'É necessário informar o Centro de Estoque antes de solicitar a conferência')
        return
      }

      const msg = await this.$bvModal.msgBoxConfirm('Solicitar a Conferencia dos Produtos?', {
        title: 'Conferir',
        size: 'sm',
        buttonSize: 'xl',
        okVariant: 'success',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
        noCloseOnEsc: true, 
        noCloseOnBackdrop: true
      })
      
      if (msg == false) return

      try {
        this.$store.commit('controle/setAguardando', true)
        const body = {
          compra: this.compra,
          login: window.localStorage.getItem('login'),
        }

        try {
          await this.$http.post(`/api/protected/gestaoCompra/solicitarConferencia`, body)
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return
        }

        try {
          await this.getConferencia(this.compra.ID)
        } catch (err) {
          console.log(err)
          throw err
        }
        
        try {
            await this.getCompra(this.compra.ID)
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Operação Indisponível! Não foi possível registrar as alterações' )
          return
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
        
    },
    async atualizarPelaConferencia() {
      const compra = this.compra
      
      if (!compra.ID) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'É Necessário Gravar o Pedido antes de Solicitar Conferência ')
        return
      }

      if (!compra.FORNECEDOR_ID) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'É Necessário informar o fornecedor')
        return
      }

      if (compra.OP_TIPO_PEDIDO === 'A') { //Compra da Industria
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Pedido para Interesse do ALMOXARIFADO não permite Atualizar pela Conferência')
          return
      }

      if (this.compra.OP_GERA_ESTOQUE === 'N') { // Não gera Estoque
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação Não Permitida!\nA opção para não gerar Estoque esta acionada')
        return
      }

      if (this.compra.OP_FINANCEIRO === '2') { // Financeiro Fechado
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação Não Permitida!\n O financeiro já foi fechado')
        return
      }


      const msg = await this.$bvModal.msgBoxConfirm('Atualizar produtos pelo saldo da Conferencia dos Produtos?', {
        title: 'Conferir',
        size: 'sm',
        buttonSize: 'xl',
        okVariant: 'success',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
        noCloseOnEsc: true, 
        noCloseOnBackdrop: true
      })
      
      if (msg == false) return

      try {
        this.$store.commit('controle/setAguardando', true)
        const body = {
          compra: this.compra,
          login: window.localStorage.getItem('login'),
        }

        try {
          await this.$http.post(`/api/protected/gestaoCompra/atualizarPelaConferencia`, body)
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return
        }

        try {
          await this.getItens(this.compra.ID)
        } catch (err) {
          console.log(err)
          throw err
        }
        
        try {
            await this.getCompra(this.compra.ID)
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Tente recarregar o Pedido. Volte e Abra novamente!' )
          return
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
        
    },
    async getTipoPagamento() {
        let tipoPagamentoResult = null
        try { 
          tipoPagamentoResult = await this.$http.get('/api/protected/tipopagamento/listartodos')
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Os tipos de pagamentos estão indisponíveis!' )
          return
        }
        
        const tipoPagamentos = tipoPagamentoResult.data
        if (!tipoPagamentos) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Os tipos de pagamentos estão indisponíveis!' )
          return
        }
        this.despesas.tipoPagamento.items = []
        for (let i = 0; i < tipoPagamentos.length; i++) {
          this.despesas.tipoPagamento.items.push({value: tipoPagamentos[i].CD_TIPO_PAGAMENTO, text: tipoPagamentos[i].CODIGONOME})
        }
    },
    async gerarFinanceiro() {
      const compra = this.compra
      const parcelas = Number(compra.OP_PARCELAMENTO || 0)

      // Se marcado "NÃO GERAR FINANCEIRO" e houver parcelas, bloqueia operação
      if (compra.OP_FINANCEIRO === '2' && parcelas > 0) {
        Tools.exibirMensagem(this.$store, 'Operação Bloqueada', 'warning',
          `Operação Bloqueada!\nA Opção NÃO GERAR FINANCEIRO foi marcada\nSelecione Tipo de Pagamento 09 - NENHUM, e pressione Gerar Parcelamento para excluir as parcelas`)
        return
      }

      // Fornecedor obrigatório
      if (!compra.FORNECEDOR_ID) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'É Necessário informar o fornecedor')
        return
      }

      // Comprador obrigatório
      if (!compra.COMPRADOR_ID) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'É Necessário informar o Comprador')
        return
      }

      // Centro de estoque obrigatório para Almoxarifado
      if (!compra.CENTRO_ESTOQUE_ID && compra.OP_TIPO_PEDIDO === 'A') {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'É Necessário informar o Centro de Estoque')
        return
      }

      // Transportadora obrigatória
      if (!compra.TRANSPORTADORA_ID) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'É Necessário informar a Transportadora')
        return
      }

      // Data de entrada no estoque obrigatória
      if (!compra.DT_CONFERENCIA_INICIO) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'É Necessário informar a Data da Entrada no Estoque - Descarregamento')
        return
      }

      // Valor da compra não pode ser negativo
      if ((compra.VL_PEDIDO ?? 0) < 0) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'O valor da Compra está negativo')
        return
      }

      // Centro de custo obrigatório
      if (!compra.CENTRO_CUSTO_ID) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'É Necessário informar o Centro de Custo')
        return
      }

      // Grupo apagar obrigatório
      if (!compra.GRUPO_APAGAR_ID) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'É Necessário informar o Grupo Apagar')
        return
      }

      // Para indústria, exige nota fiscal ou marcar "concluir sem nota"
      if (compra.OP_TIPO_PEDIDO === 'I' && compra.OP_XML === '0' && compra.OP_CONCLUIR_SEM_NOTA === '0') {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe a nota fiscal ou selecione Concluir Processo sem Nota Fiscal')
        return
      }

      // Número externo obrigatório
      if (!compra.NUMERO_EXTERNO?.trim()) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Número do DOCUMENTO')
        return
      }

      // Deve haver pelo menos um item lançado
      if (!Array.isArray(this.tabelaItens.items) || this.tabelaItens.items.length <= 0) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'É necessário lançar os itens da Compra')
        return
      }

      
      if (!this.compra.OP_FORMA_PAGAMENTO || this.compra.OP_FORMA_PAGAMENTO.trim() === '0') {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'É necessário informar a Opção de Tipo de Pagamento')
        return
      }

      // Regras específicas para indústria
      if (compra.OP_TIPO_PEDIDO === 'I') {
        // Se não há conferência vinculada e não está marcado "concluir sem conferência", bloqueia
        if (compra.OP_RECEPCAO === '0' && compra.OP_CONCLUIR_SEM_RECEPCAO !== '1') {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Nenhuma Conferência Vinculada! Marque a opção concluir sem Conferência!')
          return
        }

        // Se há divergência na recepção e não está autorizada, bloqueia
        if (compra.OP_RECEPCAO === '1' && !compra.USUARIO_DIVERGENCIA) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Recepção com divergência. É necessário autorizar!')
          return
        }
      }

     

      const existeItemSemPreco = this.tabelaItens.items.some(item => (item.VL_TOTAL_FOB ?? 0) <= 0)

      if (existeItemSemPreco) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação Não Permitida!\nExistem Itens sem Preço ou Sem quantidade')
        return
      }

      if (this.parcelamento.items.length !== Number((compra.OP_PARCELAMENTO || '').toString().trim())) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'A quantidade de Parcelas não corresponde às parcelas Geradas!\nUtilize o Botão Gerar Parcelamento!!!!!')
        return false
      }

      const totalParcelado = this.parcelamento.items.reduce((total, parcela) => total + Number(parcela.VALOR || 0), 0)
      const pedidoTotal = Number(compra.VL_PEDIDO || 0)

      if (Tools.arredondarValor(totalParcelado, 2) !== Tools.arredondarValor(pedidoTotal, 2)) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'A soma nas parcelas é diferente do TOTAL DO PEDIDO DE COMPRA!\nCorrija o Parcelamento!!!!!')
        return
      }
      
      const msg = await this.$bvModal.msgBoxConfirm('Gerar o Título a Pagar do Pedido de Compra?.', {
        title: 'Financeiro',
        size: 'sm',
        buttonSize: 'xl',
        okVariant: 'success',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
        noCloseOnEsc: true, 
        noCloseOnBackdrop: true
      })
      
      if (msg == false) return
      
      try { 
        this.$store.commit('controle/setAguardando', true)  
        
        const bodyFinanceiro = {
          compra : this.compra,
          login: window.localStorage.getItem('login'),
        }
        try {
          await this.$http.post(`/api/protected/gestaoCompra/gerarFinanceiro`, bodyFinanceiro)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return
        }

        try {
          await this.getCompra(this.compra.ID)
        } catch {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return
        }

      } finally {
        this.$store.commit('controle/setAguardando', false)  
      }
    },
  
    async downloadPDFNfe () {
      try {
        this.$store.commit('controle/setAguardando', true)

        const body = {
          chaveAcesso: this.compra.NOTA_FISCAL,
          empresaId: this.compra.EMPRESA_ID
        }

        const response = await this.$http.post(`/api/protected/integrador/downloadPDFTerceiros/`, body)

        const resultado = response.data

        if (!resultado || !resultado.sucesso || !resultado.pdfBase64) {
          const erro = resultado?.erro || 'Não foi possível baixar o PDF da Nota Fiscal.'
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', erro)
          return
        }

        // Converte base64 para blob
        const byteCharacters = atob(resultado.pdfBase64)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: 'application/pdf' })

        // Cria a URL e abre o PDF
        const url = window.URL.createObjectURL(blob)
        window.open(url)

      } catch (err) {
        console.error('Erro na download da nota:', err)

        const erroMsg = err.response?.data?.erro || 'Falha inesperada ao gerar a nota fiscal.'
        this.$root.$bvToast.toast(erroMsg, {
          title: 'Erro',
          autoHideDelay: 2000,
          variant: 'danger',
          appendToast: true
        })

      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async gerarParcelamento() {
      if (this.compraFechada) return

      if (!this.compra.OP_PARCELAMENTO) {
        Tools.exibirMensagem(this.$store, 'Operação Bloqueada', 'warning', `A quantidade de Parcelas inválida`)
        return
      }

      const parcelas = Number(this.compra.OP_PARCELAMENTO)

      if ((this.compra.OP_FINANCEIRO == '2') && (parcelas > 0)) {
        Tools.exibirMensagem(this.$store, 'Operação Bloqueada', 'warning', `Operação Bloqueada! 
        A Opção NÃO GERAR FINANCEIRO foi marcada 
        Selecione 09 - NENHUM, e pressione Gerar Parcelamento para excluir as parcelas`)
        return
      }

      if (!this.compra.DT_PEDIDO) {
          Tools.exibirMensagem(this.$store, 'Operação Bloqueada', 'warning', `Informe a data Efetivação da Compra antes de gerar o parcelamento`)
          return
        }

      if (!this.tabelaItens.items.length) {
          Tools.exibirMensagem(this.$store, 'Operação Bloqueada', 'warning', `É necessário lançar os itens da Compra`)
          return
      }

      

      const itensInvalidos = this.tabelaItens.items.filter(item => {
        const valor = Number(item.VL_TOTAL_FOB)
        return !valor // vai ser true se for 0, NaN, null, undefined ou ''
      })

      if (itensInvalidos.length > 0) {
        Tools.exibirMensagem(this.$store, 'Operação Bloqueada', 'warning', `Existem Itens sem Preço ou Sem quantidade`)
        return
      }

      
      /*
      if (isNaN(parcelas) || parcelas < 0) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe a quantidade de parcelas corretamente.')
        return
      }
        */

      try {
        this.$store.commit('controle/setAguardando', true)
      
        const parcelasInt = Math.round(parcelas)

        // Corrigir a data de entrada
        const baseData = new Date(`${this.compra.DT_PEDIDO}T00:00:00`) // evita problemas de fuso
        
        const valorBase = this.arredondar(this.compra.VL_PEDIDO / parcelasInt)
        const totalBase = this.arredondar(valorBase * parcelasInt)
        const diferenca = this.arredondar(this.compra.VL_PEDIDO - totalBase) // pode ser centavos negativos

        this.parcelamento.items = []

        for (let i = 1; i <= parcelasInt; i++) {
          const vencimento = this.somarMeses(baseData, i)

          let valor = valorBase

          if (i === 1) {
            valor = this.arredondar(valorBase + diferenca) // soma o resto à primeira parcela
          }

          this.parcelamento.items.push({
            ID: -1,
            PEDIDO_COMPRA_ID: this.compra.ID,
            PARCELA: i,
            VENCIMENTO: vencimento.toISOString().slice(0, 10), // data ISO
            VALOR: valor
          })
        }

        try {
          await this.$http.post(`/api/protected/gestaoCompra/edit`, this.compra)
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Operação Indisponível! Não foi possível registrar os dados do Pedido' )
          return
        }

        //Apaga o parcelamento no backend
        try {
          await this.$http.post('/api/protected/gestaoCompra/parcelamento/deleteParcelas/'+this.compra.ID)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Nao foi possivel Excluir as parcelas atuais.')
          return
        }
        //Se tiver mais de uma parcela então deve-se cadastrar no backend
        if (parcelas > 0) {
          try {
            await this.$http.post('/api/protected/gestaoCompra/parcelamento/postParcelas/',{parcelas: this.parcelamento.items})
          } catch (err) {
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Nao foi possivel Cadastras as parcelas.')
            this.parcelamento.items = []
            return
          }
        }

      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
      

        
    },
    somarMeses(data, meses) {
      const d = new Date(data.getTime())
      const diaOriginal = d.getDate()
      d.setMonth(d.getMonth() + meses)

      // Corrige casos como 31 de janeiro + 1 mês => 3 de março
      if (d.getDate() < diaOriginal) {
        d.setDate(0) // vai para o último dia do mês anterior
      }

      return d
    },
    abrirModaldeleteItem(item) { 
      if (item.PECAS_COLETADAS > 0) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não é possível excluir o item, pois já existem etiquetas coletadas para este produto nesta compra.')
        return
      }
      
      this.itemExcluir.CODIGO_NOME_PRODUTO = `${item.ID} - ${item.NOME_PRODUTO}` 
      this.itemExcluir.ID = item.ID
      this.itemExcluir.PRODUTO_ID = item.PRODUTO_ID
      this.itemExcluir.QUANT = item.NR_PESO_LIQUIDO
      this.itemExcluir.PECAS = item.QT_PECAS
      this.itemExcluir.VL_UNT = item.VL_UNITARIO_FOB
      this.itemExcluir.VL_TOTAL_BRUTO = item.VL_TOTAL_FOB
         
      this.itemExcluir.QUANT_MASK          = item.NR_PESO_LIQUIDO ? item.NR_PESO_LIQUIDO.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0.00
      this.itemExcluir.VL_UNT_MASK         = item.VL_UNITARIO_FOB ? item.VL_UNITARIO_FOB.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL', minimumFractionDigits: 3, maximumFractionDigits: 3}) : 0.000
      this.itemExcluir.VL_TOTAL_BRUTO_MASK = item.VL_TOTAL_FOB ? item.VL_TOTAL_FOB.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
  
      this.$refs['modal-excluir-item'].show()
    },

    abrirModalCancelarFinanceiro() {
      this.modalCancelarFinanceiro.motivo = null
      this.$refs['modal-cancelar-financeiro'].show()
    },
    async cancelarFinanceiro() {
      if (!this.modalCancelarFinanceiro.motivo || this.modalCancelarFinanceiro.motivo.length < 10) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o motivo com no mínimo 10 caracteres')
        return
      }

      try {
        this.$store.commit('controle/setAguardando', true)

        const payload = {
          compra: this.compra,
          info: {
            login: window.localStorage.getItem('login'),
            motivo: this.modalCancelarFinanceiro.motivo
          }
        }
        
        let dados = await this.$http.post('/api/protected/gestaoCompra/cancelarFinanceiro', payload)
        this.compra = dados.data.compra ?? null
        if (!this.compra) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Operação Indisponível! Não foi possível atualizar os dados da compra')
          return
        }

        this.ajustarCamposTabelaPrincipal()
        
        await this.getParcelamento()
        

        this.$refs['modal-cancelar-financeiro'].hide()
        Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Financeiro cancelado com sucesso!')
      } catch (err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err)
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    abrirModalCancelarFinanceiro() {
      this.modalCancelarFinanceiro.motivo = null
      this.$refs['modal-cancelar-financeiro'].show()
    },
    async abrirModalReabrir() {
      this.modalReabrir.motivo = null
      this.modalReabrir.valorPedido = this.compra.VL_PEDIDO && this.compra.VL_PEDIDO > 0.00 ?  this.compra.VL_PEDIDO.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
      this.$refs['modal-reabrir'].show()
      this.$nextTick(() => {
        this.$refs.edMotivoReabrir.focus()
      })
    },
    async reabrir() {
      const compra = this.compra
      
      if (!compra.ID) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'É Necessário Gravar o Pedido antes de Solicitar Conferência ')
        return
      }

      if (!this.compra.OP_STATUS === '2') {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'A compra não está finalizada')
        return
      }

      if (!this.valMotivoReabertura) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o motivo para reabertura da compra (mínimo 20 caracteres)')
        return
      }

      try {
        this.$store.commit('controle/setAguardando', true)
        const body = {
          compra: this.compra,
          motivo: this.modalReabrir.motivo,
          login: window.localStorage.getItem('login'),
        }

        try {
          await this.$http.post(`/api/protected/gestaoCompra/reabrir`, body)
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return
        }
        
        try {
            await this.getCompra(this.compra.ID)
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Operação Indisponível! Não foi possível registrar as alterações' )
          return
        }

        this.$refs['modal-reabrir'].hide()
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
        
    },
    focusModalParcela() {
      this.$nextTick(() => {
          this.$refs.edParcelamentoVENCIMENTO.focus()
      })
    },
    focusModalReabrir(){
        this.$refs.edMotivoReabrir.focus()
    },
    focusModaldeleteItem(){

    },
    focusTabPesagem() {
      // Acessa o input encapsulado e aplica o foco
      this.$nextTick(() => {
        if (this.$refs.edPeso && this.$refs.edPeso.$el) {
          this.$refs.edPeso.$el.focus()
          this.$refs.edPeso.$el.select()
        }
      })
    },
    teste() {
    },
    focusModalItem() {
      this.$nextTick(() => {
        if (this.controles.itemAlteracao) {
          this.$refs.edQuant.$el.focus()
        } else {
          this.$refs.edPRODUTO_ID.$refs.auto.$refs.autocomplete.focus()
        }
      })
    },
    focusTabProduto() {
    /*
      if (this.$refs.edPRODUTO_ID) {
        this.$refs.edPRODUTO_ID.$refs.auto.$refs.autocomplete.focus()
      } else {
      }
    */
   
    },
    /** ****************************** ICMS ***************************************** */
    regraOP_ICMS_SITUACAO_TRIBUTARIA() {
      this.icms.habilitado.comboOP_ICMS_SITUACAO_TRIBUTARIA = false
      this.icms.habilitado.comboOP_ICMS_ORIGEM              = false 

      //Grupo ICMS Normal}
      this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC     = false
      this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC       = false
      this.icms.habilitado.edVL_ICMS_BASE_CALC              = false
      this.icms.habilitado.edVL_ICMS_ALIQUOTA               = false
      this.icms.habilitado.edVL_ICMS_PERC_BC_OPER_PROPRIA   = false
      this.icms.habilitado.edVL_ICMS                        = false

      this.icms.habilitado.comboOP_MOTIVO_DESONERACAO       = false

      //Grupo ICMS Normal ST}
      this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC_ST  = false
      this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC_ST    = false
      this.icms.habilitado.edVL_ICMS_MARGEM_VL_ADIC_ST      = false
      this.icms.habilitado.edVL_ICMS_BASE_CALC_ST           = false
      this.icms.habilitado.edVL_ICMS_ALIQUOTA_ST            = false
      this.icms.habilitado.edVL_ICMS_ST                     = false
      this.icms.habilitado.comboID_UF_ICMS_ST               = false

      //Grupo ICMS Simples}
      this.icms.habilitado.edVL_ALIQ_APLICAVEL_CALC_CREDITO = false
      this.icms.habilitado.edVL_CREDITO_ICMS_APROVEITADO    = false

      //Grupo ICMS Simples ST}
      this.icms.habilitado.edVL_ICMS_BC_ST_RETIDO_ANT       = false
      this.icms.habilitado.edVL_ICMS_ST_RETIDO_ANT          = false

      if (this.item.PRODUTO_ID && this.item.PRODUTO_ID > 0 ) {
        this.icms.habilitado.comboOP_ICMS_SITUACAO_TRIBUTARIA = true
        this.icms.habilitado.comboOP_ICMS_ORIGEM              = true
        switch (this.item.OP_ICMS_SITUACAO_TRIBUTARIA) {
          case '00' : //ICMS 00}
            //Grupo ICMS Normal}
            this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC     = true
            this.icms.habilitado.edVL_ICMS_BASE_CALC              = true
            this.icms.habilitado.edVL_ICMS_ALIQUOTA               = true
            //this.icms.habilitado.edVL_ICMS                        = true
            break
          case '10': // ICMS 10}
            //Grupo ICMS Normal}
            this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC     = true
            this.icms.habilitado.edVL_ICMS_BASE_CALC              = true
            this.icms.habilitado.edVL_ICMS_ALIQUOTA               = true
            //this.icms.habilitado.edVL_ICMS                        = true

            //Grupo ICMS Normal ST}
            this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC_ST  = true
            this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC_ST    = true
            this.icms.habilitado.edVL_ICMS_MARGEM_VL_ADIC_ST      = true
            this.icms.habilitado.edVL_ICMS_BASE_CALC_ST           = true
            this.icms.habilitado.edVL_ICMS_ALIQUOTA_ST            = true
            this.icms.habilitado.edVL_ICMS_ST                     = true
            break
          case '20': //{ICMS 20}
            //Grupo ICMS Normal}
            this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC     = true
            this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC       = true
            this.icms.habilitado.edVL_ICMS_BASE_CALC              = true
            this.icms.habilitado.edVL_ICMS_ALIQUOTA               = true
            //this.icms.habilitado.EdVL_ICMS                        = true
            break
          case '30': //ICMS 30}
            //Grupo ICMS Normal ST}
            this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC_ST  = true
            this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC_ST    = true
            this.icms.habilitado.edVL_ICMS_MARGEM_VL_ADIC_ST      = true
            this.icms.habilitado.edVL_ICMS_BASE_CALC_ST           = true
            this.icms.habilitado.EdVL_ICMS_ALIQUOTA_ST            = true
            this.icms.habilitado.edVL_ICMS_ST                     = true
            break
          case '40': //ICMS 40}
            //Grupo ICMS Normal}
            this.icms.habilitado.comboOP_MOTIVO_DESONERACAO       = true
            break
          case '41': //ICMS 41}
            //Grupo ICMS Normal}
            this.icms.habilitado.edVL_ICMS_BC_ST_RETIDO_ANT       = true
            this.icms.habilitado.edVL_ICMS_ST_RETIDO_ANT          = true
            this.icms.habilitado.comboOP_MOTIVO_DESONERACAO       = true
            break
          case '50': //ICMS 50}
            //Grupo ICMS Normal}
            break
          case '51': //ICMS 51}
            //Grupo ICMS Normal}
            this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC     = true
            this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC       = true
            this.icms.habilitado.edVL_ICMS_BASE_CALC              = true
            this.icms.habilitado.edVL_ICMS_ALIQUOTA               = true
            //this.icms.habilitado.edVL_ICMS                        = true
            this.icms.habilitado.edVL_ICMS_BC_ST_RETIDO_ANT       = true
            this.icms.habilitado.edVL_ICMS_ST_RETIDO_ANT          = true
            this.icms.habilitado.comboOP_MOTIVO_DESONERACAO       = true
            break
          case '60': //ICMS 60}
            //Grupo ICMS Simples ST}
            this.icms.habilitado.edVL_ICMS_BC_ST_RETIDO_ANT       = true
            this.icms.habilitado.edVL_ICMS_ST_RETIDO_ANT          = true
            break
          case '70': //ICMS 70}
            //Grupo ICMS Normal}
            this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC     = true
            this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC       = true
            this.icms.habilitado.edVL_ICMS_BASE_CALC              = true
            this.icms.habilitado.edVL_ICMS_ALIQUOTA               = true
            //this.icms.habilitado.edVL_ICMS                        = true

            //Grupo ICMS Normal ST}
            this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC_ST  = true
            this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC_ST    = true
            this.icms.habilitado.edVL_ICMS_MARGEM_VL_ADIC_ST      = true
            this.icms.habilitado.edVL_ICMS_BASE_CALC_ST           = true
            this.icms.habilitado.edVL_ICMS_ALIQUOTA_ST            = true
            this.icms.habilitado.edVL_ICMS_ST                     = true
          break
          case '90': //ICMS 90}
            //Grupo ICMS Normal}
            this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC     = true
            this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC       = true
            this.icms.habilitado.edVL_ICMS_BASE_CALC              = true
            this.icms.habilitado.edVL_ICMS_ALIQUOTA               = true
            //this.icms.habilitado.edVL_ICMS                        = true

            //Grupo ICMS Normal ST}
            this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC_ST  = true
            this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC_ST    = true
            this.icms.habilitado.edVL_ICMS_MARGEM_VL_ADIC_ST      = true
            this.icms.habilitado.edVL_ICMS_BASE_CALC_ST           = true
            this.icms.habilitado.edVL_ICMS_ALIQUOTA_ST            = true
            this.icms.habilitado.edVL_ICMS_ST                     = true
            this.icms.habilitado.comboID_UF_ICMS_ST               = true
            break

          case '101': //ICMS 101}
            //Grupo ICMS Simples}
            this.icms.habilitado.edVL_ALIQ_APLICAVEL_CALC_CREDITO = true
            this.icms.habilitado.edVL_CREDITO_ICMS_APROVEITADO    = true
            break
          case '102': //ICMS 102}
            break
          case '103': //ICMS 103}
            break
          case '201': // ICMS 201}
            //Grupo ICMS Normal ST}
            this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC_ST  = true
            this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC_ST    = true
            this.icms.habilitado.edVL_ICMS_MARGEM_VL_ADIC_ST      = true
            this.icms.habilitado.edVL_ICMS_BASE_CALC_ST           = true
            this.icms.habilitado.edVL_ICMS_ALIQUOTA_ST            = true
            this.icms.habilitado.edVL_ICMS_ST                     = true

            //Grupo ICMS Simples}
            this.icms.habilitado.edVL_ALIQ_APLICAVEL_CALC_CREDITO = true
            this.icms.habilitado.edVL_CREDITO_ICMS_APROVEITADO    = true
            break
          case '202': //ICMS 202}
            //Grupo ICMS Normal ST}
            this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC_ST  = true
            this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC_ST    = true
            this.icms.habilitado.edVL_ICMS_MARGEM_VL_ADIC_ST      = true
            this.icms.habilitado.edVL_ICMS_BASE_CALC_ST           = true
            this.icms.habilitado.edVL_ICMS_ALIQUOTA_ST            = true
            this.icms.habilitado.edVL_ICMS_ST                     = true
            break
          case '203': //ICMS 203}
            //Grupo ICMS Normal ST}
            this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC_ST  = true
            this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC_ST    = true
            this.icms.habilitado.edVL_ICMS_MARGEM_VL_ADIC_ST      = true
            this.icms.habilitado.edVL_ICMS_BASE_CALC_ST           = true
            this.icms.habilitado.edVL_ICMS_ALIQUOTA_ST            = true
            this.icms.habilitado.edVL_ICMS_ST                     = true
            break
          case '300': //ICMS 300}
            break
          case '400': //ICMS 400}
            break
          case '500': //ICMS 500}
            //Grupo ICMS Simples ST}
            this.icms.habilitado.edVL_ICMS_BC_ST_RETIDO_ANT       = true
            this.icms.habilitado.edVL_ICMS_ST_RETIDO_ANT          = true
            break
          case '900': //ICMS 900}
            //Grupo ICMS Normal}
            this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC     = true
            this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC       = true
            this.icms.habilitado.edVL_ICMS_BASE_CALC              = true
            this.icms.habilitado.edVL_ICMS_ALIQUOTA               = true
            //this.icms.habilitado.edVL_ICMS                        = true

            //Grupo ICMS Normal ST}
            this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC_ST  = true
            this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC_ST    = true
            this.icms.habilitado.edVL_ICMS_MARGEM_VL_ADIC_ST      = true
            this.icms.habilitado.edVL_ICMS_BASE_CALC_ST           = true
            this.icms.habilitado.edVL_ICMS_ALIQUOTA_ST            = true
            this.icms.habilitado.edVL_ICMS_ST                     = true

            //Grupo ICMS Simples}
            this.icms.habilitado.edVL_ALIQ_APLICAVEL_CALC_CREDITO = true
            this.icms.habilitado.edVL_CREDITO_ICMS_APROVEITADO    = true
            break
          default:
        }
      }
    },
    /*calculaICMSeIPIGeral() {

      //Não calcula nada ate que o produto seja criado no promise que pega os dados do produto
      if (this.controles.montandoItem == true) {
        return
      }

      let
        frete, seguro, despesas, totalBruto, ipiAliquota, ipiBC,
        ipiTotal, icmsBC, icmsTotal, icmsSTBC, icmsSTTotal, icmsReducao,
        icmsAliquota, icmsMVAAliquota, icmsMVA, icmsSTReducao,
        icmsSTAliquota 

      frete = 0.00
      seguro = 0.00
      despesas = 0.00
      totalBruto = this.item.VL_TOTAL_BRUTO?? 0.00

      ipiBC = totalBruto + seguro + despesas
      if (this.cliente.FIZ_JUR === '0') {
        ipiBC = ipiBC + frete
      }

      // BASE CALC DO IPI*********************************************************** 
      // Se a transportadora NÃO for da empresa emitente então deve-se retirar o frete 
      ipiAliquota = this.item.VL_IPI_ALIQUOTA

      ipiTotal = 0.00
      if (ipiAliquota > 0.00) {
        ipiTotal = ((ipiBC / 100.00) * ipiAliquota )
      }

      icmsReducao = this.item.VL_ICMS_PERCENT_REDUC_BC
      icmsAliquota = this.item.VL_ICMS_ALIQUOTA

      // BASE CALC DO ICMS************************************************************ 
      // Produto para consumo da industria não acrescentao o IPI na Base de Calculo 
      icmsBC = totalBruto
      if (this.cliente.FIZ_JUR === '0') {
        icmsBC = totalBruto + ipiTotal
      }

      if (icmsReducao > 0.00) {
        icmsBC = icmsBC - ((totalBruto / 100.00) * icmsReducao )
      }

      icmsTotal = 0.00
      if (icmsAliquota > 0)  {
        icmsTotal = ((icmsBC / 100.00) * icmsAliquota)
      }
      // MVA ************************************************************************* 
      icmsMVAAliquota = this.item.VL_ICMS_MARGEM_VL_ADIC_ST
      icmsMVA = 0.00
      if (icmsMVAAliquota > 0.00) {
        icmsMVA = ((icmsBC / 100.00) * icmsMVAAliquota)
      }

      // BASE CALC DO ICMS ST********************************************************** 
      icmsSTReducao = this.item.VL_ICMS_PERCENT_REDUC_BC_ST
      icmsSTAliquota = this.item.VL_ICMS_ALIQUOTA_ST
      icmsSTBC = ipiTotal + icmsBC + icmsMVA

      if (icmsSTReducao > 0.00) {
        icmsSTBC = icmsSTBC - ((icmsSTBC / 100.00  ) * icmsSTReducao )
      }

      icmsSTTotal = ((icmsSTBC /100.00) * icmsSTAliquota ) - icmsTotal

      // Atualizar Valores

      this.item.VL_IPI_BASE_CALC      = null
      this.item.VL_IPI_ALIQUOTA       = null
      this.item.VL_IPI                = null
      this.item.VL_ICMS_BASE_CALC     = null
      this.item.VL_ICMS               = null
      this.item.VL_ICMS_BASE_CALC_ST  = null
      this.item.VL_ICMS_ST            = null

      // IPI
      if (this.item.OP_IPI_TIPO_CALCULO === '1') {
        this.item.VL_IPI_ALIQUOTA = ipiAliquota
        this.item.VL_IPI_BASE_CALC = ipiBC
        this.item.VL_IPI = ipiTotal
      }

      // ICMS
      this.item.VL_ICMS_BASE_CALC = null
      this.item.VL_ICMS           = null
      this.item.OP_ICMS_SITUACAO_TRIBUTARIA + ''
      var aux = "00,10,20,70".split(",")
      for (var i = 0; i < aux.length; i++) {
          switch(aux[i]){
              case this.item.OP_ICMS_SITUACAO_TRIBUTARIA:
                this.item.VL_ICMS_BASE_CALC = icmsBC
                this.item.VL_ICMS = icmsTotal
              break
          }
      }
      
      
      // ICMS ST
      this.item.VL_ICMS_BASE_CALC_ST = null
      this.item.VL_ICMS_ST = null
      var aux = "10,30,70,201,202,203".split(",")
      for (var i = 0; i < aux.length; i++) {
          switch(aux[i]){
              case this.item.OP_ICMS_SITUACAO_TRIBUTARIA:
                this.item.VL_ICMS_BASE_CALC_ST = icmsSTBC
                this.item.VL_ICMS_ST = icmsSTTotal
              break
          }
      }
    },*/

    limpaEditsSemValorICMSeIPI(){
      //ICMS
      if (!this.icms.habilitado.edVL_ICMS_BASE_CALC) {  this.item.VL_ICMS_BASE_CALC = null }
      if (!this.icms.habilitado.edVL_ICMS) { this.item.VL_ICMS = null }
      if (!this.icms.habilitado.edVL_ICMS_BASE_CALC_ST) { this.item.VL_ICMS_BASE_CALC_ST = null }
      if (!this.icms.habilitado.edVL_ICMS_ST) { this.item.VL_ICMS_ST = null }

      if (!this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC) { this.item.VL_ICMS_PERCENT_REDUC_BC = null }
      if (!this.icms.habilitado.edVL_ICMS_ALIQUOTA) { this.item.VL_ICMS_ALIQUOTA = null }
      if (!this.icms.habilitado.edVL_ICMS_MARGEM_VL_ADIC_ST) { this.item.VL_ICMS_MARGEM_VL_ADIC_ST = null }
      if (!this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC_ST) {this.item.VL_ICMS_PERCENT_REDUC_BC_ST = null }
      if (!this.icms.habilitado.edVL_ICMS_ALIQUOTA_ST) { this.item.VL_ICMS_ALIQUOTA_ST = null }
      if (!this.icms.habilitado.edVL_ICMS_PERC_BC_OPER_PROPRIA) { this.item.VL_ICMS_PERC_BC_OPER_PROPRIA = null }
      if (!this.icms.habilitado.edVL_ICMS_BC_ST_RETIDO_ANT) { this.item.VL_ICMS_BC_ST_RETIDO_ANT = null }
      if (!this.icms.habilitado.edVL_ICMS_ST_RETIDO_ANT) { this.item.VL_ICMS_ST_RETIDO_ANT = null }
      if (!this.icms.habilitado.edVL_ALIQ_APLICAVEL_CALC_CREDITO) { this.item.VL_ALIQ_APLICAVEL_CALC_CREDITO = null }
      if (!this.icms.habilitado.edVL_CREDITO_ICMS_APROVEITADO) { this.item.VL_CREDITO_ICMS_APROVEITADO = null }
    },
    atualizarTabelaPesagem(){
      let linhas = 0
      // atualiza o ID
      for (let i = 0; i < this.pesagem.items.length; i++) {
        this.pesagem.items[i].ID = i + 1;
        linhas += 1
      }
      
      //Adiciona as linhas em branco
      for (let i = linhas; i < 10; i++) {
        this.pesagem.items.push(
          { ID: i + 1, COL1: null, COL2: null, COL3: null, COL4: null, COL5: null, COL6: null, COL7: null, COL8: null, COL9: null, COL10: null }
        )
        
      }

    },
    limparPesagemEmBranco(){
      let preenchidas = []
      let brancos = []
      for (let i = 0; i < this.pesagem.items.length; i++) {
       if ((this.pesagem.items[i].COL1  === null) && 
            (this.pesagem.items[i].COL2 === null) &&
            (this.pesagem.items[i].COL3 === null) &&
            (this.pesagem.items[i].COL4 === null) &&
            (this.pesagem.items[i].COL5 === null) &&
            (this.pesagem.items[i].COL6 === null) &&
            (this.pesagem.items[i].COL7 === null) &&
            (this.pesagem.items[i].COL8 === null) &&
            (this.pesagem.items[i].COL9 === null) &&
            (this.pesagem.items[i].COL10 === null)) {
         brancos.push(this.pesagem.items[i])     
        } else {
          preenchidas.push(this.pesagem.items[i])     
        }
      }
      this.pesagem.items = []
      this.pesagem.items =  preenchidas
      //let compraAux = JSON.parse(JSON.stringify(this.compra))
    },
    gerarPesagemAlteracao(id){
      this.$http.get(`/api/protected/gestaoCompra/item/getPesagemByItemId/${id}`)
      .then(result => {
        this.pesagem.items = result.data
        this.atualizarTabelaPesagem()
        
      })
      
    },
    atualizarQuantidadeManual(deltaPeso) {
      const pesoLiquidoAnterior = Number(this.item.NR_PESO_LIQUIDO || 0)
      const pesoBrutoAnterior = Number(this.item.NR_PESO_BRUTO || 0)
      const novoPesoLiquido = Math.max(0, pesoLiquidoAnterior + Number(deltaPeso || 0))

      this.item.NR_PESO_LIQUIDO = novoPesoLiquido

      if (pesoBrutoAnterior <= 0 || Math.abs(pesoBrutoAnterior - pesoLiquidoAnterior) <= 0.00001) {
        this.item.NR_PESO_BRUTO = novoPesoLiquido
      }
    },
    limparCelulaPesagem(linhaId, coluna) {
      const index = this.pesagem.items.findIndex(item => item.ID === linhaId)
      if (index !== -1 && this.pesagem.items[index][coluna] !== null) {
        const valorRemovido = this.pesagem.items[index][coluna]
        this.pesagem.items[index][coluna] = null
        if (typeof valorRemovido === 'number' && valorRemovido > 0) {
          this.atualizarQuantidadeManual(-valorRemovido)
          this.item.QT_PECAS = this.item.QT_PECAS > 0 ? this.item.QT_PECAS - 1 : 0
          if (this.item.NR_PESO_LIQUIDO <= 0) {
            this.pesagem.manual = false
          }
        }
      }
    },
    lancarPeso(){
      let parar = false
      for (let i = 0; i < this.pesagem.items.length; i++) {
          for (let j = 0; j < Object.keys(this.pesagem.items[i]).length; j++) {
              if (Object.values(this.pesagem.items[i])[j] === null) {
                  this.pesagem.items[i][Object.keys(this.pesagem.items[i])[j]] = parseFloat(this.pesagem.peso)
                  
                  // Se é a primeira pesagem manual, zera os campos antes de somar para desconsiderar valores digitados diretamente
                  if (!this.pesagem.manual) {
                      this.item.NR_PESO_BRUTO = 0
                      this.item.NR_PESO_LIQUIDO = 0
                      this.item.QT_PECAS = 0
                  }
                  
                  this.atualizarQuantidadeManual(parseFloat(this.pesagem.peso))
                  this.item.QT_PECAS = this.item.QT_PECAS >= 0 ? this.item.QT_PECAS + 1 : this.item.QT_PECAS
                  this.pesagem.manual = true
                  parar = true
                  break
              }
          }
          if (parar) {
              break
          }
      }
      this.pesagem.peso = ''
      this.$refs.edPeso.$el.focus();
      this.$refs.edPeso.$el.select();
    },
    excluirPeso(){
      let parar = false
      for (let i = this.pesagem.items.length; i > 0 ; i--) {
          for (let j = Object.keys(this.pesagem.items[i-1]).length; j > 1;  j--) {
              if ((typeof Object.values(this.pesagem.items[i-1])[j-1] === 'number') && (Object.values(this.pesagem.items[i-1])[j-1] > 0.00)) {
                  this.atualizarQuantidadeManual(-parseFloat(Object.values(this.pesagem.items[i-1])[j-1]))
                  this.item.QT_PECAS = this.item.QT_PECAS >= 0 ? this.item.QT_PECAS - 1 : this.item.QT_PECAS
                  this.pesagem.items[i-1][Object.keys(this.pesagem.items[i-1])[j-1]] = null
                  if (this.item.NR_PESO_LIQUIDO <= 0) {
                    this.pesagem.manual = false
                  }
                  parar = true
                  break
              }
          }
          if (parar) {
              break
          }
      }
    },
    excluirPesagem(){
      for (let i = 0; i < this.pesagem.items.length; i++) {
          for (let j = 0; j < Object.keys(this.pesagem.items[i]).length; j++) {
             if ((j > 0) && (typeof Object.values(this.pesagem.items[i])[j] === 'number')) {
                  this.pesagem.items[i][Object.keys(this.pesagem.items[i])[j]] = null
             }
          }
      }
      this.item.NR_PESO_BRUTO = 0.00
      this.item.NR_PESO_LIQUIDO = 0.00
      this.item.QT_PECAS = 0
      this.pesagem.manual = false
      
      this.$refs.edPeso.$el.focus();
      this.$refs.edPeso.$el.select();
    },
    onHidden_botaoParcelamento() {
      // Return focus to the button
      this.$refs.bt_gerarParcelamento.focus()
    },
    avisosVenda(){
      let retorno = true
      if (!this.valN_VENDA) {
        retorno = false
        this.toastCount++
        this.$root.$bvToast.toast(`Informe o Número do Pedido!! `, {
          title: 'Campo Obrigatório',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
      } 
      if (!this.valFORNECEDOR_ID) {
        retorno = false
        this.toastCount++
        this.$root.$bvToast.toast(`Informe o Cliente!! `, {
          title: 'Campo Obrigatório',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
      } 
      if (!this.valCOD_VENDEDOR) {
        retorno = false
        this.toastCount++
        this.$root.$bvToast.toast(`Informe o Vendedor!! `, {
          title: 'Campo Obrigatório',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
      } 
      if (!this.valCOD_CONFERENTE) {
        retorno = false
        this.toastCount++
        this.$root.$bvToast.toast(`Informe o Conferente!! `, {
          title: 'Campo Obrigatório',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
      } 
      if (!this.valCOD_MOTORISTA) {
        retorno = false
        this.toastCount++
        this.$root.$bvToast.toast(`Informe o Motorista!! `, {
          title: 'Campo Obrigatório',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
      } 
      if (!this.valOP_FORMA_PAGAMENTO) {
        retorno = false
        this.toastCount++
        this.$root.$bvToast.toast(`Informe a forma de Pagamento!! `, {
          title: 'Campo Obrigatório',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
      } 
      if ((this.totalQuant <= 0.00)) {
        retorno = false
        this.toastCount++
        this.$root.$bvToast.toast(`Adicione os Produtos!!`, {
          title: 'Aviso',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
      } 
      if (this.compra.OP_FORMA_PAGAMENTO === 'P' ) { // A PRAZO
         if (!this.valOP_PARCELAMENTO) {
          retorno = false
          this.toastCount++
          this.$root.$bvToast.toast(`Informe o número de Parcelas!! `, {
            title: 'Campo Obrigatório',
            autoHideDelay: 5000,
            variant: 'warning',
            appendToast: true
          })
         } 
         else if  (!this.parcelamento.items.length)  {
          retorno = false
          this.toastCount++
          this.$root.$bvToast.toast(`Faça o parcelamento!! `, {
            title: 'Campo Obrigatório',
            autoHideDelay: 5000,
            variant: 'warning',
            appendToast: true
          })
        }
      }

      return retorno
    },
    avisosItem(){
      return this.valPRODUTO_ID && this.valQuantidadeComercial
    },
    avisosDespesa(){

      return !this.despesas.item.HISTORICO_ID      
          || !this.despesas.item.OP_TIPO_MOVIMENTO 
          || !this.despesas.item.VALOR             
          || !this.despesas.item.OBSERVACOES       
          || !this.despesas.item.DATA_MOVIMENTACAO 
          || !this.despesas.item.DOCUMENTO         
          || !this.despesas.item.TIPO_PAGAMENTO_ID 
          || !this.despesas.item.CENTRO_CUSTO_ID   
          || !this.despesas.item.CLIENTE_ID        


    },
    onHidden_botaoGerarDocumento() {
      // Return focus to the button
      //console.log(this.$refs)
      this.$refs.ob_edDocumento.focus()
    },
    calcularPercentualLimiteCredito(){
      let credito = 0.00
      let usado = 0.00
      if (this.cliente.VL_CREDITO !== null && this.cliente.VL_CREDITO > 0) {
        credito = this.cliente.VL_CREDITO
      }
      if (this.cliente.LIMITE_CREDITO !== null && this.cliente.LIMITE_CREDITO > 0) {
        usado = this.cliente.LIMITE_CREDITO
      } 
      if (credito <= 0) {
        return 100
      } else {
        return 100 - ((credito - usado) / credito) * 100
      }
      
    },
    postProduto(){

    },
    showModalImposto () {
      this.$refs['modal-imposto'].show()
      
    },
    editar() {
      this.$store.commit('controle/setAguardando', true)
      this.controles.botaoGerarDocumento.busy = false
      

      if (!this.isValid) {
        this.$root.$bvToast.toast(`Preencha todos os campos obrigatórios!!!`, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'warning',
          appendToast: true
        })
        this.$store.commit('controle/setAguardando', false)
        this.controles.botaoGerarDocumento.busy = false
        return
      }
      if (this.compra.ID > 0) {
      this.$http.post(`/api/protected/compra/edit`, this.compra)
        .then(response => {
          this.$store.commit('controle/setAguardando', true)
          this.$root.$bvToast.toast(`compra ATUALIZADO com Successo!!!`, {
            title: 'Aviso',
            autoHideDelay: 3000,
            variant: 'success',
            appendToast: true
          })
          this.$router.replace('/movimentos/compras/listagem') 
        })
        .catch(erro => {
          this.$root.$bvToast.toast(`Falha ao executar a operação!! ` + erro, {
            title: 'Erro',
            autoHideDelay: 5000,
            variant: 'danger',
            appendToast: true
          })
          this.$store.commit('controle/setAguardando', false)
          this.controles.botaoGerarDocumento.busy = false
        })
      }
    },
    
    preencherItem(alteracao, item) {
      this.item.ID                 = null,
      this.item.PEDIDO_COMPRA_ID   = null,
      this.item.PRODUTO_ID         = null,
      this.item.ID_UNIDADE_COMERCIAL = null,
      this.item.TX_NOME_PRODUTO    = null,
      this.item.TX_NCM             = null,
      this.item.EAN                = null,
      this.item.QT_PECAS           = 0,
      this.item.VL_ICMS            = 0.00,
      this.item.VL_PIS             = 0.00,
      this.item.VL_COFINS          = 0.00,
      this.item.VL_IBS             = 0.00,
      this.item.VL_CBS             = 0.00,
      this.item.VL_IS              = 0.00,
      this.item.VL_IPI             = 0.00,
      this.item.VL_II              = 0.00,
      this.item.VL_UNITARIO_FOB    = 0.00,
      this.item.VL_FRETE           = 0.00,
      this.item.VL_OUTROS          = 0.00,
      this.item.NR_PESO_BRUTO      = 0.00,
      this.item.NR_PESO_LIQUIDO    = 0.00,
      this.item.VL_TOTAL_CIF       = 0.00,
      this.item.VL_TOTAL_FOB       = 0.00,
      this.item.VL_UNITARIO_CIF    = 0.00,
      this.item.USUARIO_CADASTRO   = window.localStorage.getItem('login'),
      this.item.USUARIO_ALTERACAO  = null,
      this.item.DATA_CADASTRO      = Tools.getDataAtual(),
      this.item.DATA_ALTERACAO     = null,
      this.item.USUARIO_EXCLUSAO   = null,
      this.item.DATA_EXCLUSAO      = null,
      this.item.OP_STATUS          = '1',
      this.item.QUANT_NFE          = 0.00,
      this.item.PECAS_NFE          = 0.00,
      this.item.VL_UNT_NFE         = 0.00,
      this.item.VL_TOTAL_NFE       = 0.00,
      this.item.CENTRO_ESTOQUE_ID  = this.compra.CENTRO_ESTOQUE_ID,
      this.item.PECAS_CONFERENCIA  = null,
      this.item.QUANT_CONFERENCIA  = null,
      this.item.VL_ICMS_ST         = 0.00,
      this.item.VL_PIS_ST          = 0.00,
      this.item.VL_COFINSST        = 0.00
      
      if (alteracao == true) {
        this.item.ID                = item.ID                ?? null
        this.item.PEDIDO_COMPRA_ID  = item.PEDIDO_COMPRA_ID  ?? null
        this.item.PRODUTO_ID        = item.PRODUTO_ID        ?? null
        this.item.ID_UNIDADE_COMERCIAL = item.ID_UNIDADE_COMERCIAL ?? null
        this.item.TX_NOME_PRODUTO   = item.TX_NOME_PRODUTO   ?? null
        this.item.TX_NCM            = item.TX_NCM            ?? null
        this.item.EAN               = item.EAN               ?? null
        this.item.QT_PECAS          = item.QT_PECAS          ?? null
        this.item.VL_ICMS           = item.VL_ICMS           ?? null
        this.item.VL_PIS            = item.VL_PIS            ?? null
        this.item.VL_COFINS         = item.VL_COFINS         ?? null
        this.item.VL_IBS            = item.VL_IBS            ?? null
        this.item.VL_CBS            = item.VL_CBS            ?? null
        this.item.VL_IS             = item.VL_IS             ?? null
        this.item.VL_IPI            = item.VL_IPI            ?? null
        this.item.VL_II             = item.VL_II             ?? null
        this.item.VL_UNITARIO_FOB   = item.VL_UNITARIO_FOB   ?? null
        this.item.VL_FRETE          = item.VL_FRETE          ?? null
        this.item.VL_OUTROS         = item.VL_OUTROS         ?? null
        this.item.NR_PESO_BRUTO     = item.NR_PESO_BRUTO     ?? null
        this.item.NR_PESO_LIQUIDO   = item.NR_PESO_LIQUIDO   ?? null
        this.item.VL_TOTAL_CIF      = item.VL_TOTAL_CIF      ?? null
        this.item.VL_TOTAL_FOB      = item.VL_TOTAL_FOB      ?? null
        this.item.VL_UNITARIO_CIF   = item.VL_UNITARIO_CIF   ?? null
        this.item.USUARIO_CADASTRO  = item.USUARIO_CADASTRO  ?? null
        this.item.USUARIO_ALTERACAO = item.USUARIO_ALTERACAO ?? null
        this.item.DATA_CADASTRO     = item.DATA_CADASTRO     ?? null
        this.item.DATA_ALTERACAO    = item.DATA_ALTERACAO    ?? null
        this.item.USUARIO_EXCLUSAO  = item.USUARIO_EXCLUSAO  ?? null
        this.item.DATA_EXCLUSAO     = item.DATA_EXCLUSAO     ?? null
        this.item.OP_STATUS         = item.OP_STATUS         ?? null
        this.item.QUANT_NFE         = item.QUANT_NFE         ?? null
        this.item.PECAS_NFE         = item.PECAS_NFE         ?? null
        this.item.VL_UNT_NFE        = item.VL_UNT_NFE        ?? null
        this.item.VL_TOTAL_NFE      = item.VL_TOTAL_NFE      ?? null
        this.item.CENTRO_ESTOQUE_ID = item.CENTRO_ESTOQUE_ID ?? null
        this.item.PECAS_CONFERENCIA = item.PECAS_CONFERENCIA ?? null
        this.item.QUANT_CONFERENCIA = item.QUANT_CONFERENCIA ?? null
        this.item.VL_ICMS_ST        = item.VL_ICMS_ST        ?? null
        this.item.VL_PIS_ST         = item.VL_PIS_ST         ?? null
        this.item.VL_COFINSST       = item.VL_COFINSST       ?? null
      }
    },
    limparCompra () {
       this.compra.ID                            = null
       this.compra.DT_PEDIDO                     = null
       this.compra.DT_CHEGADA_PREVISTA           = null
       this.compra.OP_TIPO_PEDIDO                = null
       this.compra.CLIENTE_ID                    = null
       this.compra.VL_PEDIDO                     = 0.00
       this.compra.NR_DIAS_PAGAMENTO             = null
       this.compra.VENDEDOR_ID                   = null
       this.compra.FORNECEDOR_ID                 = null
       this.compra.DT_ENVIO                      = null
       this.compra.DT_EMBARQUE                   = null
       this.compra.TX_USUARIO_INC                = null
       this.compra.TX_USUARIO_ALT                = null
       this.compra.DT_ALTERACAO                  = null
       this.compra.VL_ICMS                       = 0.00
       this.compra.VL_PIS                        = 0.00
       this.compra.VL_COFINS                     = 0.00
       this.compra.VL_IPI                        = 0.00
       this.compra.VL_II                         = 0.00
       this.compra.VL_FRETE                      = 0.00
       this.compra.VL_OUTROS                     = 0.00
       this.compra.NR_PESO_BRUTO                 = 0.00
       this.compra.NR_PESO_LIQUIDO               = null
       this.compra.DT_CHEGADA_EFETIVA            = null
       this.compra.DT_CHEGADA_NECESSARIA         = null
       this.compra.OP_INCOTERMS                  = null
       this.compra.OB_GERAIS                     = null
       this.compra.OP_STATUS                     = null
       this.compra.DT_CADASTRO                   = null
       this.compra.VL_SEGURO                     = null
       this.compra.COMPRADOR_ID                  = null
       this.compra.VL_DESCONTO_IMPOSTO           = null
       this.compra.TRANSPORTADORA_ID             = null
       this.compra.VL_CIF                        = 0.00
       this.compra.VL_FOB                        = 0.00
       this.compra.QT_PECAS                      = null
       this.compra.OP_FORMA_PAGAMENTO            = null
       this.compra.OP_PARCELAMENTO               = null
       this.compra.DT_ENTREGA_PREVISTA           = null
       this.compra.DT_ENTREGA_EFETIVA            = null
       this.compra.VL_TOTAL_DESCONTO             = 0.00
       this.compra.EMBARQUE_REPRESENTA_ID        = null
       this.compra.VL_CREDITO                    = 0.00
       this.compra.VL_DEBITO                     = 0.00
       this.compra.DT_PREVISAO_CARREGAMENTO      = null
       this.compra.DT_PREVISAO_CHEGADA_PORTO     = null
       this.compra.DT_PREVISAO_CEHGADA_PORTO     = null
       this.compra.DT_PREVISAO_SAIDA_PORTO       = null
       this.compra.DT_DESCARREGAMENTO_DESTINO    = null
       this.compra.DT_SAIDA_PORTO                = null
       this.compra.DT_CHEGADA_PORTO              = null
       this.compra.DT_CARREGAMENTO_ORIGEM        = null
       this.compra.NOTA_FISCAL                   = null
       this.compra.OP_EMBARCADO                  = null
       this.compra.CENTRO_ESTOQUE_ID             = null
       this.compra.NFE_DISTRIBUICAO_ID           = null
       this.compra.GRUPO_APAGAR_ID               = null
       this.compra.CENTRO_CUSTO_ID               = null
       this.compra.OP_FINANCEIRO                 = null
       this.compra.OP_XML                        = null
       this.compra.OP_CONCLUIR_SEM_NOTA          = null
       this.compra.RECEPCAO_ID                   = null
       this.compra.USUARIO_DIVERGENCIA           = null
       this.compra.DATA_AUTORIZA_DIVERGENCIA     = null
       this.compra.OP_RECEPCAO                   = '0'
       this.compra.USUARIO_FECHAMENTO            = null
       this.compra.DATA_FECHAMENTO               = null
       this.compra.EMPRESA_ID                    = null
       this.compra.OP_CONCLUIR_SEM_RECEPCAO      = null
       this.compra.CONFERENTE_ID                 = null
       this.compra.DT_CONFERENCIA_INICIO         = null
       this.compra.DT_CONFERENCIA_FIM            = null
       this.compra.USUARIO_CONFERENCIA           = null
       this.compra.USUARIO_REABERTURA            = null
       this.compra.DT_SOLICITA_CONFERENCIA       = null
       this.compra.USUARIO_SOLICITA_CONFERENCIA  = null
       this.compra.PLACA                         = null
       this.compra.MSG_SEFAZ                     = null
       this.compra.DATA_CONFIRMACAO              = null
       this.compra.PROTOCOLO                     = null
       this.compra.DATA_REABERTURA               = null
       this.compra.MOTIVO_REABERTURA             = null
       this.compra.TEMPERATURA_INICIAL           = null
       this.compra.TEMPERATURA_MEIO              = null
       this.compra.TEMPERATURA_FINAL             = null
       this.compra.NOME_ARQUIVO_CARGA_XML        = null
       this.compra.DATA_CARGA_XML                = null
       this.compra.USUARIO_CARGA_XML             = null
       this.compra.OP_CARGA_XML                  = null
       this.compra.NUMERO_EXTERNO                = null
       this.compra.OP_GERA_ESTOQUE               = null
       this.compra.USUARIO_CANCELAMENTO          = null
       this.compra.OBS_CANCELAMENTO              = null
       this.compra.DATA_CANCELAMENTO             = null
       this.compra.DT_PREVISAO_DESCARREGAMENTO   = null
       this.compra.VL_TOTAL_DESPESA              = 0.00
       this.compra.USUARIO_LIBERA_DEVOLUCAO      = null
       this.compra.DATA_LIBERA_DEVOLUCAO         = null
       this.compra.MOTIVO_LIBERA_DEVOLUCAO       = null
    },
    ajustarCamposTabelaPrincipal() {
      this.compra.OP_FORMA_PAGAMENTO            = !this.compra.OP_FORMA_PAGAMENTO ? null : this.compra.OP_FORMA_PAGAMENTO.trim()
      this.compra.OP_STATUS                     = (this.compra.OP_STATUS?.trim()) ?? '1'
      this.compra.OP_PARCELAMENTO               = (this.compra.OP_PARCELAMENTO?.trim()) ?? '0'

      const id = this.compra.COMPRADOR_ID
      this.compra.COMPRADOR_ID = (typeof id === 'string' && id.trim() !== '')
        ? parseInt(id.trim(), 10)
        : (typeof id === 'number' ? id : null)

      this.compra.OP_RECEPCAO                   = String(this.compra.OP_RECEPCAO ?? '')

      this.compra.DT_PEDIDO                     = this.compra.DT_PEDIDO                   ? Tools.formatarDataParaInput(this.compra.DT_PEDIDO                  ) : null
      this.compra.DT_CHEGADA_NECESSARIA         = this.compra.DT_CHEGADA_NECESSARIA       ? Tools.formatarDataParaInput(this.compra.DT_CHEGADA_NECESSARIA      ) : null
      this.compra.DT_CADASTRO                   = this.compra.DT_CADASTRO                 ? Tools.formatarDataParaInput(this.compra.DT_CADASTRO                ) : null

      this.compra.DT_ENTREGA_PREVISTA           = this.compra.DT_ENTREGA_PREVISTA         ? Tools.formatarDataParaInput(this.compra.DT_ENTREGA_PREVISTA        ) : null
      this.compra.DT_ENTREGA_EFETIVA            = this.compra.DT_ENTREGA_EFETIVA          ? Tools.formatarDataParaInput(this.compra.DT_ENTREGA_EFETIVA         ) : null
      this.compra.DT_PREVISAO_CARREGAMENTO      = this.compra.DT_PREVISAO_CARREGAMENTO    ? Tools.formatarDataParaInput(this.compra.DT_PREVISAO_CARREGAMENTO   ) : null
      this.compra.DT_PREVISAO_CHEGADA_PORTO     = this.compra.DT_PREVISAO_CHEGADA_PORTO   ? Tools.formatarDataParaInput(this.compra.DT_PREVISAO_CHEGADA_PORTO  ) : null
      this.compra.DT_PREVISAO_CEHGADA_PORTO     = this.compra.DT_PREVISAO_CEHGADA_PORTO   ? Tools.formatarDataParaInput(this.compra.DT_PREVISAO_CEHGADA_PORTO  ) : null
      this.compra.DT_PREVISAO_SAIDA_PORTO       = this.compra.DT_PREVISAO_SAIDA_PORTO     ? Tools.formatarDataParaInput(this.compra.DT_PREVISAO_SAIDA_PORTO    ) : null
      this.compra.DT_DESCARREGAMENTO_DESTINO    = this.compra.DT_DESCARREGAMENTO_DESTINO  ? Tools.formatarDataParaInput(this.compra.DT_DESCARREGAMENTO_DESTINO ) : null
      this.compra.DT_SAIDA_PORTO                = this.compra.DT_SAIDA_PORTO              ? Tools.formatarDataParaInput(this.compra.DT_SAIDA_PORTO             ) : null
      this.compra.DT_CHEGADA_PORTO              = this.compra.DT_CHEGADA_PORTO            ? Tools.formatarDataParaInput(this.compra.DT_CHEGADA_PORTO           ) : null
      this.compra.DT_CARREGAMENTO_ORIGEM        = this.compra.DT_CARREGAMENTO_ORIGEM      ? Tools.formatarDataParaInput(this.compra.DT_CARREGAMENTO_ORIGEM     ) : null
      this.compra.DATA_AUTORIZA_DIVERGENCIA     = this.compra.DATA_AUTORIZA_DIVERGENCIA   ? Tools.formatarDataParaInput(this.compra.DATA_AUTORIZA_DIVERGENCIA  ) : null
      this.compra.DATA_FECHAMENTO               = this.compra.DATA_FECHAMENTO             ? Tools.formatarDataParaInput(this.compra.DATA_FECHAMENTO            ) : null
      this.compra.DT_CONFERENCIA_INICIO         = this.compra.DT_CONFERENCIA_INICIO       ? Tools.formatarDataParaInput(this.compra.DT_CONFERENCIA_INICIO      ) : null
      this.compra.DT_CONFERENCIA_FIM            = this.compra.DT_CONFERENCIA_FIM          ? Tools.formatarDataParaInput(this.compra.DT_CONFERENCIA_FIM         ) : null
      this.compra.DT_SOLICITA_CONFERENCIA       = this.compra.DT_SOLICITA_CONFERENCIA     ? Tools.formatarDataParaInput(this.compra.DT_SOLICITA_CONFERENCIA    ) : null
      this.compra.DATA_CONFIRMACAO              = this.compra.DATA_CONFIRMACAO            ? Tools.formatarDataParaInput(this.compra.DATA_CONFIRMACAO           ) : null
      this.compra.DATA_REABERTURA               = this.compra.DATA_REABERTURA             ? Tools.formatarDataParaInput(this.compra.DATA_REABERTURA            ) : null
      this.compra.DATA_CARGA_XML                = this.compra.DATA_CARGA_XML              ? Tools.formatarDataParaInput(this.compra.DATA_CARGA_XML             ) : null
      this.compra.DATA_CANCELAMENTO             = this.compra.DATA_CANCELAMENTO           ? Tools.formatarDataParaInput(this.compra.DATA_CANCELAMENTO          ) : null
      this.compra.DT_PREVISAO_DESCARREGAMENTO   = this.compra.DT_PREVISAO_DESCARREGAMENTO ? Tools.formatarDataParaInput(this.compra.DT_PREVISAO_DESCARREGAMENTO) : null

    },
    async imprimirEspelho() {
      if (!this.compra.ID) return
      
      try {
        this.$store.commit('controle/setAguardando', true)
        const response = await this.$http.get(`/api/protected/relatorios/espelhoCompra/${this.compra.ID}`)
        
        if (response.data) {
          await imprimirEspelhoCompra(response.data, localStorage.getItem('nomeusuario'))
        } else {
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Não foi possível obter os dados da compra.')
        }
      } catch (err) {
        console.error(err)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Falha ao gerar espelho da compra.')
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async getCompra(id) {
      try {
        this.controles.carregandoDados = true
        const response = await this.$http.get(`/api/protected/gestaoCompra/getById/${id}`)
        this.compra = (response?.data?.[0]) ?? null
        if (!this.compra) {
          throw new Error('O pedido não foi localizado')
        }

        this.ajustarCamposTabelaPrincipal()
        
        this.$nextTick(() => {
          this.controles.carregandoDados = false
        })

      } catch (err) {
        console.error('Erro em getCompra:', err)
        this.controles.carregandoDados = false
        throw err
      }
    },

    async getItens(compraId) {
      try {
        const response = await this.$http.get('/api/protected/gestaoCompra/item/getByCompraId/'+compraId)
        this.tabelaItens.items = (response.data ?? []).map(item => this.normalizarItemTabela(item))

      } catch (err) {
        console.error('Erro em getItens:', err)
        throw new Error(err)
      }
    },
    async getConferencia(compraId) {
      try {
        this.conferencia.loading = true
        const response = await this.$http.get('/api/protected/gestaoCompra/getEtiquetasRecepcao/'+compraId)
        this.conferencia.items = response.data ?? null

      } catch (err) {
        console.error('Erro em getConferencia:', err)
        throw new Error(err)
      } finally {
        this.conferencia.loading = false
      }
    },
    async getDespesas(compraId) {
      try {
        const response = await this.$http.get('/api/protected/gestaoCompra/despesa/viewDespesas/'+compraId)
        this.despesas.items = response.data ?? null

        this.calcularFinanceiro()

      } catch (err) {
        console.error('Erro em getDespesas:', err)
        throw new Error(err)
      }
    },
    async getParcelamento() {
      try {
        const response = await this.$http.get('/api/protected/gestaoCompra/parcelamento/getByCompraId/'+this.compra.ID)
        const dados = response.data
        this.parcelamento.items = (response?.data) ?? null
        

      } catch (err) {
        console.error('Erro em getParcelamento:', err)
        return new Error(err)
      }
    },
    async carregarParametros () {
      try {
        const response = await this.$http.get(this.$http.defaults.baseURL.concat('api/protected/parametro/getDados'))
        const dados = response.data

        return dados?.[0]

      } catch (err) {
        console.error('Erro em carregarParametros:', err)
        return null
      }
    },
    imprimirEspelhoConferencia() {
      CompraConferenciaReport.imprimir(this.compra, this.$http, this.$store)
    },
    async carregarEmpresas () {
      try {
        this.empresas.items = []
        this.empresas.options = []
        const response = await this.$http.get(this.$http.defaults.baseURL.concat('api/protected/empresa/getTodas'))
        

        const empresasAux = response?.data?? null
        if (!empresasAux) {
          throw new Error("Empresas " + err)
        }
        
        const empresasArray = [].concat(empresasAux || [])

        
        for (let emp of empresasArray) {
          this.empresas.options.push({value: emp.CODIGO, text: `${emp.APELIDO} - ${emp.IE} - ${emp.RAZAO}`})
        }

      } catch (err) {
        console.error('Erro em carregarEmpresas:', err)
      }
    },
    async carregarListaEstoque() {
      try {
        let uri = '/api/protected/centroestoque/listartodos'
        if (this.compra.OP_TIPO_PEDIDO) {
          switch (this.compra.OP_TIPO_PEDIDO) {
            case `I`: uri += '&tipo=1';
              break;
            case `A`: uri += '&tipo=3';
              break;
            default: ''
              break;
          }
        }

        const response = await this.$http.get(uri)
        
        const estoqueAux = response?.data?? null
        if (!estoqueAux) {
          return
        }

        this.estoqueProduto.options = []

        const estoqueArray = [].concat(estoqueAux || [])
        for (let est of estoqueArray) {
          this.estoqueProduto.options.push({value: est.CODIGO, text: est.CODIGONOME})
        }
      } catch (err) {
        console.error('Erro em carregarListaEstoque:', err)
        throw new Error("O estoque está indisponível")
      }
    },
    colorirLimiteCredito(valor) {
      if (valor === 0) return 'primary'
      else if (valor > 0) return 'success'
      else return 'danger'
    },
    traduzOP_RECEPCAO(value) {
      switch (value) {
         case '0': return  'NAO SOLICITADO'
         case '1': return  'CONF ABERTA'
         case '2': return  'EM CONFERENCIA'
         case '3': return  'CONFERIDO'
         default: ''
          break;
      }
    },
    traduzOP_FINANCEIRO(value) {
      switch (value) {
        case '0': return 'FIN. ABERTO'
        case '1': return 'FIN. GERADO'  
        case '2': return 'FIN. NAO GERA'
        default: ''
          break;
      }
    },
    colorirOP_RECEPCAO(value) {
      switch (value) {
        case '0': return 'text-secondary'
        case '1': return 'text-warning'  
        case '2': return 'text-info'
        case '3': return 'text-success'
        default: ''
          break;
      }
    },
    colorirOP_FINANCEIRO(value) {
      switch (value) {
        case '0': return 'warning'
        case '1': return 'success'  
        case '2': return 'info'
        default: ''
          break;
      }
    },
    colorirOP_XML(value) {
      switch (value) {
        case '0': return 'yellow'
        case '1': return 'warning'  
        case '2': return 'success'
        case '3': return 'primary'

        default: ''
          break;
      }
    },
    traduzOP_XML(value) {
      const valor = value?.trim()
      switch (valor) {
        case '0': return 'NFE NAO VINCULADA'
        case '1': return 'NFE DIVERGENTE'
        case '2': return 'NFE VINCULADA'
        case '3': return 'NFE CONFIRMADA SEFAZ'
        default: ''
          break;
      }  
    },
    traduzOP_STATUS(value) {
      const valor = value?.trim()
      switch (valor) {
        case '0': return 'CANCELADO'
        case '1': return 'CADASTRANDO'  
        case '2': return 'CONCLUIDO'
        default: ''
          break;
      }  
    },
    colorirOP_STATUS(value) {
      const valor = value?.trim()
      switch (valor) {
        case '0': return 'danger'
        case '1': return 'warning'  
        case '2': return 'success'
        default: return 'secondary'
      }
    },
    traduzOP_CARGA_XML(value) {
      const valor = value?.trim()
      switch (valor) {
        case null: return ''
        case '0': return 'SEM XML'  
        case '1': return 'XML CARREGADO'
        default: ''
          break;
      }  
    },
    colorirLANCOU_ROMANEIO(value) {
      const valor = value?.trim()
      switch (valor) {
        case null: return 'text-secondary'
        case '0': return 'text-secondary'  
        case '1': return 'text-success'
        default: ''
          break;
      }
    },
    colorirNotaFiscalTIPO_ARQUIVO(value) {
      const valor = value?.trim()
      
      switch (valor) {
        case null: return 'secondary'
        case 'Nota Completa': return 'success'  
        case 'Nota Parcial': return 'warning'
        default: ''
          break;
      }
    },
    colorirOP_GERA_TITULO(value) {
      const valor = value?.trim()
      switch (valor) {
        case null: return 'text-secondary'
        case '0': return 'text-secondary'  
        case '1': return 'text-success'
        default: ''
          break;
      }
    },
    colorirOP_DESPESA(value) {
      const valor = value?.trim()
      switch (valor) {
        case null: return 'text-secondary'
        case '0': return 'text-secondary'  
        case '1': return 'text-success'
        default: ''
          break;
      }
    },
    colorirOP_CARGA_XML(value) {
      const valor = value?.trim()
      switch (valor) {
        case null: return 'secondary'
        case '0': return 'secondary'  
        case '1': return 'success'
        default: ''
          break;
      }
    },
    somarTotalItem() {
      let quantidade = this.item.NR_PESO_LIQUIDO ??  0
      let valor = this.item.VL_UNITARIO_FOB ??  0
      let auxTotal = parseFloat(quantidade * valor).toFixed(2)
      auxTotal = parseFloat(auxTotal)
      
      this.item.VL_TOTAL_FOB = auxTotal
      
      
    },
    carregarTabelaPreco(){
      if (this.item.PRODUTO_ID && this.item.PRODUTO_ID > 0 ) {
        this.$http.get(`/api/protected/tabelaPrecoProduto/getByProduto/${this.item.PRODUTO_ID}`)
        .then(result => {
          this.tabelaPreco.options = []
          result.data.forEach(tabela => {
            this.tabelaPreco.options.push(
              { value: tabela.ID,
                text: tabela.VL_PRECO && tabela.VL_PRECO > 0 ? tabela.VL_PRECO.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) + ' - ' + tabela.DESCRICAO : ''
              }
            )
          })
          this.tabelaPreco.selected = result.data[0].ID
        })
        .catch(() => {
          this.toastCount++
          this.$root.$bvToast.toast(`Não foi Possível encontrar as tabelas de Preços!!`, {
            title: 'Erro',
            autoHideDelay: 10000,
            variant: 'danger',
            appendToast: true
          })
        })
      } else {
        this.tabelaPreco.options = []
      }
    },
    async atualizarDadosDoProduto(produtoId) {
      if (!produtoId) {
        this.item.PRODUTO_ID = null
        this.item.ID_UNIDADE_COMERCIAL = null
        this.item.TX_NOME_PRODUTO = null
        this.item.TX_NCM = null
        this.item.EAN = null
        this.item.OP_CONTROLA_LOTE = '0'
        this.item.OP_MATERIA_PRIMA = '0'
        return
      }

      this.$store.commit('controle/setAguardando', true)
      try {
        const result = await this.$http.get(`/api/protected/produto/getById/${produtoId}`)
        if (result) {
          this.item.TX_NOME_PRODUTO = result.data[0].DESCRICAO
          this.item.TX_NCM = result.data[0].TX_NCM
          this.item.EAN = result.data[0].EAN
          this.item.CEST = result.data[0].CEST
          this.item.ID_UNIDADE_COMERCIAL = result.data[0].ID_UNIDADE_COMERCIAL
          this.item.OP_CONTROLA_LOTE = String(result.data[0].OP_CONTROLA_LOTE || '0').trim()
          this.item.OP_MATERIA_PRIMA = String(result.data[0].OP_MATERIA_PRIMA || '0').trim()

          if (result.data[0].PROSERV == 'P') {
            this.item.OP_COMPOE_VALOR_NFE = '1'
          }
          else {
            this.item.OP_COMPOE_VALOR_NFE = '0'
          }
        }
      } catch (err) {
        this.toastCount++
        this.$root.$bvToast.toast(`Não foi Possível atualizar os dados do Produto!! \n` + err, {
          title: 'Erro',
          autoHideDelay: 10000,
          variant: 'danger',
          appendToast: true
        })
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    onSelecionarProdutoItem(produtoId) {
      this.item.PRODUTO_ID = produtoId
      this.atualizarDadosDoProduto(produtoId)
    },
    handleKeydown(event) {
      const key = event.key.toLowerCase()
      const modalAberto = this.$refs.modalItem?.isShow === true

      if (key === "insert" && !modalAberto) {
        this.$refs.btAdicionarItem?.click()
      } else if (key === "f9" && !modalAberto) {
        this.tabIndex = 0
      } else if (key === "f10" && !modalAberto) {
        this.tabIndex = 1
      } else if (event.altKey) {
        switch (key) {
          case "1": this.tabIndexItem = 0; this.focusTabProduto(); break
          case "2": this.tabIndexItem = 1; this.focusTabPesagem(); break
          case "3": this.tabIndexItem = 2; break
          case "4": this.tabIndexItem = 3; break
          case "5": this.tabIndexItem = 4; break
          case "6": this.tabIndexItem = 5; break
          case "g":
            if (modalAberto) {
              this.controles.itemAlteracao ? this.editItem() : this.postItem()
            }
            break
          case "v":
            if (!modalAberto) {
              this.voltar()
            }
            break
        }
      } else if (key === "escape" && modalAberto) {
        this.$refs.modalItem?.hide()
      }
    }

    
    
    
  },  
  async created () {
    try {
      this.controles.montagemTelaConcluida = false
      try {
        this.$store.commit('controle/setAguardando', true)
        let id = this.$route.params.id
        
        this.parametros =  await this.carregarParametros()
        
        if (!this.parametros) {
          throw new Error(`Os parametros do Sistema não foram carregados!!`)
        }

        if (this.parametros.OP_VENDA_PRECO_POR_TABELA === 'T' ) {
          this.precoTabelado = true
        } else {
          this.precoTabelado = false
        }
        
        try {
          await this.carregarEmpresas()
        } catch (err) {
          console.log(err)
        }

        try {
          await this.carregarListaEstoque()
        } catch (err) {
          throw new Error(err.message || err)
        }

        
        this.gerarComboParcelas()
        this.gerarDias()
        
        //VENDA EM ALTERACAO
        if ( id ) {
          try {
            await this.getCompra(id)
          } catch(err) {
            this.controles.falhaNaAbertura = true // pra deixar tudo fechado
            console.log(err)
            throw err 
          }


          this.ajustarCamposTabelaPrincipal()
          
          
          try {
            await this.getItens(this.compra.ID)
          } catch (err) {
            console.log(err)
            throw err
          }
          try {
            await this.getParcelamento()
          } catch (err) {
            throw new Error(`O parcelamento da Venda/Prefatura, não foi encontrado!!`)
          }
          
          //0 - NAO SOLICITADO
          //1 - CONF ABERTA
          //2 - EM CONFERENCIA
          //3 - CONFERIDO
          if (['1','2','3'].includes(this.compra.OP_RECEPCAO)) {
            try {
              await this.getConferencia(this.compra.ID)
            } catch (err) {
              console.log(err)
              throw err
            }
          }
          
          try {
            await this.getDespesas(this.compra.ID)
          } catch (err) {
            console.log(err)
            throw err
          }
          
          this.compraIdEditar = id

          //Controla se o form esta em alteracao
          this.controles.compraAlteracao = true

          //Controla se o usuario clicou no botao reabrir
          this.controles.compraReaberta = false
         
        } 
        // NOVA VENDA
        else { 
          
          this.limparCompra()
          this.compra.ID                   = 0
          this.compra.OP_FINANCEIRO        = '0'
          this.compra.OP_CARGA_XML         = '0'
          
          this.compra.OP_STATUS            = '1' //Em Cadastro
          this.compra.OP_TIPO_PEDIDO       = 'I'
          this.compra.OP_INCOTERMS         = 'FOB'
          this.compra.OP_XML                    = '0' //Não Vinculada
          this.compra.OP_CONCLUIR_SEM_NOTA      = '0'// não setado
          this.compra.OP_RECEPCAO               = '0' //Não Vinculada
          this.compra.OP_CONCLUIR_SEM_RECEPCAO  = '0'
          
          this.compra.VL_ICMS              = this.parametros.VL_ICMS_PEDIDO
          this.compra.VL_PIS               = this.parametros.VL_PIS_PEDIDO
          this.compra.VL_COFINS            = this.parametros.VL_COFINS_PEDIDO
          this.compra.VL_DESCONTO_IMPOSTO  = this.parametros.VL_DESCONTO_PEDIDO
          this.compra.VL_OUTROS            = this.parametros.VL_OUTROS_IMPOSTOS_PEDIDO
          this.compra.OP_PARCELAMENTO       = '0';
          this.compra.OP_FORMA_PAGAMENTO    = '00';
          this.compra.DT_CHEGADA_NECESSARIA = Tools.formatarDataParaInput(Tools.getDataAtual())
          this.compra.DT_CADASTRO           = Tools.formatarDataParaInput(Tools.getDataAtual())
          this.compra.DT_PEDIDO             = Tools.formatarDataParaInput(Tools.getDataAtual())
          this.compra.TX_USUARIO_INC        = window.localStorage.getItem('login')
          this.compra.OP_FINANCEIRO         = '0'
          this.compra.OP_GERA_ESTOQUE       = 'S'
          this.compra.VL_TOTAL_DESCONTO         = 0.00
          this.compra.NR_PESO_BRUTO             = 0.00
          this.compra.NR_PESO_LIQUIDO           = 0.00

          this.compraIdEditar = null
          this.controles.compraAlteracao = false
          this.controles.compraReaberta = false
          
          // ⏳ Delay para garantir que o DOM e refs estejam prontos
          setTimeout(() => {
            try {
              document.addEventListener("keydown", this.handleKeydown)

              const campoCliente = this.$refs.edFORNECEDOR_ID?.$refs?.auto?.$refs?.autocomplete
              if (campoCliente && typeof campoCliente.focus === 'function') {
                campoCliente.focus()
              } else {
                console.warn('Campo cliente-pesquisa não encontrado para foco')
              }
            } catch (err) {
              console.error('Erro ao tentar focar o campo cliente-pesquisa:', err)
            }
          }, 200)
          


        }
      } catch (err) {
        console.log(err)
        await Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        this.$router.go(-1)
        return
      }
    } finally {
      this.controles.montagemTelaConcluida = true
      this.$store.commit('controle/setAguardando', false)
    }
  },
  mounted (){
    let id = this.$route.params.id
    if ( id == null  ) {
      this.$refs.ob_edDocumento.focus()
    }

    // Adiciona o evento de keydown ao document
    setTimeout(() => {
      document.addEventListener("keydown", this.handleKeydown)
    }, 200)
  },
  beforeDestroy() {
    // Remove o evento de keydown ao destruir o componente
    document.removeEventListener("keydown", this.handleKeydown)
  },

  watch: {
    tabIndexItem(newIndex) {
      // Verifica se a aba de pesagem foi ativada (índice 1, ajustável)
      switch (newIndex) {
        case 0: //Aba dos dados do Produto
        this.$nextTick(() => {
            this.focusModalItem()
          })
          break;
        case 1:  // Supondo que a aba de Pesagem é a segunda aba (índice 1)
          this.$nextTick(() => {
            this.focusTabPesagem()
          })
          break;
        default:
          break;
      }
    },
    //'item.PRODUTO_ID': async function () {    },
    'item.NR_PESO_LIQUIDO': function(){
      this.somarTotalItem()
      //if (!this.controles.montandoItem) {this.calculaICMSeIPIGeral()}
    },
    'item.VL_UNITARIO_FOB': function(){
      this.somarTotalItem()
      //if (!this.controles.montandoItem) {this.calculaICMSeIPIGeral()}
    },
    'compra.OP_TIPO_PEDIDO': async function (newValue, oldValue) {
      // Não limpa durante carregamento inicial dos dados
      if (this.controles.carregandoDados) {
        return
      }
      
      if (newValue === 'I') {
        this.compra.OP_GERA_ESTOQUE = 'S'
      }
      // Limpa o centro de estoque apenas quando usuário muda manualmente
      if (oldValue !== undefined && oldValue !== null) {
        this.compra.CENTRO_ESTOQUE_ID = null
      }
    },
    'compra.OP_GERA_ESTOQUE': function (newValue, oldValue) {
      // Não limpa durante carregamento inicial dos dados
      if (this.controles.carregandoDados) {
        return
      }
      
      // Limpa o centro de estoque apenas quando usuário muda manualmente
      if (newValue === 'N' && oldValue !== undefined && oldValue !== null) {
        this.compra.CENTRO_ESTOQUE_ID = null
      }
    },
  }
  
}

</script>
<style scope>
.prepend-label-fixo {
  width: 140px;        /* ou min-width se quiser permitir expansão */
  justify-content: flex-end;
}

input[type="date"].vazio:not(:focus)::-webkit-datetime-edit {
  color: transparent;
  caret-color: transparent;
}

.modern-premium-card {
  border: none;
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.modern-premium-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
}

.card-header-premium {
  background: transparent;
  border-bottom: 1px solid rgba(0,0,0,0.05);
  padding: 1.25rem;
}

.modal-header-premium {
  border-bottom: none;
}

.bg-white-20 {
  background: rgba(255, 255, 255, 0.2);
}

.stat-item {
  padding: 0.5rem 1rem;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.5);
  min-width: 120px;
}

.modern-tabs >>> .nav-pills .nav-link {
  border-radius: 50px;
  padding: 0.6rem 1.5rem;
  font-weight: 600;
  color: #6c757d;
  transition: all 0.3s ease;
  border: 1px solid transparent;
  margin-right: 0.5rem;
}

.modern-tabs >>> .nav-pills .nav-link.active {
  background: #20a8d8;
  color: white;
  box-shadow: 0 4px 12px rgba(32, 168, 216, 0.3);
}

.modern-tabs >>> .nav-pills .nav-link:hover:not(.active) {
  background: rgba(32, 168, 216, 0.1);
  color: #20a8d8;
}

.modern-table {
  border-radius: 12px;
  overflow: hidden;
  border: none;
}

.modern-table thead th {
  background: #f8f9fa;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #edf2f7;
  padding: 1rem;
}

.modern-table tbody td {
  padding: 1rem;
  vertical-align: middle;
  border-bottom: 1px solid #edf2f7;
}

.modal-label-premium {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #4a5568;
  margin-bottom: 0.5rem;
  display: block;
  letter-spacing: 0.5px;
}

.modern-textarea {
  border-radius: 15px;
  border: 1px solid #e2e8f0;
  padding: 1rem;
  transition: all 0.3s ease;
}

.modern-textarea:focus {
  border-color: #20a8d8;
  box-shadow: 0 0 0 3px rgba(32, 168, 216, 0.1);
}

.btn-glass {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  transition: all 0.3s ease;
}

.btn-glass:hover {
  background: rgba(255, 255, 255, 0.3);
  color: white;
  transform: translateY(-2px);
}

.alert-soft-warning {
  background-color: #fffaf0;
  color: #9c4221;
  border: 1px solid #feebc8;
}

.alert-soft-info {
  background-color: #ebf8ff;
  color: #2b6cb0;
  border: 1px solid #bee3f8;
}

.bg-soft-info { background-color: rgba(32, 168, 216, 0.1) !important; color: #20a8d8 !important; }
.bg-soft-success { background-color: rgba(77, 189, 116, 0.1) !important; color: #4dbd74 !important; }
.bg-soft-danger { background-color: rgba(248, 108, 107, 0.1) !important; color: #f86c6b !important; }
.bg-soft-warning { background-color: rgba(255, 193, 7, 0.1) !important; color: #ffc107 !important; }

.btn-soft-info {
  background: rgba(32, 168, 216, 0.1);
  color: #20a8d8;
  border: none;
  transition: all 0.2s;
}

.btn-soft-info:hover {
  background: #20a8d8;
  color: white;
}

.btn-soft-danger {
  background: rgba(248, 108, 107, 0.1);
  color: #f86c6b;
  border: none;
  transition: all 0.2s;
}

.btn-soft-danger:hover {
  background: #f86c6b;
  color: white;
}

.header-icon-wrapper-modal {
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(4px);
}

.header-icon-wrapper-modal i {
  font-size: 1.5rem;
}

.modal-custom-width {
  width: 90% !important;
  max-width: 1300px;
}

.table.b-table tbody tr.cec-row-selected,
.table.b-table tbody tr.cec-row-selected > td {
  background-color: #1f3b63 !important;
  color: #fff !important;
}

.table-conciliacao-wrapper .b-table-sticky-header {
  overflow-y: auto !important;
  overflow-x: visible !important;
  min-height: 500px;
}

.table-conciliacao-wrapper thead th {
  background-color: #f1f4f7 !important;
  position: sticky;
  top: 0;
  z-index: 2;
}

.table-conciliacao-wrapper td {
  overflow: visible !important;
}

.bg-soft-success { background-color: rgba(34, 197, 94, 0.1); }
.bg-soft-info { background-color: rgba(14, 165, 233, 0.1); }
.bg-soft-primary { background-color: rgba(59, 130, 246, 0.1); }
.bg-soft-secondary { background-color: rgba(107, 114, 128, 0.1); }

.shadow-xs {
  box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important;
}

.modal-footer-premium {
  border-top: 1px solid #edf2f7;
}
</style>



// WEBPACK FOOTER //
// src/views/movimentos/compras/ComprasCadastro.vue